var recipe_groups = [
  [
    {
      "output": "block.minecraft.acacia_button",
      "size": 1,
      "ingredients": [
        [
          "block.minecraft.acacia_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.bamboo_button",
      "size": 1,
      "ingredients": [
        [
          "block.minecraft.bamboo_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.birch_button",
      "size": 1,
      "ingredients": [
        [
          "block.minecraft.birch_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.cherry_button",
      "size": 1,
      "ingredients": [
        [
          "block.minecraft.cherry_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.crimson_button",
      "size": 1,
      "ingredients": [
        [
          "block.minecraft.crimson_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.dark_oak_button",
      "size": 1,
      "ingredients": [
        [
          "block.minecraft.dark_oak_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.jungle_button",
      "size": 1,
      "ingredients": [
        [
          "block.minecraft.jungle_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.mangrove_button",
      "size": 1,
      "ingredients": [
        [
          "block.minecraft.mangrove_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.oak_button",
      "size": 1,
      "ingredients": [
        [
          "block.minecraft.oak_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.pale_oak_button",
      "size": 1,
      "ingredients": [
        [
          "block.minecraft.pale_oak_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.spruce_button",
      "size": 1,
      "ingredients": [
        [
          "block.minecraft.spruce_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.warped_button",
      "size": 1,
      "ingredients": [
        [
          "block.minecraft.warped_planks"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.acacia_door",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.acacia_planks"
        ],
        [
          "block.minecraft.acacia_planks"
        ],
        [
          "block.minecraft.acacia_planks"
        ],
        [
          "block.minecraft.acacia_planks"
        ],
        [
          "block.minecraft.acacia_planks"
        ],
        [
          "block.minecraft.acacia_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.bamboo_door",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.bamboo_planks"
        ],
        [
          "block.minecraft.bamboo_planks"
        ],
        [
          "block.minecraft.bamboo_planks"
        ],
        [
          "block.minecraft.bamboo_planks"
        ],
        [
          "block.minecraft.bamboo_planks"
        ],
        [
          "block.minecraft.bamboo_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.birch_door",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.birch_planks"
        ],
        [
          "block.minecraft.birch_planks"
        ],
        [
          "block.minecraft.birch_planks"
        ],
        [
          "block.minecraft.birch_planks"
        ],
        [
          "block.minecraft.birch_planks"
        ],
        [
          "block.minecraft.birch_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.cherry_door",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.cherry_planks"
        ],
        [
          "block.minecraft.cherry_planks"
        ],
        [
          "block.minecraft.cherry_planks"
        ],
        [
          "block.minecraft.cherry_planks"
        ],
        [
          "block.minecraft.cherry_planks"
        ],
        [
          "block.minecraft.cherry_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.crimson_door",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.crimson_planks"
        ],
        [
          "block.minecraft.crimson_planks"
        ],
        [
          "block.minecraft.crimson_planks"
        ],
        [
          "block.minecraft.crimson_planks"
        ],
        [
          "block.minecraft.crimson_planks"
        ],
        [
          "block.minecraft.crimson_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.dark_oak_door",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.dark_oak_planks"
        ],
        [
          "block.minecraft.dark_oak_planks"
        ],
        [
          "block.minecraft.dark_oak_planks"
        ],
        [
          "block.minecraft.dark_oak_planks"
        ],
        [
          "block.minecraft.dark_oak_planks"
        ],
        [
          "block.minecraft.dark_oak_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.jungle_door",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.jungle_planks"
        ],
        [
          "block.minecraft.jungle_planks"
        ],
        [
          "block.minecraft.jungle_planks"
        ],
        [
          "block.minecraft.jungle_planks"
        ],
        [
          "block.minecraft.jungle_planks"
        ],
        [
          "block.minecraft.jungle_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.mangrove_door",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.mangrove_planks"
        ],
        [
          "block.minecraft.mangrove_planks"
        ],
        [
          "block.minecraft.mangrove_planks"
        ],
        [
          "block.minecraft.mangrove_planks"
        ],
        [
          "block.minecraft.mangrove_planks"
        ],
        [
          "block.minecraft.mangrove_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.oak_door",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.oak_planks"
        ],
        [
          "block.minecraft.oak_planks"
        ],
        [
          "block.minecraft.oak_planks"
        ],
        [
          "block.minecraft.oak_planks"
        ],
        [
          "block.minecraft.oak_planks"
        ],
        [
          "block.minecraft.oak_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.pale_oak_door",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.pale_oak_planks"
        ],
        [
          "block.minecraft.pale_oak_planks"
        ],
        [
          "block.minecraft.pale_oak_planks"
        ],
        [
          "block.minecraft.pale_oak_planks"
        ],
        [
          "block.minecraft.pale_oak_planks"
        ],
        [
          "block.minecraft.pale_oak_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.spruce_door",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.spruce_planks"
        ],
        [
          "block.minecraft.spruce_planks"
        ],
        [
          "block.minecraft.spruce_planks"
        ],
        [
          "block.minecraft.spruce_planks"
        ],
        [
          "block.minecraft.spruce_planks"
        ],
        [
          "block.minecraft.spruce_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.warped_door",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.warped_planks"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.acacia_fence",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.acacia_planks"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "block.minecraft.acacia_planks"
        ],
        [
          "block.minecraft.acacia_planks"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "block.minecraft.acacia_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.bamboo_fence",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.bamboo_planks"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "block.minecraft.bamboo_planks"
        ],
        [
          "block.minecraft.bamboo_planks"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "block.minecraft.bamboo_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.birch_fence",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.birch_planks"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "block.minecraft.birch_planks"
        ],
        [
          "block.minecraft.birch_planks"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "block.minecraft.birch_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.cherry_fence",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.cherry_planks"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "block.minecraft.cherry_planks"
        ],
        [
          "block.minecraft.cherry_planks"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "block.minecraft.cherry_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.crimson_fence",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.crimson_planks"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "block.minecraft.crimson_planks"
        ],
        [
          "block.minecraft.crimson_planks"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "block.minecraft.crimson_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.dark_oak_fence",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.dark_oak_planks"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "block.minecraft.dark_oak_planks"
        ],
        [
          "block.minecraft.dark_oak_planks"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "block.minecraft.dark_oak_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.jungle_fence",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.jungle_planks"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "block.minecraft.jungle_planks"
        ],
        [
          "block.minecraft.jungle_planks"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "block.minecraft.jungle_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.mangrove_fence",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.mangrove_planks"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "block.minecraft.mangrove_planks"
        ],
        [
          "block.minecraft.mangrove_planks"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "block.minecraft.mangrove_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.oak_fence",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.oak_planks"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "block.minecraft.oak_planks"
        ],
        [
          "block.minecraft.oak_planks"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "block.minecraft.oak_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.pale_oak_fence",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.pale_oak_planks"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "block.minecraft.pale_oak_planks"
        ],
        [
          "block.minecraft.pale_oak_planks"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "block.minecraft.pale_oak_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.spruce_fence",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.spruce_planks"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "block.minecraft.spruce_planks"
        ],
        [
          "block.minecraft.spruce_planks"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "block.minecraft.spruce_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.warped_fence",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.warped_planks"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.warped_planks"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "block.minecraft.warped_planks"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.acacia_fence_gate",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.stick"
        ],
        [
          "block.minecraft.acacia_planks"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "block.minecraft.acacia_planks"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    },
    {
      "output": "block.minecraft.bamboo_fence_gate",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.stick"
        ],
        [
          "block.minecraft.bamboo_planks"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "block.minecraft.bamboo_planks"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    },
    {
      "output": "block.minecraft.birch_fence_gate",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.stick"
        ],
        [
          "block.minecraft.birch_planks"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "block.minecraft.birch_planks"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    },
    {
      "output": "block.minecraft.cherry_fence_gate",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.stick"
        ],
        [
          "block.minecraft.cherry_planks"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "block.minecraft.cherry_planks"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    },
    {
      "output": "block.minecraft.crimson_fence_gate",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.stick"
        ],
        [
          "block.minecraft.crimson_planks"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "block.minecraft.crimson_planks"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    },
    {
      "output": "block.minecraft.dark_oak_fence_gate",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.stick"
        ],
        [
          "block.minecraft.dark_oak_planks"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "block.minecraft.dark_oak_planks"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    },
    {
      "output": "block.minecraft.jungle_fence_gate",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.stick"
        ],
        [
          "block.minecraft.jungle_planks"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "block.minecraft.jungle_planks"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    },
    {
      "output": "block.minecraft.mangrove_fence_gate",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.stick"
        ],
        [
          "block.minecraft.mangrove_planks"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "block.minecraft.mangrove_planks"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    },
    {
      "output": "block.minecraft.oak_fence_gate",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.stick"
        ],
        [
          "block.minecraft.oak_planks"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "block.minecraft.oak_planks"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    },
    {
      "output": "block.minecraft.pale_oak_fence_gate",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.stick"
        ],
        [
          "block.minecraft.pale_oak_planks"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "block.minecraft.pale_oak_planks"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    },
    {
      "output": "block.minecraft.spruce_fence_gate",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.stick"
        ],
        [
          "block.minecraft.spruce_planks"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "block.minecraft.spruce_planks"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    },
    {
      "output": "block.minecraft.warped_fence_gate",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.stick"
        ],
        [
          "block.minecraft.warped_planks"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "block.minecraft.warped_planks"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.acacia_hanging_sign",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.iron_chain"
        ],
        [
          "block.minecraft.iron_chain"
        ],
        [
          "block.minecraft.stripped_acacia_log"
        ],
        [
          "block.minecraft.stripped_acacia_log"
        ],
        [
          "block.minecraft.stripped_acacia_log"
        ],
        [
          "block.minecraft.stripped_acacia_log"
        ],
        [
          "block.minecraft.stripped_acacia_log"
        ],
        [
          "block.minecraft.stripped_acacia_log"
        ]
      ]
    },
    {
      "output": "block.minecraft.bamboo_hanging_sign",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.iron_chain"
        ],
        [
          "block.minecraft.iron_chain"
        ],
        [
          "block.minecraft.stripped_bamboo_block"
        ],
        [
          "block.minecraft.stripped_bamboo_block"
        ],
        [
          "block.minecraft.stripped_bamboo_block"
        ],
        [
          "block.minecraft.stripped_bamboo_block"
        ],
        [
          "block.minecraft.stripped_bamboo_block"
        ],
        [
          "block.minecraft.stripped_bamboo_block"
        ]
      ]
    },
    {
      "output": "block.minecraft.birch_hanging_sign",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.iron_chain"
        ],
        [
          "block.minecraft.iron_chain"
        ],
        [
          "block.minecraft.stripped_birch_log"
        ],
        [
          "block.minecraft.stripped_birch_log"
        ],
        [
          "block.minecraft.stripped_birch_log"
        ],
        [
          "block.minecraft.stripped_birch_log"
        ],
        [
          "block.minecraft.stripped_birch_log"
        ],
        [
          "block.minecraft.stripped_birch_log"
        ]
      ]
    },
    {
      "output": "block.minecraft.cherry_hanging_sign",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.iron_chain"
        ],
        [
          "block.minecraft.iron_chain"
        ],
        [
          "block.minecraft.stripped_cherry_log"
        ],
        [
          "block.minecraft.stripped_cherry_log"
        ],
        [
          "block.minecraft.stripped_cherry_log"
        ],
        [
          "block.minecraft.stripped_cherry_log"
        ],
        [
          "block.minecraft.stripped_cherry_log"
        ],
        [
          "block.minecraft.stripped_cherry_log"
        ]
      ]
    },
    {
      "output": "block.minecraft.crimson_hanging_sign",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.iron_chain"
        ],
        [
          "block.minecraft.iron_chain"
        ],
        [
          "block.minecraft.stripped_crimson_stem"
        ],
        [
          "block.minecraft.stripped_crimson_stem"
        ],
        [
          "block.minecraft.stripped_crimson_stem"
        ],
        [
          "block.minecraft.stripped_crimson_stem"
        ],
        [
          "block.minecraft.stripped_crimson_stem"
        ],
        [
          "block.minecraft.stripped_crimson_stem"
        ]
      ]
    },
    {
      "output": "block.minecraft.dark_oak_hanging_sign",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.iron_chain"
        ],
        [
          "block.minecraft.iron_chain"
        ],
        [
          "block.minecraft.stripped_dark_oak_log"
        ],
        [
          "block.minecraft.stripped_dark_oak_log"
        ],
        [
          "block.minecraft.stripped_dark_oak_log"
        ],
        [
          "block.minecraft.stripped_dark_oak_log"
        ],
        [
          "block.minecraft.stripped_dark_oak_log"
        ],
        [
          "block.minecraft.stripped_dark_oak_log"
        ]
      ]
    },
    {
      "output": "block.minecraft.jungle_hanging_sign",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.iron_chain"
        ],
        [
          "block.minecraft.iron_chain"
        ],
        [
          "block.minecraft.stripped_jungle_log"
        ],
        [
          "block.minecraft.stripped_jungle_log"
        ],
        [
          "block.minecraft.stripped_jungle_log"
        ],
        [
          "block.minecraft.stripped_jungle_log"
        ],
        [
          "block.minecraft.stripped_jungle_log"
        ],
        [
          "block.minecraft.stripped_jungle_log"
        ]
      ]
    },
    {
      "output": "block.minecraft.mangrove_hanging_sign",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.iron_chain"
        ],
        [
          "block.minecraft.iron_chain"
        ],
        [
          "block.minecraft.stripped_mangrove_log"
        ],
        [
          "block.minecraft.stripped_mangrove_log"
        ],
        [
          "block.minecraft.stripped_mangrove_log"
        ],
        [
          "block.minecraft.stripped_mangrove_log"
        ],
        [
          "block.minecraft.stripped_mangrove_log"
        ],
        [
          "block.minecraft.stripped_mangrove_log"
        ]
      ]
    },
    {
      "output": "block.minecraft.oak_hanging_sign",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.iron_chain"
        ],
        [
          "block.minecraft.iron_chain"
        ],
        [
          "block.minecraft.stripped_oak_log"
        ],
        [
          "block.minecraft.stripped_oak_log"
        ],
        [
          "block.minecraft.stripped_oak_log"
        ],
        [
          "block.minecraft.stripped_oak_log"
        ],
        [
          "block.minecraft.stripped_oak_log"
        ],
        [
          "block.minecraft.stripped_oak_log"
        ]
      ]
    },
    {
      "output": "block.minecraft.pale_oak_hanging_sign",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.iron_chain"
        ],
        [
          "block.minecraft.iron_chain"
        ],
        [
          "block.minecraft.stripped_pale_oak_log"
        ],
        [
          "block.minecraft.stripped_pale_oak_log"
        ],
        [
          "block.minecraft.stripped_pale_oak_log"
        ],
        [
          "block.minecraft.stripped_pale_oak_log"
        ],
        [
          "block.minecraft.stripped_pale_oak_log"
        ],
        [
          "block.minecraft.stripped_pale_oak_log"
        ]
      ]
    },
    {
      "output": "block.minecraft.spruce_hanging_sign",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.iron_chain"
        ],
        [
          "block.minecraft.iron_chain"
        ],
        [
          "block.minecraft.stripped_spruce_log"
        ],
        [
          "block.minecraft.stripped_spruce_log"
        ],
        [
          "block.minecraft.stripped_spruce_log"
        ],
        [
          "block.minecraft.stripped_spruce_log"
        ],
        [
          "block.minecraft.stripped_spruce_log"
        ],
        [
          "block.minecraft.stripped_spruce_log"
        ]
      ]
    },
    {
      "output": "block.minecraft.warped_hanging_sign",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.iron_chain"
        ],
        [
          "block.minecraft.iron_chain"
        ],
        [
          "block.minecraft.stripped_warped_stem"
        ],
        [
          "block.minecraft.stripped_warped_stem"
        ],
        [
          "block.minecraft.stripped_warped_stem"
        ],
        [
          "block.minecraft.stripped_warped_stem"
        ],
        [
          "block.minecraft.stripped_warped_stem"
        ],
        [
          "block.minecraft.stripped_warped_stem"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.acacia_planks",
      "size": 1,
      "ingredients": [
        [
          "block.minecraft.acacia_log",
          "block.minecraft.acacia_wood",
          "block.minecraft.stripped_acacia_log",
          "block.minecraft.stripped_acacia_wood"
        ]
      ]
    },
    {
      "output": "block.minecraft.bamboo_planks",
      "size": 1,
      "ingredients": [
        [
          "block.minecraft.bamboo_block",
          "block.minecraft.stripped_bamboo_block"
        ]
      ]
    },
    {
      "output": "block.minecraft.birch_planks",
      "size": 1,
      "ingredients": [
        [
          "block.minecraft.birch_log",
          "block.minecraft.birch_wood",
          "block.minecraft.stripped_birch_log",
          "block.minecraft.stripped_birch_wood"
        ]
      ]
    },
    {
      "output": "block.minecraft.cherry_planks",
      "size": 1,
      "ingredients": [
        [
          "block.minecraft.cherry_log",
          "block.minecraft.cherry_wood",
          "block.minecraft.stripped_cherry_log",
          "block.minecraft.stripped_cherry_wood"
        ]
      ]
    },
    {
      "output": "block.minecraft.crimson_planks",
      "size": 1,
      "ingredients": [
        [
          "block.minecraft.crimson_hyphae",
          "block.minecraft.crimson_stem",
          "block.minecraft.stripped_crimson_hyphae",
          "block.minecraft.stripped_crimson_stem"
        ]
      ]
    },
    {
      "output": "block.minecraft.dark_oak_planks",
      "size": 1,
      "ingredients": [
        [
          "block.minecraft.dark_oak_log",
          "block.minecraft.dark_oak_wood",
          "block.minecraft.stripped_dark_oak_log",
          "block.minecraft.stripped_dark_oak_wood"
        ]
      ]
    },
    {
      "output": "block.minecraft.jungle_planks",
      "size": 1,
      "ingredients": [
        [
          "block.minecraft.jungle_log",
          "block.minecraft.jungle_wood",
          "block.minecraft.stripped_jungle_log",
          "block.minecraft.stripped_jungle_wood"
        ]
      ]
    },
    {
      "output": "block.minecraft.mangrove_planks",
      "size": 1,
      "ingredients": [
        [
          "block.minecraft.mangrove_log",
          "block.minecraft.mangrove_wood",
          "block.minecraft.stripped_mangrove_log",
          "block.minecraft.stripped_mangrove_wood"
        ]
      ]
    },
    {
      "output": "block.minecraft.oak_planks",
      "size": 1,
      "ingredients": [
        [
          "block.minecraft.oak_log",
          "block.minecraft.oak_wood",
          "block.minecraft.stripped_oak_log",
          "block.minecraft.stripped_oak_wood"
        ]
      ]
    },
    {
      "output": "block.minecraft.pale_oak_planks",
      "size": 1,
      "ingredients": [
        [
          "block.minecraft.pale_oak_log",
          "block.minecraft.pale_oak_wood",
          "block.minecraft.stripped_pale_oak_log",
          "block.minecraft.stripped_pale_oak_wood"
        ]
      ]
    },
    {
      "output": "block.minecraft.spruce_planks",
      "size": 1,
      "ingredients": [
        [
          "block.minecraft.spruce_log",
          "block.minecraft.spruce_wood",
          "block.minecraft.stripped_spruce_log",
          "block.minecraft.stripped_spruce_wood"
        ]
      ]
    },
    {
      "output": "block.minecraft.warped_planks",
      "size": 1,
      "ingredients": [
        [
          "block.minecraft.stripped_warped_hyphae",
          "block.minecraft.stripped_warped_stem",
          "block.minecraft.warped_hyphae",
          "block.minecraft.warped_stem"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.acacia_pressure_plate",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.acacia_planks"
        ],
        [
          "block.minecraft.acacia_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.bamboo_pressure_plate",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.bamboo_planks"
        ],
        [
          "block.minecraft.bamboo_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.birch_pressure_plate",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.birch_planks"
        ],
        [
          "block.minecraft.birch_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.cherry_pressure_plate",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.cherry_planks"
        ],
        [
          "block.minecraft.cherry_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.crimson_pressure_plate",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.crimson_planks"
        ],
        [
          "block.minecraft.crimson_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.dark_oak_pressure_plate",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.dark_oak_planks"
        ],
        [
          "block.minecraft.dark_oak_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.jungle_pressure_plate",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.jungle_planks"
        ],
        [
          "block.minecraft.jungle_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.mangrove_pressure_plate",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.mangrove_planks"
        ],
        [
          "block.minecraft.mangrove_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.oak_pressure_plate",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.oak_planks"
        ],
        [
          "block.minecraft.oak_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.pale_oak_pressure_plate",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.pale_oak_planks"
        ],
        [
          "block.minecraft.pale_oak_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.spruce_pressure_plate",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.spruce_planks"
        ],
        [
          "block.minecraft.spruce_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.warped_pressure_plate",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.warped_planks"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.acacia_shelf",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.stripped_acacia_log"
        ],
        [
          "block.minecraft.stripped_acacia_log"
        ],
        [
          "block.minecraft.stripped_acacia_log"
        ],
        [
          "block.minecraft.stripped_acacia_log"
        ],
        [
          "block.minecraft.stripped_acacia_log"
        ],
        [
          "block.minecraft.stripped_acacia_log"
        ]
      ]
    },
    {
      "output": "block.minecraft.bamboo_shelf",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.stripped_bamboo_block"
        ],
        [
          "block.minecraft.stripped_bamboo_block"
        ],
        [
          "block.minecraft.stripped_bamboo_block"
        ],
        [
          "block.minecraft.stripped_bamboo_block"
        ],
        [
          "block.minecraft.stripped_bamboo_block"
        ],
        [
          "block.minecraft.stripped_bamboo_block"
        ]
      ]
    },
    {
      "output": "block.minecraft.birch_shelf",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.stripped_birch_log"
        ],
        [
          "block.minecraft.stripped_birch_log"
        ],
        [
          "block.minecraft.stripped_birch_log"
        ],
        [
          "block.minecraft.stripped_birch_log"
        ],
        [
          "block.minecraft.stripped_birch_log"
        ],
        [
          "block.minecraft.stripped_birch_log"
        ]
      ]
    },
    {
      "output": "block.minecraft.cherry_shelf",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.stripped_cherry_log"
        ],
        [
          "block.minecraft.stripped_cherry_log"
        ],
        [
          "block.minecraft.stripped_cherry_log"
        ],
        [
          "block.minecraft.stripped_cherry_log"
        ],
        [
          "block.minecraft.stripped_cherry_log"
        ],
        [
          "block.minecraft.stripped_cherry_log"
        ]
      ]
    },
    {
      "output": "block.minecraft.crimson_shelf",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.stripped_crimson_stem"
        ],
        [
          "block.minecraft.stripped_crimson_stem"
        ],
        [
          "block.minecraft.stripped_crimson_stem"
        ],
        [
          "block.minecraft.stripped_crimson_stem"
        ],
        [
          "block.minecraft.stripped_crimson_stem"
        ],
        [
          "block.minecraft.stripped_crimson_stem"
        ]
      ]
    },
    {
      "output": "block.minecraft.dark_oak_shelf",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.stripped_dark_oak_log"
        ],
        [
          "block.minecraft.stripped_dark_oak_log"
        ],
        [
          "block.minecraft.stripped_dark_oak_log"
        ],
        [
          "block.minecraft.stripped_dark_oak_log"
        ],
        [
          "block.minecraft.stripped_dark_oak_log"
        ],
        [
          "block.minecraft.stripped_dark_oak_log"
        ]
      ]
    },
    {
      "output": "block.minecraft.jungle_shelf",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.stripped_jungle_log"
        ],
        [
          "block.minecraft.stripped_jungle_log"
        ],
        [
          "block.minecraft.stripped_jungle_log"
        ],
        [
          "block.minecraft.stripped_jungle_log"
        ],
        [
          "block.minecraft.stripped_jungle_log"
        ],
        [
          "block.minecraft.stripped_jungle_log"
        ]
      ]
    },
    {
      "output": "block.minecraft.mangrove_shelf",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.stripped_mangrove_log"
        ],
        [
          "block.minecraft.stripped_mangrove_log"
        ],
        [
          "block.minecraft.stripped_mangrove_log"
        ],
        [
          "block.minecraft.stripped_mangrove_log"
        ],
        [
          "block.minecraft.stripped_mangrove_log"
        ],
        [
          "block.minecraft.stripped_mangrove_log"
        ]
      ]
    },
    {
      "output": "block.minecraft.oak_shelf",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.stripped_oak_log"
        ],
        [
          "block.minecraft.stripped_oak_log"
        ],
        [
          "block.minecraft.stripped_oak_log"
        ],
        [
          "block.minecraft.stripped_oak_log"
        ],
        [
          "block.minecraft.stripped_oak_log"
        ],
        [
          "block.minecraft.stripped_oak_log"
        ]
      ]
    },
    {
      "output": "block.minecraft.pale_oak_shelf",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.stripped_pale_oak_log"
        ],
        [
          "block.minecraft.stripped_pale_oak_log"
        ],
        [
          "block.minecraft.stripped_pale_oak_log"
        ],
        [
          "block.minecraft.stripped_pale_oak_log"
        ],
        [
          "block.minecraft.stripped_pale_oak_log"
        ],
        [
          "block.minecraft.stripped_pale_oak_log"
        ]
      ]
    },
    {
      "output": "block.minecraft.spruce_shelf",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.stripped_spruce_log"
        ],
        [
          "block.minecraft.stripped_spruce_log"
        ],
        [
          "block.minecraft.stripped_spruce_log"
        ],
        [
          "block.minecraft.stripped_spruce_log"
        ],
        [
          "block.minecraft.stripped_spruce_log"
        ],
        [
          "block.minecraft.stripped_spruce_log"
        ]
      ]
    },
    {
      "output": "block.minecraft.warped_shelf",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.stripped_warped_stem"
        ],
        [
          "block.minecraft.stripped_warped_stem"
        ],
        [
          "block.minecraft.stripped_warped_stem"
        ],
        [
          "block.minecraft.stripped_warped_stem"
        ],
        [
          "block.minecraft.stripped_warped_stem"
        ],
        [
          "block.minecraft.stripped_warped_stem"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.acacia_sign",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.acacia_planks"
        ],
        [
          "block.minecraft.acacia_planks"
        ],
        [
          "block.minecraft.acacia_planks"
        ],
        [
          "block.minecraft.acacia_planks"
        ],
        [
          "block.minecraft.acacia_planks"
        ],
        [
          "block.minecraft.acacia_planks"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    },
    {
      "output": "block.minecraft.bamboo_sign",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.bamboo_planks"
        ],
        [
          "block.minecraft.bamboo_planks"
        ],
        [
          "block.minecraft.bamboo_planks"
        ],
        [
          "block.minecraft.bamboo_planks"
        ],
        [
          "block.minecraft.bamboo_planks"
        ],
        [
          "block.minecraft.bamboo_planks"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    },
    {
      "output": "block.minecraft.birch_sign",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.birch_planks"
        ],
        [
          "block.minecraft.birch_planks"
        ],
        [
          "block.minecraft.birch_planks"
        ],
        [
          "block.minecraft.birch_planks"
        ],
        [
          "block.minecraft.birch_planks"
        ],
        [
          "block.minecraft.birch_planks"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    },
    {
      "output": "block.minecraft.cherry_sign",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.cherry_planks"
        ],
        [
          "block.minecraft.cherry_planks"
        ],
        [
          "block.minecraft.cherry_planks"
        ],
        [
          "block.minecraft.cherry_planks"
        ],
        [
          "block.minecraft.cherry_planks"
        ],
        [
          "block.minecraft.cherry_planks"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    },
    {
      "output": "block.minecraft.crimson_sign",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.crimson_planks"
        ],
        [
          "block.minecraft.crimson_planks"
        ],
        [
          "block.minecraft.crimson_planks"
        ],
        [
          "block.minecraft.crimson_planks"
        ],
        [
          "block.minecraft.crimson_planks"
        ],
        [
          "block.minecraft.crimson_planks"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    },
    {
      "output": "block.minecraft.dark_oak_sign",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.dark_oak_planks"
        ],
        [
          "block.minecraft.dark_oak_planks"
        ],
        [
          "block.minecraft.dark_oak_planks"
        ],
        [
          "block.minecraft.dark_oak_planks"
        ],
        [
          "block.minecraft.dark_oak_planks"
        ],
        [
          "block.minecraft.dark_oak_planks"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    },
    {
      "output": "block.minecraft.jungle_sign",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.jungle_planks"
        ],
        [
          "block.minecraft.jungle_planks"
        ],
        [
          "block.minecraft.jungle_planks"
        ],
        [
          "block.minecraft.jungle_planks"
        ],
        [
          "block.minecraft.jungle_planks"
        ],
        [
          "block.minecraft.jungle_planks"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    },
    {
      "output": "block.minecraft.mangrove_sign",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.mangrove_planks"
        ],
        [
          "block.minecraft.mangrove_planks"
        ],
        [
          "block.minecraft.mangrove_planks"
        ],
        [
          "block.minecraft.mangrove_planks"
        ],
        [
          "block.minecraft.mangrove_planks"
        ],
        [
          "block.minecraft.mangrove_planks"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    },
    {
      "output": "block.minecraft.oak_sign",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.oak_planks"
        ],
        [
          "block.minecraft.oak_planks"
        ],
        [
          "block.minecraft.oak_planks"
        ],
        [
          "block.minecraft.oak_planks"
        ],
        [
          "block.minecraft.oak_planks"
        ],
        [
          "block.minecraft.oak_planks"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    },
    {
      "output": "block.minecraft.pale_oak_sign",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.pale_oak_planks"
        ],
        [
          "block.minecraft.pale_oak_planks"
        ],
        [
          "block.minecraft.pale_oak_planks"
        ],
        [
          "block.minecraft.pale_oak_planks"
        ],
        [
          "block.minecraft.pale_oak_planks"
        ],
        [
          "block.minecraft.pale_oak_planks"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    },
    {
      "output": "block.minecraft.spruce_sign",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.spruce_planks"
        ],
        [
          "block.minecraft.spruce_planks"
        ],
        [
          "block.minecraft.spruce_planks"
        ],
        [
          "block.minecraft.spruce_planks"
        ],
        [
          "block.minecraft.spruce_planks"
        ],
        [
          "block.minecraft.spruce_planks"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    },
    {
      "output": "block.minecraft.warped_sign",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.warped_planks"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.acacia_slab",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.acacia_planks"
        ],
        [
          "block.minecraft.acacia_planks"
        ],
        [
          "block.minecraft.acacia_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.bamboo_slab",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.bamboo_planks"
        ],
        [
          "block.minecraft.bamboo_planks"
        ],
        [
          "block.minecraft.bamboo_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.birch_slab",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.birch_planks"
        ],
        [
          "block.minecraft.birch_planks"
        ],
        [
          "block.minecraft.birch_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.cherry_slab",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.cherry_planks"
        ],
        [
          "block.minecraft.cherry_planks"
        ],
        [
          "block.minecraft.cherry_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.crimson_slab",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.crimson_planks"
        ],
        [
          "block.minecraft.crimson_planks"
        ],
        [
          "block.minecraft.crimson_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.dark_oak_slab",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.dark_oak_planks"
        ],
        [
          "block.minecraft.dark_oak_planks"
        ],
        [
          "block.minecraft.dark_oak_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.jungle_slab",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.jungle_planks"
        ],
        [
          "block.minecraft.jungle_planks"
        ],
        [
          "block.minecraft.jungle_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.mangrove_slab",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.mangrove_planks"
        ],
        [
          "block.minecraft.mangrove_planks"
        ],
        [
          "block.minecraft.mangrove_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.oak_slab",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.oak_planks"
        ],
        [
          "block.minecraft.oak_planks"
        ],
        [
          "block.minecraft.oak_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.pale_oak_slab",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.pale_oak_planks"
        ],
        [
          "block.minecraft.pale_oak_planks"
        ],
        [
          "block.minecraft.pale_oak_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.spruce_slab",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.spruce_planks"
        ],
        [
          "block.minecraft.spruce_planks"
        ],
        [
          "block.minecraft.spruce_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.warped_slab",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.warped_planks"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.acacia_stairs",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.acacia_planks"
        ],
        [
          "block.minecraft.acacia_planks"
        ],
        [
          "block.minecraft.acacia_planks"
        ],
        [
          "block.minecraft.acacia_planks"
        ],
        [
          "block.minecraft.acacia_planks"
        ],
        [
          "block.minecraft.acacia_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.bamboo_stairs",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.bamboo_planks"
        ],
        [
          "block.minecraft.bamboo_planks"
        ],
        [
          "block.minecraft.bamboo_planks"
        ],
        [
          "block.minecraft.bamboo_planks"
        ],
        [
          "block.minecraft.bamboo_planks"
        ],
        [
          "block.minecraft.bamboo_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.birch_stairs",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.birch_planks"
        ],
        [
          "block.minecraft.birch_planks"
        ],
        [
          "block.minecraft.birch_planks"
        ],
        [
          "block.minecraft.birch_planks"
        ],
        [
          "block.minecraft.birch_planks"
        ],
        [
          "block.minecraft.birch_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.cherry_stairs",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.cherry_planks"
        ],
        [
          "block.minecraft.cherry_planks"
        ],
        [
          "block.minecraft.cherry_planks"
        ],
        [
          "block.minecraft.cherry_planks"
        ],
        [
          "block.minecraft.cherry_planks"
        ],
        [
          "block.minecraft.cherry_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.crimson_stairs",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.crimson_planks"
        ],
        [
          "block.minecraft.crimson_planks"
        ],
        [
          "block.minecraft.crimson_planks"
        ],
        [
          "block.minecraft.crimson_planks"
        ],
        [
          "block.minecraft.crimson_planks"
        ],
        [
          "block.minecraft.crimson_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.dark_oak_stairs",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.dark_oak_planks"
        ],
        [
          "block.minecraft.dark_oak_planks"
        ],
        [
          "block.minecraft.dark_oak_planks"
        ],
        [
          "block.minecraft.dark_oak_planks"
        ],
        [
          "block.minecraft.dark_oak_planks"
        ],
        [
          "block.minecraft.dark_oak_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.jungle_stairs",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.jungle_planks"
        ],
        [
          "block.minecraft.jungle_planks"
        ],
        [
          "block.minecraft.jungle_planks"
        ],
        [
          "block.minecraft.jungle_planks"
        ],
        [
          "block.minecraft.jungle_planks"
        ],
        [
          "block.minecraft.jungle_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.mangrove_stairs",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.mangrove_planks"
        ],
        [
          "block.minecraft.mangrove_planks"
        ],
        [
          "block.minecraft.mangrove_planks"
        ],
        [
          "block.minecraft.mangrove_planks"
        ],
        [
          "block.minecraft.mangrove_planks"
        ],
        [
          "block.minecraft.mangrove_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.oak_stairs",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.oak_planks"
        ],
        [
          "block.minecraft.oak_planks"
        ],
        [
          "block.minecraft.oak_planks"
        ],
        [
          "block.minecraft.oak_planks"
        ],
        [
          "block.minecraft.oak_planks"
        ],
        [
          "block.minecraft.oak_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.pale_oak_stairs",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.pale_oak_planks"
        ],
        [
          "block.minecraft.pale_oak_planks"
        ],
        [
          "block.minecraft.pale_oak_planks"
        ],
        [
          "block.minecraft.pale_oak_planks"
        ],
        [
          "block.minecraft.pale_oak_planks"
        ],
        [
          "block.minecraft.pale_oak_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.spruce_stairs",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.spruce_planks"
        ],
        [
          "block.minecraft.spruce_planks"
        ],
        [
          "block.minecraft.spruce_planks"
        ],
        [
          "block.minecraft.spruce_planks"
        ],
        [
          "block.minecraft.spruce_planks"
        ],
        [
          "block.minecraft.spruce_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.warped_stairs",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.warped_planks"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.acacia_trapdoor",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.acacia_planks"
        ],
        [
          "block.minecraft.acacia_planks"
        ],
        [
          "block.minecraft.acacia_planks"
        ],
        [
          "block.minecraft.acacia_planks"
        ],
        [
          "block.minecraft.acacia_planks"
        ],
        [
          "block.minecraft.acacia_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.bamboo_trapdoor",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.bamboo_planks"
        ],
        [
          "block.minecraft.bamboo_planks"
        ],
        [
          "block.minecraft.bamboo_planks"
        ],
        [
          "block.minecraft.bamboo_planks"
        ],
        [
          "block.minecraft.bamboo_planks"
        ],
        [
          "block.minecraft.bamboo_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.birch_trapdoor",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.birch_planks"
        ],
        [
          "block.minecraft.birch_planks"
        ],
        [
          "block.minecraft.birch_planks"
        ],
        [
          "block.minecraft.birch_planks"
        ],
        [
          "block.minecraft.birch_planks"
        ],
        [
          "block.minecraft.birch_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.cherry_trapdoor",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.cherry_planks"
        ],
        [
          "block.minecraft.cherry_planks"
        ],
        [
          "block.minecraft.cherry_planks"
        ],
        [
          "block.minecraft.cherry_planks"
        ],
        [
          "block.minecraft.cherry_planks"
        ],
        [
          "block.minecraft.cherry_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.crimson_trapdoor",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.crimson_planks"
        ],
        [
          "block.minecraft.crimson_planks"
        ],
        [
          "block.minecraft.crimson_planks"
        ],
        [
          "block.minecraft.crimson_planks"
        ],
        [
          "block.minecraft.crimson_planks"
        ],
        [
          "block.minecraft.crimson_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.dark_oak_trapdoor",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.dark_oak_planks"
        ],
        [
          "block.minecraft.dark_oak_planks"
        ],
        [
          "block.minecraft.dark_oak_planks"
        ],
        [
          "block.minecraft.dark_oak_planks"
        ],
        [
          "block.minecraft.dark_oak_planks"
        ],
        [
          "block.minecraft.dark_oak_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.jungle_trapdoor",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.jungle_planks"
        ],
        [
          "block.minecraft.jungle_planks"
        ],
        [
          "block.minecraft.jungle_planks"
        ],
        [
          "block.minecraft.jungle_planks"
        ],
        [
          "block.minecraft.jungle_planks"
        ],
        [
          "block.minecraft.jungle_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.mangrove_trapdoor",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.mangrove_planks"
        ],
        [
          "block.minecraft.mangrove_planks"
        ],
        [
          "block.minecraft.mangrove_planks"
        ],
        [
          "block.minecraft.mangrove_planks"
        ],
        [
          "block.minecraft.mangrove_planks"
        ],
        [
          "block.minecraft.mangrove_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.oak_trapdoor",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.oak_planks"
        ],
        [
          "block.minecraft.oak_planks"
        ],
        [
          "block.minecraft.oak_planks"
        ],
        [
          "block.minecraft.oak_planks"
        ],
        [
          "block.minecraft.oak_planks"
        ],
        [
          "block.minecraft.oak_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.pale_oak_trapdoor",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.pale_oak_planks"
        ],
        [
          "block.minecraft.pale_oak_planks"
        ],
        [
          "block.minecraft.pale_oak_planks"
        ],
        [
          "block.minecraft.pale_oak_planks"
        ],
        [
          "block.minecraft.pale_oak_planks"
        ],
        [
          "block.minecraft.pale_oak_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.spruce_trapdoor",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.spruce_planks"
        ],
        [
          "block.minecraft.spruce_planks"
        ],
        [
          "block.minecraft.spruce_planks"
        ],
        [
          "block.minecraft.spruce_planks"
        ],
        [
          "block.minecraft.spruce_planks"
        ],
        [
          "block.minecraft.spruce_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.warped_trapdoor",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.warped_planks"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.acacia_wood",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.acacia_log"
        ],
        [
          "block.minecraft.acacia_log"
        ],
        [
          "block.minecraft.acacia_log"
        ],
        [
          "block.minecraft.acacia_log"
        ]
      ]
    },
    {
      "output": "block.minecraft.birch_wood",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.birch_log"
        ],
        [
          "block.minecraft.birch_log"
        ],
        [
          "block.minecraft.birch_log"
        ],
        [
          "block.minecraft.birch_log"
        ]
      ]
    },
    {
      "output": "block.minecraft.cherry_wood",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.cherry_log"
        ],
        [
          "block.minecraft.cherry_log"
        ],
        [
          "block.minecraft.cherry_log"
        ],
        [
          "block.minecraft.cherry_log"
        ]
      ]
    },
    {
      "output": "block.minecraft.crimson_hyphae",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.crimson_stem"
        ],
        [
          "block.minecraft.crimson_stem"
        ],
        [
          "block.minecraft.crimson_stem"
        ],
        [
          "block.minecraft.crimson_stem"
        ]
      ]
    },
    {
      "output": "block.minecraft.dark_oak_wood",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.dark_oak_log"
        ],
        [
          "block.minecraft.dark_oak_log"
        ],
        [
          "block.minecraft.dark_oak_log"
        ],
        [
          "block.minecraft.dark_oak_log"
        ]
      ]
    },
    {
      "output": "block.minecraft.jungle_wood",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.jungle_log"
        ],
        [
          "block.minecraft.jungle_log"
        ],
        [
          "block.minecraft.jungle_log"
        ],
        [
          "block.minecraft.jungle_log"
        ]
      ]
    },
    {
      "output": "block.minecraft.mangrove_wood",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.mangrove_log"
        ],
        [
          "block.minecraft.mangrove_log"
        ],
        [
          "block.minecraft.mangrove_log"
        ],
        [
          "block.minecraft.mangrove_log"
        ]
      ]
    },
    {
      "output": "block.minecraft.oak_wood",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.oak_log"
        ],
        [
          "block.minecraft.oak_log"
        ],
        [
          "block.minecraft.oak_log"
        ],
        [
          "block.minecraft.oak_log"
        ]
      ]
    },
    {
      "output": "block.minecraft.pale_oak_wood",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.pale_oak_log"
        ],
        [
          "block.minecraft.pale_oak_log"
        ],
        [
          "block.minecraft.pale_oak_log"
        ],
        [
          "block.minecraft.pale_oak_log"
        ]
      ]
    },
    {
      "output": "block.minecraft.spruce_wood",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.spruce_log"
        ],
        [
          "block.minecraft.spruce_log"
        ],
        [
          "block.minecraft.spruce_log"
        ],
        [
          "block.minecraft.spruce_log"
        ]
      ]
    },
    {
      "output": "block.minecraft.stripped_acacia_wood",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.stripped_acacia_log"
        ],
        [
          "block.minecraft.stripped_acacia_log"
        ],
        [
          "block.minecraft.stripped_acacia_log"
        ],
        [
          "block.minecraft.stripped_acacia_log"
        ]
      ]
    },
    {
      "output": "block.minecraft.stripped_birch_wood",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.stripped_birch_log"
        ],
        [
          "block.minecraft.stripped_birch_log"
        ],
        [
          "block.minecraft.stripped_birch_log"
        ],
        [
          "block.minecraft.stripped_birch_log"
        ]
      ]
    },
    {
      "output": "block.minecraft.stripped_cherry_wood",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.stripped_cherry_log"
        ],
        [
          "block.minecraft.stripped_cherry_log"
        ],
        [
          "block.minecraft.stripped_cherry_log"
        ],
        [
          "block.minecraft.stripped_cherry_log"
        ]
      ]
    },
    {
      "output": "block.minecraft.stripped_crimson_hyphae",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.stripped_crimson_stem"
        ],
        [
          "block.minecraft.stripped_crimson_stem"
        ],
        [
          "block.minecraft.stripped_crimson_stem"
        ],
        [
          "block.minecraft.stripped_crimson_stem"
        ]
      ]
    },
    {
      "output": "block.minecraft.stripped_dark_oak_wood",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.stripped_dark_oak_log"
        ],
        [
          "block.minecraft.stripped_dark_oak_log"
        ],
        [
          "block.minecraft.stripped_dark_oak_log"
        ],
        [
          "block.minecraft.stripped_dark_oak_log"
        ]
      ]
    },
    {
      "output": "block.minecraft.stripped_jungle_wood",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.stripped_jungle_log"
        ],
        [
          "block.minecraft.stripped_jungle_log"
        ],
        [
          "block.minecraft.stripped_jungle_log"
        ],
        [
          "block.minecraft.stripped_jungle_log"
        ]
      ]
    },
    {
      "output": "block.minecraft.stripped_mangrove_wood",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.stripped_mangrove_log"
        ],
        [
          "block.minecraft.stripped_mangrove_log"
        ],
        [
          "block.minecraft.stripped_mangrove_log"
        ],
        [
          "block.minecraft.stripped_mangrove_log"
        ]
      ]
    },
    {
      "output": "block.minecraft.stripped_oak_wood",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.stripped_oak_log"
        ],
        [
          "block.minecraft.stripped_oak_log"
        ],
        [
          "block.minecraft.stripped_oak_log"
        ],
        [
          "block.minecraft.stripped_oak_log"
        ]
      ]
    },
    {
      "output": "block.minecraft.stripped_pale_oak_wood",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.stripped_pale_oak_log"
        ],
        [
          "block.minecraft.stripped_pale_oak_log"
        ],
        [
          "block.minecraft.stripped_pale_oak_log"
        ],
        [
          "block.minecraft.stripped_pale_oak_log"
        ]
      ]
    },
    {
      "output": "block.minecraft.stripped_spruce_wood",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.stripped_spruce_log"
        ],
        [
          "block.minecraft.stripped_spruce_log"
        ],
        [
          "block.minecraft.stripped_spruce_log"
        ],
        [
          "block.minecraft.stripped_spruce_log"
        ]
      ]
    },
    {
      "output": "block.minecraft.stripped_warped_hyphae",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.stripped_warped_stem"
        ],
        [
          "block.minecraft.stripped_warped_stem"
        ],
        [
          "block.minecraft.stripped_warped_stem"
        ],
        [
          "block.minecraft.stripped_warped_stem"
        ]
      ]
    },
    {
      "output": "block.minecraft.warped_hyphae",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.warped_stem"
        ],
        [
          "block.minecraft.warped_stem"
        ],
        [
          "block.minecraft.warped_stem"
        ],
        [
          "block.minecraft.warped_stem"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.activator_rail",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "block.minecraft.redstone_torch"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.iron_ingot"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.amethyst_block",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.amethyst_shard"
        ],
        [
          "item.minecraft.amethyst_shard"
        ],
        [
          "item.minecraft.amethyst_shard"
        ],
        [
          "item.minecraft.amethyst_shard"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.andesite",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.diorite"
        ],
        [
          "block.minecraft.cobblestone"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.andesite_slab",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.andesite"
        ],
        [
          "block.minecraft.andesite"
        ],
        [
          "block.minecraft.andesite"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.andesite_stairs",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.andesite"
        ],
        [
          "block.minecraft.andesite"
        ],
        [
          "block.minecraft.andesite"
        ],
        [
          "block.minecraft.andesite"
        ],
        [
          "block.minecraft.andesite"
        ],
        [
          "block.minecraft.andesite"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.andesite_wall",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.andesite"
        ],
        [
          "block.minecraft.andesite"
        ],
        [
          "block.minecraft.andesite"
        ],
        [
          "block.minecraft.andesite"
        ],
        [
          "block.minecraft.andesite"
        ],
        [
          "block.minecraft.andesite"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.anvil",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.iron_block"
        ],
        [
          "block.minecraft.iron_block"
        ],
        [
          "block.minecraft.iron_block"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.bamboo_block",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.bamboo"
        ],
        [
          "block.minecraft.bamboo"
        ],
        [
          "block.minecraft.bamboo"
        ],
        [
          "block.minecraft.bamboo"
        ],
        [
          "block.minecraft.bamboo"
        ],
        [
          "block.minecraft.bamboo"
        ],
        [
          "block.minecraft.bamboo"
        ],
        [
          "block.minecraft.bamboo"
        ],
        [
          "block.minecraft.bamboo"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.bamboo_mosaic",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.bamboo_slab"
        ],
        [
          "block.minecraft.bamboo_slab"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.bamboo_mosaic_slab",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.bamboo_mosaic"
        ],
        [
          "block.minecraft.bamboo_mosaic"
        ],
        [
          "block.minecraft.bamboo_mosaic"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.bamboo_mosaic_stairs",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.bamboo_mosaic"
        ],
        [
          "block.minecraft.bamboo_mosaic"
        ],
        [
          "block.minecraft.bamboo_mosaic"
        ],
        [
          "block.minecraft.bamboo_mosaic"
        ],
        [
          "block.minecraft.bamboo_mosaic"
        ],
        [
          "block.minecraft.bamboo_mosaic"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.barrel",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.acacia_slab",
          "block.minecraft.bamboo_slab",
          "block.minecraft.birch_slab",
          "block.minecraft.cherry_slab",
          "block.minecraft.crimson_slab",
          "block.minecraft.dark_oak_slab",
          "block.minecraft.jungle_slab",
          "block.minecraft.mangrove_slab",
          "block.minecraft.oak_slab",
          "block.minecraft.pale_oak_slab",
          "block.minecraft.spruce_slab",
          "block.minecraft.warped_slab"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.acacia_slab",
          "block.minecraft.bamboo_slab",
          "block.minecraft.birch_slab",
          "block.minecraft.cherry_slab",
          "block.minecraft.crimson_slab",
          "block.minecraft.dark_oak_slab",
          "block.minecraft.jungle_slab",
          "block.minecraft.mangrove_slab",
          "block.minecraft.oak_slab",
          "block.minecraft.pale_oak_slab",
          "block.minecraft.spruce_slab",
          "block.minecraft.warped_slab"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.beacon",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "item.minecraft.nether_star"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.obsidian"
        ],
        [
          "block.minecraft.obsidian"
        ],
        [
          "block.minecraft.obsidian"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.beehive",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "item.minecraft.honeycomb"
        ],
        [
          "item.minecraft.honeycomb"
        ],
        [
          "item.minecraft.honeycomb"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.black_banner",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.black_wool"
        ],
        [
          "block.minecraft.black_wool"
        ],
        [
          "block.minecraft.black_wool"
        ],
        [
          "block.minecraft.black_wool"
        ],
        [
          "block.minecraft.black_wool"
        ],
        [
          "block.minecraft.black_wool"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    },
    {
      "output": "block.minecraft.blue_banner",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.blue_wool"
        ],
        [
          "block.minecraft.blue_wool"
        ],
        [
          "block.minecraft.blue_wool"
        ],
        [
          "block.minecraft.blue_wool"
        ],
        [
          "block.minecraft.blue_wool"
        ],
        [
          "block.minecraft.blue_wool"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    },
    {
      "output": "block.minecraft.brown_banner",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.brown_wool"
        ],
        [
          "block.minecraft.brown_wool"
        ],
        [
          "block.minecraft.brown_wool"
        ],
        [
          "block.minecraft.brown_wool"
        ],
        [
          "block.minecraft.brown_wool"
        ],
        [
          "block.minecraft.brown_wool"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    },
    {
      "output": "block.minecraft.cyan_banner",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.cyan_wool"
        ],
        [
          "block.minecraft.cyan_wool"
        ],
        [
          "block.minecraft.cyan_wool"
        ],
        [
          "block.minecraft.cyan_wool"
        ],
        [
          "block.minecraft.cyan_wool"
        ],
        [
          "block.minecraft.cyan_wool"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    },
    {
      "output": "block.minecraft.gray_banner",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.gray_wool"
        ],
        [
          "block.minecraft.gray_wool"
        ],
        [
          "block.minecraft.gray_wool"
        ],
        [
          "block.minecraft.gray_wool"
        ],
        [
          "block.minecraft.gray_wool"
        ],
        [
          "block.minecraft.gray_wool"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    },
    {
      "output": "block.minecraft.green_banner",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.green_wool"
        ],
        [
          "block.minecraft.green_wool"
        ],
        [
          "block.minecraft.green_wool"
        ],
        [
          "block.minecraft.green_wool"
        ],
        [
          "block.minecraft.green_wool"
        ],
        [
          "block.minecraft.green_wool"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    },
    {
      "output": "block.minecraft.light_blue_banner",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.light_blue_wool"
        ],
        [
          "block.minecraft.light_blue_wool"
        ],
        [
          "block.minecraft.light_blue_wool"
        ],
        [
          "block.minecraft.light_blue_wool"
        ],
        [
          "block.minecraft.light_blue_wool"
        ],
        [
          "block.minecraft.light_blue_wool"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    },
    {
      "output": "block.minecraft.light_gray_banner",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.light_gray_wool"
        ],
        [
          "block.minecraft.light_gray_wool"
        ],
        [
          "block.minecraft.light_gray_wool"
        ],
        [
          "block.minecraft.light_gray_wool"
        ],
        [
          "block.minecraft.light_gray_wool"
        ],
        [
          "block.minecraft.light_gray_wool"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    },
    {
      "output": "block.minecraft.lime_banner",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.lime_wool"
        ],
        [
          "block.minecraft.lime_wool"
        ],
        [
          "block.minecraft.lime_wool"
        ],
        [
          "block.minecraft.lime_wool"
        ],
        [
          "block.minecraft.lime_wool"
        ],
        [
          "block.minecraft.lime_wool"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    },
    {
      "output": "block.minecraft.magenta_banner",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.magenta_wool"
        ],
        [
          "block.minecraft.magenta_wool"
        ],
        [
          "block.minecraft.magenta_wool"
        ],
        [
          "block.minecraft.magenta_wool"
        ],
        [
          "block.minecraft.magenta_wool"
        ],
        [
          "block.minecraft.magenta_wool"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    },
    {
      "output": "block.minecraft.orange_banner",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.orange_wool"
        ],
        [
          "block.minecraft.orange_wool"
        ],
        [
          "block.minecraft.orange_wool"
        ],
        [
          "block.minecraft.orange_wool"
        ],
        [
          "block.minecraft.orange_wool"
        ],
        [
          "block.minecraft.orange_wool"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    },
    {
      "output": "block.minecraft.pink_banner",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.pink_wool"
        ],
        [
          "block.minecraft.pink_wool"
        ],
        [
          "block.minecraft.pink_wool"
        ],
        [
          "block.minecraft.pink_wool"
        ],
        [
          "block.minecraft.pink_wool"
        ],
        [
          "block.minecraft.pink_wool"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    },
    {
      "output": "block.minecraft.purple_banner",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.purple_wool"
        ],
        [
          "block.minecraft.purple_wool"
        ],
        [
          "block.minecraft.purple_wool"
        ],
        [
          "block.minecraft.purple_wool"
        ],
        [
          "block.minecraft.purple_wool"
        ],
        [
          "block.minecraft.purple_wool"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    },
    {
      "output": "block.minecraft.red_banner",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.red_wool"
        ],
        [
          "block.minecraft.red_wool"
        ],
        [
          "block.minecraft.red_wool"
        ],
        [
          "block.minecraft.red_wool"
        ],
        [
          "block.minecraft.red_wool"
        ],
        [
          "block.minecraft.red_wool"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    },
    {
      "output": "block.minecraft.white_banner",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.white_wool"
        ],
        [
          "block.minecraft.white_wool"
        ],
        [
          "block.minecraft.white_wool"
        ],
        [
          "block.minecraft.white_wool"
        ],
        [
          "block.minecraft.white_wool"
        ],
        [
          "block.minecraft.white_wool"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    },
    {
      "output": "block.minecraft.yellow_banner",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.yellow_wool"
        ],
        [
          "block.minecraft.yellow_wool"
        ],
        [
          "block.minecraft.yellow_wool"
        ],
        [
          "block.minecraft.yellow_wool"
        ],
        [
          "block.minecraft.yellow_wool"
        ],
        [
          "block.minecraft.yellow_wool"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.black_bed",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.black_wool"
        ],
        [
          "block.minecraft.black_wool"
        ],
        [
          "block.minecraft.black_wool"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.blue_bed",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.blue_wool"
        ],
        [
          "block.minecraft.blue_wool"
        ],
        [
          "block.minecraft.blue_wool"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.brown_bed",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.brown_wool"
        ],
        [
          "block.minecraft.brown_wool"
        ],
        [
          "block.minecraft.brown_wool"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.cyan_bed",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.cyan_wool"
        ],
        [
          "block.minecraft.cyan_wool"
        ],
        [
          "block.minecraft.cyan_wool"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.gray_bed",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.gray_wool"
        ],
        [
          "block.minecraft.gray_wool"
        ],
        [
          "block.minecraft.gray_wool"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.green_bed",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.green_wool"
        ],
        [
          "block.minecraft.green_wool"
        ],
        [
          "block.minecraft.green_wool"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.light_blue_bed",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.light_blue_wool"
        ],
        [
          "block.minecraft.light_blue_wool"
        ],
        [
          "block.minecraft.light_blue_wool"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.light_gray_bed",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.light_gray_wool"
        ],
        [
          "block.minecraft.light_gray_wool"
        ],
        [
          "block.minecraft.light_gray_wool"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.lime_bed",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.lime_wool"
        ],
        [
          "block.minecraft.lime_wool"
        ],
        [
          "block.minecraft.lime_wool"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.magenta_bed",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.magenta_wool"
        ],
        [
          "block.minecraft.magenta_wool"
        ],
        [
          "block.minecraft.magenta_wool"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.orange_bed",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.orange_wool"
        ],
        [
          "block.minecraft.orange_wool"
        ],
        [
          "block.minecraft.orange_wool"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.pink_bed",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.pink_wool"
        ],
        [
          "block.minecraft.pink_wool"
        ],
        [
          "block.minecraft.pink_wool"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.purple_bed",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.purple_wool"
        ],
        [
          "block.minecraft.purple_wool"
        ],
        [
          "block.minecraft.purple_wool"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.red_bed",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.red_wool"
        ],
        [
          "block.minecraft.red_wool"
        ],
        [
          "block.minecraft.red_wool"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.white_bed",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.white_wool"
        ],
        [
          "block.minecraft.white_wool"
        ],
        [
          "block.minecraft.white_wool"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ]
      ]
    },
    {
      "output": "block.minecraft.yellow_bed",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.yellow_wool"
        ],
        [
          "block.minecraft.yellow_wool"
        ],
        [
          "block.minecraft.yellow_wool"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.black_bed",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.black_dye"
        ],
        [
          "block.minecraft.blue_bed",
          "block.minecraft.brown_bed",
          "block.minecraft.cyan_bed",
          "block.minecraft.gray_bed",
          "block.minecraft.green_bed",
          "block.minecraft.light_blue_bed",
          "block.minecraft.light_gray_bed",
          "block.minecraft.lime_bed",
          "block.minecraft.magenta_bed",
          "block.minecraft.orange_bed",
          "block.minecraft.pink_bed",
          "block.minecraft.purple_bed",
          "block.minecraft.red_bed",
          "block.minecraft.white_bed",
          "block.minecraft.yellow_bed"
        ]
      ]
    },
    {
      "output": "block.minecraft.blue_bed",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.blue_dye"
        ],
        [
          "block.minecraft.black_bed",
          "block.minecraft.brown_bed",
          "block.minecraft.cyan_bed",
          "block.minecraft.gray_bed",
          "block.minecraft.green_bed",
          "block.minecraft.light_blue_bed",
          "block.minecraft.light_gray_bed",
          "block.minecraft.lime_bed",
          "block.minecraft.magenta_bed",
          "block.minecraft.orange_bed",
          "block.minecraft.pink_bed",
          "block.minecraft.purple_bed",
          "block.minecraft.red_bed",
          "block.minecraft.white_bed",
          "block.minecraft.yellow_bed"
        ]
      ]
    },
    {
      "output": "block.minecraft.brown_bed",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.brown_dye"
        ],
        [
          "block.minecraft.black_bed",
          "block.minecraft.blue_bed",
          "block.minecraft.cyan_bed",
          "block.minecraft.gray_bed",
          "block.minecraft.green_bed",
          "block.minecraft.light_blue_bed",
          "block.minecraft.light_gray_bed",
          "block.minecraft.lime_bed",
          "block.minecraft.magenta_bed",
          "block.minecraft.orange_bed",
          "block.minecraft.pink_bed",
          "block.minecraft.purple_bed",
          "block.minecraft.red_bed",
          "block.minecraft.white_bed",
          "block.minecraft.yellow_bed"
        ]
      ]
    },
    {
      "output": "block.minecraft.cyan_bed",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.cyan_dye"
        ],
        [
          "block.minecraft.black_bed",
          "block.minecraft.blue_bed",
          "block.minecraft.brown_bed",
          "block.minecraft.gray_bed",
          "block.minecraft.green_bed",
          "block.minecraft.light_blue_bed",
          "block.minecraft.light_gray_bed",
          "block.minecraft.lime_bed",
          "block.minecraft.magenta_bed",
          "block.minecraft.orange_bed",
          "block.minecraft.pink_bed",
          "block.minecraft.purple_bed",
          "block.minecraft.red_bed",
          "block.minecraft.white_bed",
          "block.minecraft.yellow_bed"
        ]
      ]
    },
    {
      "output": "block.minecraft.gray_bed",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.gray_dye"
        ],
        [
          "block.minecraft.black_bed",
          "block.minecraft.blue_bed",
          "block.minecraft.brown_bed",
          "block.minecraft.cyan_bed",
          "block.minecraft.green_bed",
          "block.minecraft.light_blue_bed",
          "block.minecraft.light_gray_bed",
          "block.minecraft.lime_bed",
          "block.minecraft.magenta_bed",
          "block.minecraft.orange_bed",
          "block.minecraft.pink_bed",
          "block.minecraft.purple_bed",
          "block.minecraft.red_bed",
          "block.minecraft.white_bed",
          "block.minecraft.yellow_bed"
        ]
      ]
    },
    {
      "output": "block.minecraft.green_bed",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.green_dye"
        ],
        [
          "block.minecraft.black_bed",
          "block.minecraft.blue_bed",
          "block.minecraft.brown_bed",
          "block.minecraft.cyan_bed",
          "block.minecraft.gray_bed",
          "block.minecraft.light_blue_bed",
          "block.minecraft.light_gray_bed",
          "block.minecraft.lime_bed",
          "block.minecraft.magenta_bed",
          "block.minecraft.orange_bed",
          "block.minecraft.pink_bed",
          "block.minecraft.purple_bed",
          "block.minecraft.red_bed",
          "block.minecraft.white_bed",
          "block.minecraft.yellow_bed"
        ]
      ]
    },
    {
      "output": "block.minecraft.light_blue_bed",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.light_blue_dye"
        ],
        [
          "block.minecraft.black_bed",
          "block.minecraft.blue_bed",
          "block.minecraft.brown_bed",
          "block.minecraft.cyan_bed",
          "block.minecraft.gray_bed",
          "block.minecraft.green_bed",
          "block.minecraft.light_gray_bed",
          "block.minecraft.lime_bed",
          "block.minecraft.magenta_bed",
          "block.minecraft.orange_bed",
          "block.minecraft.pink_bed",
          "block.minecraft.purple_bed",
          "block.minecraft.red_bed",
          "block.minecraft.white_bed",
          "block.minecraft.yellow_bed"
        ]
      ]
    },
    {
      "output": "block.minecraft.light_gray_bed",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.light_gray_dye"
        ],
        [
          "block.minecraft.black_bed",
          "block.minecraft.blue_bed",
          "block.minecraft.brown_bed",
          "block.minecraft.cyan_bed",
          "block.minecraft.gray_bed",
          "block.minecraft.green_bed",
          "block.minecraft.light_blue_bed",
          "block.minecraft.lime_bed",
          "block.minecraft.magenta_bed",
          "block.minecraft.orange_bed",
          "block.minecraft.pink_bed",
          "block.minecraft.purple_bed",
          "block.minecraft.red_bed",
          "block.minecraft.white_bed",
          "block.minecraft.yellow_bed"
        ]
      ]
    },
    {
      "output": "block.minecraft.lime_bed",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.lime_dye"
        ],
        [
          "block.minecraft.black_bed",
          "block.minecraft.blue_bed",
          "block.minecraft.brown_bed",
          "block.minecraft.cyan_bed",
          "block.minecraft.gray_bed",
          "block.minecraft.green_bed",
          "block.minecraft.light_blue_bed",
          "block.minecraft.light_gray_bed",
          "block.minecraft.magenta_bed",
          "block.minecraft.orange_bed",
          "block.minecraft.pink_bed",
          "block.minecraft.purple_bed",
          "block.minecraft.red_bed",
          "block.minecraft.white_bed",
          "block.minecraft.yellow_bed"
        ]
      ]
    },
    {
      "output": "block.minecraft.magenta_bed",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.magenta_dye"
        ],
        [
          "block.minecraft.black_bed",
          "block.minecraft.blue_bed",
          "block.minecraft.brown_bed",
          "block.minecraft.cyan_bed",
          "block.minecraft.gray_bed",
          "block.minecraft.green_bed",
          "block.minecraft.light_blue_bed",
          "block.minecraft.light_gray_bed",
          "block.minecraft.lime_bed",
          "block.minecraft.orange_bed",
          "block.minecraft.pink_bed",
          "block.minecraft.purple_bed",
          "block.minecraft.red_bed",
          "block.minecraft.white_bed",
          "block.minecraft.yellow_bed"
        ]
      ]
    },
    {
      "output": "block.minecraft.orange_bed",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.orange_dye"
        ],
        [
          "block.minecraft.black_bed",
          "block.minecraft.blue_bed",
          "block.minecraft.brown_bed",
          "block.minecraft.cyan_bed",
          "block.minecraft.gray_bed",
          "block.minecraft.green_bed",
          "block.minecraft.light_blue_bed",
          "block.minecraft.light_gray_bed",
          "block.minecraft.lime_bed",
          "block.minecraft.magenta_bed",
          "block.minecraft.pink_bed",
          "block.minecraft.purple_bed",
          "block.minecraft.red_bed",
          "block.minecraft.white_bed",
          "block.minecraft.yellow_bed"
        ]
      ]
    },
    {
      "output": "block.minecraft.pink_bed",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.pink_dye"
        ],
        [
          "block.minecraft.black_bed",
          "block.minecraft.blue_bed",
          "block.minecraft.brown_bed",
          "block.minecraft.cyan_bed",
          "block.minecraft.gray_bed",
          "block.minecraft.green_bed",
          "block.minecraft.light_blue_bed",
          "block.minecraft.light_gray_bed",
          "block.minecraft.lime_bed",
          "block.minecraft.magenta_bed",
          "block.minecraft.orange_bed",
          "block.minecraft.purple_bed",
          "block.minecraft.red_bed",
          "block.minecraft.white_bed",
          "block.minecraft.yellow_bed"
        ]
      ]
    },
    {
      "output": "block.minecraft.purple_bed",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.purple_dye"
        ],
        [
          "block.minecraft.black_bed",
          "block.minecraft.blue_bed",
          "block.minecraft.brown_bed",
          "block.minecraft.cyan_bed",
          "block.minecraft.gray_bed",
          "block.minecraft.green_bed",
          "block.minecraft.light_blue_bed",
          "block.minecraft.light_gray_bed",
          "block.minecraft.lime_bed",
          "block.minecraft.magenta_bed",
          "block.minecraft.orange_bed",
          "block.minecraft.pink_bed",
          "block.minecraft.red_bed",
          "block.minecraft.white_bed",
          "block.minecraft.yellow_bed"
        ]
      ]
    },
    {
      "output": "block.minecraft.red_bed",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.red_dye"
        ],
        [
          "block.minecraft.black_bed",
          "block.minecraft.blue_bed",
          "block.minecraft.brown_bed",
          "block.minecraft.cyan_bed",
          "block.minecraft.gray_bed",
          "block.minecraft.green_bed",
          "block.minecraft.light_blue_bed",
          "block.minecraft.light_gray_bed",
          "block.minecraft.lime_bed",
          "block.minecraft.magenta_bed",
          "block.minecraft.orange_bed",
          "block.minecraft.pink_bed",
          "block.minecraft.purple_bed",
          "block.minecraft.white_bed",
          "block.minecraft.yellow_bed"
        ]
      ]
    },
    {
      "output": "block.minecraft.white_bed",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.white_dye"
        ],
        [
          "block.minecraft.black_bed",
          "block.minecraft.blue_bed",
          "block.minecraft.brown_bed",
          "block.minecraft.cyan_bed",
          "block.minecraft.gray_bed",
          "block.minecraft.green_bed",
          "block.minecraft.light_blue_bed",
          "block.minecraft.light_gray_bed",
          "block.minecraft.lime_bed",
          "block.minecraft.magenta_bed",
          "block.minecraft.orange_bed",
          "block.minecraft.pink_bed",
          "block.minecraft.purple_bed",
          "block.minecraft.red_bed",
          "block.minecraft.yellow_bed"
        ]
      ]
    },
    {
      "output": "block.minecraft.yellow_bed",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.yellow_dye"
        ],
        [
          "block.minecraft.black_bed",
          "block.minecraft.blue_bed",
          "block.minecraft.brown_bed",
          "block.minecraft.cyan_bed",
          "block.minecraft.gray_bed",
          "block.minecraft.green_bed",
          "block.minecraft.light_blue_bed",
          "block.minecraft.light_gray_bed",
          "block.minecraft.lime_bed",
          "block.minecraft.magenta_bed",
          "block.minecraft.orange_bed",
          "block.minecraft.pink_bed",
          "block.minecraft.purple_bed",
          "block.minecraft.red_bed",
          "block.minecraft.white_bed"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.black_candle",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.candle"
        ],
        [
          "item.minecraft.black_dye"
        ]
      ]
    },
    {
      "output": "block.minecraft.blue_candle",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.candle"
        ],
        [
          "item.minecraft.blue_dye"
        ]
      ]
    },
    {
      "output": "block.minecraft.brown_candle",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.candle"
        ],
        [
          "item.minecraft.brown_dye"
        ]
      ]
    },
    {
      "output": "block.minecraft.cyan_candle",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.candle"
        ],
        [
          "item.minecraft.cyan_dye"
        ]
      ]
    },
    {
      "output": "block.minecraft.gray_candle",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.candle"
        ],
        [
          "item.minecraft.gray_dye"
        ]
      ]
    },
    {
      "output": "block.minecraft.green_candle",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.candle"
        ],
        [
          "item.minecraft.green_dye"
        ]
      ]
    },
    {
      "output": "block.minecraft.light_blue_candle",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.candle"
        ],
        [
          "item.minecraft.light_blue_dye"
        ]
      ]
    },
    {
      "output": "block.minecraft.light_gray_candle",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.candle"
        ],
        [
          "item.minecraft.light_gray_dye"
        ]
      ]
    },
    {
      "output": "block.minecraft.lime_candle",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.candle"
        ],
        [
          "item.minecraft.lime_dye"
        ]
      ]
    },
    {
      "output": "block.minecraft.magenta_candle",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.candle"
        ],
        [
          "item.minecraft.magenta_dye"
        ]
      ]
    },
    {
      "output": "block.minecraft.orange_candle",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.candle"
        ],
        [
          "item.minecraft.orange_dye"
        ]
      ]
    },
    {
      "output": "block.minecraft.pink_candle",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.candle"
        ],
        [
          "item.minecraft.pink_dye"
        ]
      ]
    },
    {
      "output": "block.minecraft.purple_candle",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.candle"
        ],
        [
          "item.minecraft.purple_dye"
        ]
      ]
    },
    {
      "output": "block.minecraft.red_candle",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.candle"
        ],
        [
          "item.minecraft.red_dye"
        ]
      ]
    },
    {
      "output": "block.minecraft.white_candle",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.candle"
        ],
        [
          "item.minecraft.white_dye"
        ]
      ]
    },
    {
      "output": "block.minecraft.yellow_candle",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.candle"
        ],
        [
          "item.minecraft.yellow_dye"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.black_carpet",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.black_wool"
        ],
        [
          "block.minecraft.black_wool"
        ]
      ]
    },
    {
      "output": "block.minecraft.blue_carpet",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.blue_wool"
        ],
        [
          "block.minecraft.blue_wool"
        ]
      ]
    },
    {
      "output": "block.minecraft.brown_carpet",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.brown_wool"
        ],
        [
          "block.minecraft.brown_wool"
        ]
      ]
    },
    {
      "output": "block.minecraft.cyan_carpet",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.cyan_wool"
        ],
        [
          "block.minecraft.cyan_wool"
        ]
      ]
    },
    {
      "output": "block.minecraft.gray_carpet",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.gray_wool"
        ],
        [
          "block.minecraft.gray_wool"
        ]
      ]
    },
    {
      "output": "block.minecraft.green_carpet",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.green_wool"
        ],
        [
          "block.minecraft.green_wool"
        ]
      ]
    },
    {
      "output": "block.minecraft.light_blue_carpet",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.light_blue_wool"
        ],
        [
          "block.minecraft.light_blue_wool"
        ]
      ]
    },
    {
      "output": "block.minecraft.light_gray_carpet",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.light_gray_wool"
        ],
        [
          "block.minecraft.light_gray_wool"
        ]
      ]
    },
    {
      "output": "block.minecraft.lime_carpet",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.lime_wool"
        ],
        [
          "block.minecraft.lime_wool"
        ]
      ]
    },
    {
      "output": "block.minecraft.magenta_carpet",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.magenta_wool"
        ],
        [
          "block.minecraft.magenta_wool"
        ]
      ]
    },
    {
      "output": "block.minecraft.moss_carpet",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.moss_block"
        ],
        [
          "block.minecraft.moss_block"
        ]
      ]
    },
    {
      "output": "block.minecraft.orange_carpet",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.orange_wool"
        ],
        [
          "block.minecraft.orange_wool"
        ]
      ]
    },
    {
      "output": "block.minecraft.pale_moss_carpet",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.pale_moss_block"
        ],
        [
          "block.minecraft.pale_moss_block"
        ]
      ]
    },
    {
      "output": "block.minecraft.pink_carpet",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.pink_wool"
        ],
        [
          "block.minecraft.pink_wool"
        ]
      ]
    },
    {
      "output": "block.minecraft.purple_carpet",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.purple_wool"
        ],
        [
          "block.minecraft.purple_wool"
        ]
      ]
    },
    {
      "output": "block.minecraft.red_carpet",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.red_wool"
        ],
        [
          "block.minecraft.red_wool"
        ]
      ]
    },
    {
      "output": "block.minecraft.white_carpet",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.white_wool"
        ],
        [
          "block.minecraft.white_wool"
        ]
      ]
    },
    {
      "output": "block.minecraft.yellow_carpet",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.yellow_wool"
        ],
        [
          "block.minecraft.yellow_wool"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.black_carpet",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.black_dye"
        ],
        [
          "block.minecraft.blue_carpet",
          "block.minecraft.brown_carpet",
          "block.minecraft.cyan_carpet",
          "block.minecraft.gray_carpet",
          "block.minecraft.green_carpet",
          "block.minecraft.light_blue_carpet",
          "block.minecraft.light_gray_carpet",
          "block.minecraft.lime_carpet",
          "block.minecraft.magenta_carpet",
          "block.minecraft.orange_carpet",
          "block.minecraft.pink_carpet",
          "block.minecraft.purple_carpet",
          "block.minecraft.red_carpet",
          "block.minecraft.white_carpet",
          "block.minecraft.yellow_carpet"
        ]
      ]
    },
    {
      "output": "block.minecraft.blue_carpet",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.blue_dye"
        ],
        [
          "block.minecraft.black_carpet",
          "block.minecraft.brown_carpet",
          "block.minecraft.cyan_carpet",
          "block.minecraft.gray_carpet",
          "block.minecraft.green_carpet",
          "block.minecraft.light_blue_carpet",
          "block.minecraft.light_gray_carpet",
          "block.minecraft.lime_carpet",
          "block.minecraft.magenta_carpet",
          "block.minecraft.orange_carpet",
          "block.minecraft.pink_carpet",
          "block.minecraft.purple_carpet",
          "block.minecraft.red_carpet",
          "block.minecraft.white_carpet",
          "block.minecraft.yellow_carpet"
        ]
      ]
    },
    {
      "output": "block.minecraft.brown_carpet",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.brown_dye"
        ],
        [
          "block.minecraft.black_carpet",
          "block.minecraft.blue_carpet",
          "block.minecraft.cyan_carpet",
          "block.minecraft.gray_carpet",
          "block.minecraft.green_carpet",
          "block.minecraft.light_blue_carpet",
          "block.minecraft.light_gray_carpet",
          "block.minecraft.lime_carpet",
          "block.minecraft.magenta_carpet",
          "block.minecraft.orange_carpet",
          "block.minecraft.pink_carpet",
          "block.minecraft.purple_carpet",
          "block.minecraft.red_carpet",
          "block.minecraft.white_carpet",
          "block.minecraft.yellow_carpet"
        ]
      ]
    },
    {
      "output": "block.minecraft.cyan_carpet",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.cyan_dye"
        ],
        [
          "block.minecraft.black_carpet",
          "block.minecraft.blue_carpet",
          "block.minecraft.brown_carpet",
          "block.minecraft.gray_carpet",
          "block.minecraft.green_carpet",
          "block.minecraft.light_blue_carpet",
          "block.minecraft.light_gray_carpet",
          "block.minecraft.lime_carpet",
          "block.minecraft.magenta_carpet",
          "block.minecraft.orange_carpet",
          "block.minecraft.pink_carpet",
          "block.minecraft.purple_carpet",
          "block.minecraft.red_carpet",
          "block.minecraft.white_carpet",
          "block.minecraft.yellow_carpet"
        ]
      ]
    },
    {
      "output": "block.minecraft.gray_carpet",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.gray_dye"
        ],
        [
          "block.minecraft.black_carpet",
          "block.minecraft.blue_carpet",
          "block.minecraft.brown_carpet",
          "block.minecraft.cyan_carpet",
          "block.minecraft.green_carpet",
          "block.minecraft.light_blue_carpet",
          "block.minecraft.light_gray_carpet",
          "block.minecraft.lime_carpet",
          "block.minecraft.magenta_carpet",
          "block.minecraft.orange_carpet",
          "block.minecraft.pink_carpet",
          "block.minecraft.purple_carpet",
          "block.minecraft.red_carpet",
          "block.minecraft.white_carpet",
          "block.minecraft.yellow_carpet"
        ]
      ]
    },
    {
      "output": "block.minecraft.green_carpet",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.green_dye"
        ],
        [
          "block.minecraft.black_carpet",
          "block.minecraft.blue_carpet",
          "block.minecraft.brown_carpet",
          "block.minecraft.cyan_carpet",
          "block.minecraft.gray_carpet",
          "block.minecraft.light_blue_carpet",
          "block.minecraft.light_gray_carpet",
          "block.minecraft.lime_carpet",
          "block.minecraft.magenta_carpet",
          "block.minecraft.orange_carpet",
          "block.minecraft.pink_carpet",
          "block.minecraft.purple_carpet",
          "block.minecraft.red_carpet",
          "block.minecraft.white_carpet",
          "block.minecraft.yellow_carpet"
        ]
      ]
    },
    {
      "output": "block.minecraft.light_blue_carpet",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.light_blue_dye"
        ],
        [
          "block.minecraft.black_carpet",
          "block.minecraft.blue_carpet",
          "block.minecraft.brown_carpet",
          "block.minecraft.cyan_carpet",
          "block.minecraft.gray_carpet",
          "block.minecraft.green_carpet",
          "block.minecraft.light_gray_carpet",
          "block.minecraft.lime_carpet",
          "block.minecraft.magenta_carpet",
          "block.minecraft.orange_carpet",
          "block.minecraft.pink_carpet",
          "block.minecraft.purple_carpet",
          "block.minecraft.red_carpet",
          "block.minecraft.white_carpet",
          "block.minecraft.yellow_carpet"
        ]
      ]
    },
    {
      "output": "block.minecraft.light_gray_carpet",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.light_gray_dye"
        ],
        [
          "block.minecraft.black_carpet",
          "block.minecraft.blue_carpet",
          "block.minecraft.brown_carpet",
          "block.minecraft.cyan_carpet",
          "block.minecraft.gray_carpet",
          "block.minecraft.green_carpet",
          "block.minecraft.light_blue_carpet",
          "block.minecraft.lime_carpet",
          "block.minecraft.magenta_carpet",
          "block.minecraft.orange_carpet",
          "block.minecraft.pink_carpet",
          "block.minecraft.purple_carpet",
          "block.minecraft.red_carpet",
          "block.minecraft.white_carpet",
          "block.minecraft.yellow_carpet"
        ]
      ]
    },
    {
      "output": "block.minecraft.lime_carpet",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.lime_dye"
        ],
        [
          "block.minecraft.black_carpet",
          "block.minecraft.blue_carpet",
          "block.minecraft.brown_carpet",
          "block.minecraft.cyan_carpet",
          "block.minecraft.gray_carpet",
          "block.minecraft.green_carpet",
          "block.minecraft.light_blue_carpet",
          "block.minecraft.light_gray_carpet",
          "block.minecraft.magenta_carpet",
          "block.minecraft.orange_carpet",
          "block.minecraft.pink_carpet",
          "block.minecraft.purple_carpet",
          "block.minecraft.red_carpet",
          "block.minecraft.white_carpet",
          "block.minecraft.yellow_carpet"
        ]
      ]
    },
    {
      "output": "block.minecraft.magenta_carpet",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.magenta_dye"
        ],
        [
          "block.minecraft.black_carpet",
          "block.minecraft.blue_carpet",
          "block.minecraft.brown_carpet",
          "block.minecraft.cyan_carpet",
          "block.minecraft.gray_carpet",
          "block.minecraft.green_carpet",
          "block.minecraft.light_blue_carpet",
          "block.minecraft.light_gray_carpet",
          "block.minecraft.lime_carpet",
          "block.minecraft.orange_carpet",
          "block.minecraft.pink_carpet",
          "block.minecraft.purple_carpet",
          "block.minecraft.red_carpet",
          "block.minecraft.white_carpet",
          "block.minecraft.yellow_carpet"
        ]
      ]
    },
    {
      "output": "block.minecraft.orange_carpet",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.orange_dye"
        ],
        [
          "block.minecraft.black_carpet",
          "block.minecraft.blue_carpet",
          "block.minecraft.brown_carpet",
          "block.minecraft.cyan_carpet",
          "block.minecraft.gray_carpet",
          "block.minecraft.green_carpet",
          "block.minecraft.light_blue_carpet",
          "block.minecraft.light_gray_carpet",
          "block.minecraft.lime_carpet",
          "block.minecraft.magenta_carpet",
          "block.minecraft.pink_carpet",
          "block.minecraft.purple_carpet",
          "block.minecraft.red_carpet",
          "block.minecraft.white_carpet",
          "block.minecraft.yellow_carpet"
        ]
      ]
    },
    {
      "output": "block.minecraft.pink_carpet",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.pink_dye"
        ],
        [
          "block.minecraft.black_carpet",
          "block.minecraft.blue_carpet",
          "block.minecraft.brown_carpet",
          "block.minecraft.cyan_carpet",
          "block.minecraft.gray_carpet",
          "block.minecraft.green_carpet",
          "block.minecraft.light_blue_carpet",
          "block.minecraft.light_gray_carpet",
          "block.minecraft.lime_carpet",
          "block.minecraft.magenta_carpet",
          "block.minecraft.orange_carpet",
          "block.minecraft.purple_carpet",
          "block.minecraft.red_carpet",
          "block.minecraft.white_carpet",
          "block.minecraft.yellow_carpet"
        ]
      ]
    },
    {
      "output": "block.minecraft.purple_carpet",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.purple_dye"
        ],
        [
          "block.minecraft.black_carpet",
          "block.minecraft.blue_carpet",
          "block.minecraft.brown_carpet",
          "block.minecraft.cyan_carpet",
          "block.minecraft.gray_carpet",
          "block.minecraft.green_carpet",
          "block.minecraft.light_blue_carpet",
          "block.minecraft.light_gray_carpet",
          "block.minecraft.lime_carpet",
          "block.minecraft.magenta_carpet",
          "block.minecraft.orange_carpet",
          "block.minecraft.pink_carpet",
          "block.minecraft.red_carpet",
          "block.minecraft.white_carpet",
          "block.minecraft.yellow_carpet"
        ]
      ]
    },
    {
      "output": "block.minecraft.red_carpet",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.red_dye"
        ],
        [
          "block.minecraft.black_carpet",
          "block.minecraft.blue_carpet",
          "block.minecraft.brown_carpet",
          "block.minecraft.cyan_carpet",
          "block.minecraft.gray_carpet",
          "block.minecraft.green_carpet",
          "block.minecraft.light_blue_carpet",
          "block.minecraft.light_gray_carpet",
          "block.minecraft.lime_carpet",
          "block.minecraft.magenta_carpet",
          "block.minecraft.orange_carpet",
          "block.minecraft.pink_carpet",
          "block.minecraft.purple_carpet",
          "block.minecraft.white_carpet",
          "block.minecraft.yellow_carpet"
        ]
      ]
    },
    {
      "output": "block.minecraft.white_carpet",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.white_dye"
        ],
        [
          "block.minecraft.black_carpet",
          "block.minecraft.blue_carpet",
          "block.minecraft.brown_carpet",
          "block.minecraft.cyan_carpet",
          "block.minecraft.gray_carpet",
          "block.minecraft.green_carpet",
          "block.minecraft.light_blue_carpet",
          "block.minecraft.light_gray_carpet",
          "block.minecraft.lime_carpet",
          "block.minecraft.magenta_carpet",
          "block.minecraft.orange_carpet",
          "block.minecraft.pink_carpet",
          "block.minecraft.purple_carpet",
          "block.minecraft.red_carpet",
          "block.minecraft.yellow_carpet"
        ]
      ]
    },
    {
      "output": "block.minecraft.yellow_carpet",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.yellow_dye"
        ],
        [
          "block.minecraft.black_carpet",
          "block.minecraft.blue_carpet",
          "block.minecraft.brown_carpet",
          "block.minecraft.cyan_carpet",
          "block.minecraft.gray_carpet",
          "block.minecraft.green_carpet",
          "block.minecraft.light_blue_carpet",
          "block.minecraft.light_gray_carpet",
          "block.minecraft.lime_carpet",
          "block.minecraft.magenta_carpet",
          "block.minecraft.orange_carpet",
          "block.minecraft.pink_carpet",
          "block.minecraft.purple_carpet",
          "block.minecraft.red_carpet",
          "block.minecraft.white_carpet"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.black_concrete_powder",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.black_dye"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.gravel"
        ],
        [
          "block.minecraft.gravel"
        ],
        [
          "block.minecraft.gravel"
        ],
        [
          "block.minecraft.gravel"
        ]
      ]
    },
    {
      "output": "block.minecraft.blue_concrete_powder",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.blue_dye"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.gravel"
        ],
        [
          "block.minecraft.gravel"
        ],
        [
          "block.minecraft.gravel"
        ],
        [
          "block.minecraft.gravel"
        ]
      ]
    },
    {
      "output": "block.minecraft.brown_concrete_powder",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.brown_dye"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.gravel"
        ],
        [
          "block.minecraft.gravel"
        ],
        [
          "block.minecraft.gravel"
        ],
        [
          "block.minecraft.gravel"
        ]
      ]
    },
    {
      "output": "block.minecraft.cyan_concrete_powder",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.cyan_dye"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.gravel"
        ],
        [
          "block.minecraft.gravel"
        ],
        [
          "block.minecraft.gravel"
        ],
        [
          "block.minecraft.gravel"
        ]
      ]
    },
    {
      "output": "block.minecraft.gray_concrete_powder",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.gray_dye"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.gravel"
        ],
        [
          "block.minecraft.gravel"
        ],
        [
          "block.minecraft.gravel"
        ],
        [
          "block.minecraft.gravel"
        ]
      ]
    },
    {
      "output": "block.minecraft.green_concrete_powder",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.green_dye"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.gravel"
        ],
        [
          "block.minecraft.gravel"
        ],
        [
          "block.minecraft.gravel"
        ],
        [
          "block.minecraft.gravel"
        ]
      ]
    },
    {
      "output": "block.minecraft.light_blue_concrete_powder",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.light_blue_dye"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.gravel"
        ],
        [
          "block.minecraft.gravel"
        ],
        [
          "block.minecraft.gravel"
        ],
        [
          "block.minecraft.gravel"
        ]
      ]
    },
    {
      "output": "block.minecraft.light_gray_concrete_powder",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.light_gray_dye"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.gravel"
        ],
        [
          "block.minecraft.gravel"
        ],
        [
          "block.minecraft.gravel"
        ],
        [
          "block.minecraft.gravel"
        ]
      ]
    },
    {
      "output": "block.minecraft.lime_concrete_powder",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.lime_dye"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.gravel"
        ],
        [
          "block.minecraft.gravel"
        ],
        [
          "block.minecraft.gravel"
        ],
        [
          "block.minecraft.gravel"
        ]
      ]
    },
    {
      "output": "block.minecraft.magenta_concrete_powder",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.magenta_dye"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.gravel"
        ],
        [
          "block.minecraft.gravel"
        ],
        [
          "block.minecraft.gravel"
        ],
        [
          "block.minecraft.gravel"
        ]
      ]
    },
    {
      "output": "block.minecraft.orange_concrete_powder",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.orange_dye"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.gravel"
        ],
        [
          "block.minecraft.gravel"
        ],
        [
          "block.minecraft.gravel"
        ],
        [
          "block.minecraft.gravel"
        ]
      ]
    },
    {
      "output": "block.minecraft.pink_concrete_powder",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.pink_dye"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.gravel"
        ],
        [
          "block.minecraft.gravel"
        ],
        [
          "block.minecraft.gravel"
        ],
        [
          "block.minecraft.gravel"
        ]
      ]
    },
    {
      "output": "block.minecraft.purple_concrete_powder",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.purple_dye"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.gravel"
        ],
        [
          "block.minecraft.gravel"
        ],
        [
          "block.minecraft.gravel"
        ],
        [
          "block.minecraft.gravel"
        ]
      ]
    },
    {
      "output": "block.minecraft.red_concrete_powder",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.red_dye"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.gravel"
        ],
        [
          "block.minecraft.gravel"
        ],
        [
          "block.minecraft.gravel"
        ],
        [
          "block.minecraft.gravel"
        ]
      ]
    },
    {
      "output": "block.minecraft.white_concrete_powder",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.white_dye"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.gravel"
        ],
        [
          "block.minecraft.gravel"
        ],
        [
          "block.minecraft.gravel"
        ],
        [
          "block.minecraft.gravel"
        ]
      ]
    },
    {
      "output": "block.minecraft.yellow_concrete_powder",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.yellow_dye"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.gravel"
        ],
        [
          "block.minecraft.gravel"
        ],
        [
          "block.minecraft.gravel"
        ],
        [
          "block.minecraft.gravel"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.black_stained_glass",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "item.minecraft.black_dye"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ]
      ]
    },
    {
      "output": "block.minecraft.blue_stained_glass",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "item.minecraft.blue_dye"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ]
      ]
    },
    {
      "output": "block.minecraft.brown_stained_glass",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "item.minecraft.brown_dye"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ]
      ]
    },
    {
      "output": "block.minecraft.cyan_stained_glass",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "item.minecraft.cyan_dye"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ]
      ]
    },
    {
      "output": "block.minecraft.gray_stained_glass",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "item.minecraft.gray_dye"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ]
      ]
    },
    {
      "output": "block.minecraft.green_stained_glass",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "item.minecraft.green_dye"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ]
      ]
    },
    {
      "output": "block.minecraft.light_blue_stained_glass",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "item.minecraft.light_blue_dye"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ]
      ]
    },
    {
      "output": "block.minecraft.light_gray_stained_glass",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "item.minecraft.light_gray_dye"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ]
      ]
    },
    {
      "output": "block.minecraft.lime_stained_glass",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "item.minecraft.lime_dye"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ]
      ]
    },
    {
      "output": "block.minecraft.magenta_stained_glass",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "item.minecraft.magenta_dye"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ]
      ]
    },
    {
      "output": "block.minecraft.orange_stained_glass",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "item.minecraft.orange_dye"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ]
      ]
    },
    {
      "output": "block.minecraft.pink_stained_glass",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "item.minecraft.pink_dye"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ]
      ]
    },
    {
      "output": "block.minecraft.purple_stained_glass",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "item.minecraft.purple_dye"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ]
      ]
    },
    {
      "output": "block.minecraft.red_stained_glass",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "item.minecraft.red_dye"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ]
      ]
    },
    {
      "output": "block.minecraft.white_stained_glass",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "item.minecraft.white_dye"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ]
      ]
    },
    {
      "output": "block.minecraft.yellow_stained_glass",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "item.minecraft.yellow_dye"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.black_stained_glass_pane",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.black_stained_glass"
        ],
        [
          "block.minecraft.black_stained_glass"
        ],
        [
          "block.minecraft.black_stained_glass"
        ],
        [
          "block.minecraft.black_stained_glass"
        ],
        [
          "block.minecraft.black_stained_glass"
        ],
        [
          "block.minecraft.black_stained_glass"
        ]
      ]
    },
    {
      "output": "block.minecraft.black_stained_glass_pane",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "item.minecraft.black_dye"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ]
      ]
    },
    {
      "output": "block.minecraft.blue_stained_glass_pane",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.blue_stained_glass"
        ],
        [
          "block.minecraft.blue_stained_glass"
        ],
        [
          "block.minecraft.blue_stained_glass"
        ],
        [
          "block.minecraft.blue_stained_glass"
        ],
        [
          "block.minecraft.blue_stained_glass"
        ],
        [
          "block.minecraft.blue_stained_glass"
        ]
      ]
    },
    {
      "output": "block.minecraft.blue_stained_glass_pane",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "item.minecraft.blue_dye"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ]
      ]
    },
    {
      "output": "block.minecraft.brown_stained_glass_pane",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.brown_stained_glass"
        ],
        [
          "block.minecraft.brown_stained_glass"
        ],
        [
          "block.minecraft.brown_stained_glass"
        ],
        [
          "block.minecraft.brown_stained_glass"
        ],
        [
          "block.minecraft.brown_stained_glass"
        ],
        [
          "block.minecraft.brown_stained_glass"
        ]
      ]
    },
    {
      "output": "block.minecraft.brown_stained_glass_pane",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "item.minecraft.brown_dye"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ]
      ]
    },
    {
      "output": "block.minecraft.cyan_stained_glass_pane",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.cyan_stained_glass"
        ],
        [
          "block.minecraft.cyan_stained_glass"
        ],
        [
          "block.minecraft.cyan_stained_glass"
        ],
        [
          "block.minecraft.cyan_stained_glass"
        ],
        [
          "block.minecraft.cyan_stained_glass"
        ],
        [
          "block.minecraft.cyan_stained_glass"
        ]
      ]
    },
    {
      "output": "block.minecraft.cyan_stained_glass_pane",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "item.minecraft.cyan_dye"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ]
      ]
    },
    {
      "output": "block.minecraft.gray_stained_glass_pane",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.gray_stained_glass"
        ],
        [
          "block.minecraft.gray_stained_glass"
        ],
        [
          "block.minecraft.gray_stained_glass"
        ],
        [
          "block.minecraft.gray_stained_glass"
        ],
        [
          "block.minecraft.gray_stained_glass"
        ],
        [
          "block.minecraft.gray_stained_glass"
        ]
      ]
    },
    {
      "output": "block.minecraft.gray_stained_glass_pane",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "item.minecraft.gray_dye"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ]
      ]
    },
    {
      "output": "block.minecraft.green_stained_glass_pane",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.green_stained_glass"
        ],
        [
          "block.minecraft.green_stained_glass"
        ],
        [
          "block.minecraft.green_stained_glass"
        ],
        [
          "block.minecraft.green_stained_glass"
        ],
        [
          "block.minecraft.green_stained_glass"
        ],
        [
          "block.minecraft.green_stained_glass"
        ]
      ]
    },
    {
      "output": "block.minecraft.green_stained_glass_pane",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "item.minecraft.green_dye"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ]
      ]
    },
    {
      "output": "block.minecraft.light_blue_stained_glass_pane",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.light_blue_stained_glass"
        ],
        [
          "block.minecraft.light_blue_stained_glass"
        ],
        [
          "block.minecraft.light_blue_stained_glass"
        ],
        [
          "block.minecraft.light_blue_stained_glass"
        ],
        [
          "block.minecraft.light_blue_stained_glass"
        ],
        [
          "block.minecraft.light_blue_stained_glass"
        ]
      ]
    },
    {
      "output": "block.minecraft.light_blue_stained_glass_pane",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "item.minecraft.light_blue_dye"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ]
      ]
    },
    {
      "output": "block.minecraft.light_gray_stained_glass_pane",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.light_gray_stained_glass"
        ],
        [
          "block.minecraft.light_gray_stained_glass"
        ],
        [
          "block.minecraft.light_gray_stained_glass"
        ],
        [
          "block.minecraft.light_gray_stained_glass"
        ],
        [
          "block.minecraft.light_gray_stained_glass"
        ],
        [
          "block.minecraft.light_gray_stained_glass"
        ]
      ]
    },
    {
      "output": "block.minecraft.light_gray_stained_glass_pane",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "item.minecraft.light_gray_dye"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ]
      ]
    },
    {
      "output": "block.minecraft.lime_stained_glass_pane",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.lime_stained_glass"
        ],
        [
          "block.minecraft.lime_stained_glass"
        ],
        [
          "block.minecraft.lime_stained_glass"
        ],
        [
          "block.minecraft.lime_stained_glass"
        ],
        [
          "block.minecraft.lime_stained_glass"
        ],
        [
          "block.minecraft.lime_stained_glass"
        ]
      ]
    },
    {
      "output": "block.minecraft.lime_stained_glass_pane",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "item.minecraft.lime_dye"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ]
      ]
    },
    {
      "output": "block.minecraft.magenta_stained_glass_pane",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.magenta_stained_glass"
        ],
        [
          "block.minecraft.magenta_stained_glass"
        ],
        [
          "block.minecraft.magenta_stained_glass"
        ],
        [
          "block.minecraft.magenta_stained_glass"
        ],
        [
          "block.minecraft.magenta_stained_glass"
        ],
        [
          "block.minecraft.magenta_stained_glass"
        ]
      ]
    },
    {
      "output": "block.minecraft.magenta_stained_glass_pane",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "item.minecraft.magenta_dye"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ]
      ]
    },
    {
      "output": "block.minecraft.orange_stained_glass_pane",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.orange_stained_glass"
        ],
        [
          "block.minecraft.orange_stained_glass"
        ],
        [
          "block.minecraft.orange_stained_glass"
        ],
        [
          "block.minecraft.orange_stained_glass"
        ],
        [
          "block.minecraft.orange_stained_glass"
        ],
        [
          "block.minecraft.orange_stained_glass"
        ]
      ]
    },
    {
      "output": "block.minecraft.orange_stained_glass_pane",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "item.minecraft.orange_dye"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ]
      ]
    },
    {
      "output": "block.minecraft.pink_stained_glass_pane",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.pink_stained_glass"
        ],
        [
          "block.minecraft.pink_stained_glass"
        ],
        [
          "block.minecraft.pink_stained_glass"
        ],
        [
          "block.minecraft.pink_stained_glass"
        ],
        [
          "block.minecraft.pink_stained_glass"
        ],
        [
          "block.minecraft.pink_stained_glass"
        ]
      ]
    },
    {
      "output": "block.minecraft.pink_stained_glass_pane",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "item.minecraft.pink_dye"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ]
      ]
    },
    {
      "output": "block.minecraft.purple_stained_glass_pane",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.purple_stained_glass"
        ],
        [
          "block.minecraft.purple_stained_glass"
        ],
        [
          "block.minecraft.purple_stained_glass"
        ],
        [
          "block.minecraft.purple_stained_glass"
        ],
        [
          "block.minecraft.purple_stained_glass"
        ],
        [
          "block.minecraft.purple_stained_glass"
        ]
      ]
    },
    {
      "output": "block.minecraft.purple_stained_glass_pane",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "item.minecraft.purple_dye"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ]
      ]
    },
    {
      "output": "block.minecraft.red_stained_glass_pane",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.red_stained_glass"
        ],
        [
          "block.minecraft.red_stained_glass"
        ],
        [
          "block.minecraft.red_stained_glass"
        ],
        [
          "block.minecraft.red_stained_glass"
        ],
        [
          "block.minecraft.red_stained_glass"
        ],
        [
          "block.minecraft.red_stained_glass"
        ]
      ]
    },
    {
      "output": "block.minecraft.red_stained_glass_pane",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "item.minecraft.red_dye"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ]
      ]
    },
    {
      "output": "block.minecraft.white_stained_glass_pane",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.white_stained_glass"
        ],
        [
          "block.minecraft.white_stained_glass"
        ],
        [
          "block.minecraft.white_stained_glass"
        ],
        [
          "block.minecraft.white_stained_glass"
        ],
        [
          "block.minecraft.white_stained_glass"
        ],
        [
          "block.minecraft.white_stained_glass"
        ]
      ]
    },
    {
      "output": "block.minecraft.white_stained_glass_pane",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "item.minecraft.white_dye"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ]
      ]
    },
    {
      "output": "block.minecraft.yellow_stained_glass_pane",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.yellow_stained_glass"
        ],
        [
          "block.minecraft.yellow_stained_glass"
        ],
        [
          "block.minecraft.yellow_stained_glass"
        ],
        [
          "block.minecraft.yellow_stained_glass"
        ],
        [
          "block.minecraft.yellow_stained_glass"
        ],
        [
          "block.minecraft.yellow_stained_glass"
        ]
      ]
    },
    {
      "output": "block.minecraft.yellow_stained_glass_pane",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "item.minecraft.yellow_dye"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ],
        [
          "block.minecraft.glass_pane"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.black_terracotta",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "item.minecraft.black_dye"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ]
      ]
    },
    {
      "output": "block.minecraft.blue_terracotta",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "item.minecraft.blue_dye"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ]
      ]
    },
    {
      "output": "block.minecraft.brown_terracotta",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "item.minecraft.brown_dye"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ]
      ]
    },
    {
      "output": "block.minecraft.cyan_terracotta",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "item.minecraft.cyan_dye"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ]
      ]
    },
    {
      "output": "block.minecraft.gray_terracotta",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "item.minecraft.gray_dye"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ]
      ]
    },
    {
      "output": "block.minecraft.green_terracotta",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "item.minecraft.green_dye"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ]
      ]
    },
    {
      "output": "block.minecraft.light_blue_terracotta",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "item.minecraft.light_blue_dye"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ]
      ]
    },
    {
      "output": "block.minecraft.light_gray_terracotta",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "item.minecraft.light_gray_dye"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ]
      ]
    },
    {
      "output": "block.minecraft.lime_terracotta",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "item.minecraft.lime_dye"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ]
      ]
    },
    {
      "output": "block.minecraft.magenta_terracotta",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "item.minecraft.magenta_dye"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ]
      ]
    },
    {
      "output": "block.minecraft.orange_terracotta",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "item.minecraft.orange_dye"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ]
      ]
    },
    {
      "output": "block.minecraft.pink_terracotta",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "item.minecraft.pink_dye"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ]
      ]
    },
    {
      "output": "block.minecraft.purple_terracotta",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "item.minecraft.purple_dye"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ]
      ]
    },
    {
      "output": "block.minecraft.red_terracotta",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "item.minecraft.red_dye"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ]
      ]
    },
    {
      "output": "block.minecraft.white_terracotta",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "item.minecraft.white_dye"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ]
      ]
    },
    {
      "output": "block.minecraft.yellow_terracotta",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "item.minecraft.yellow_dye"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "block.minecraft.terracotta"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.black_wool",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.black_dye"
        ],
        [
          "block.minecraft.blue_wool",
          "block.minecraft.brown_wool",
          "block.minecraft.cyan_wool",
          "block.minecraft.gray_wool",
          "block.minecraft.green_wool",
          "block.minecraft.light_blue_wool",
          "block.minecraft.light_gray_wool",
          "block.minecraft.lime_wool",
          "block.minecraft.magenta_wool",
          "block.minecraft.orange_wool",
          "block.minecraft.pink_wool",
          "block.minecraft.purple_wool",
          "block.minecraft.red_wool",
          "block.minecraft.white_wool",
          "block.minecraft.yellow_wool"
        ]
      ]
    },
    {
      "output": "block.minecraft.blue_wool",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.blue_dye"
        ],
        [
          "block.minecraft.black_wool",
          "block.minecraft.brown_wool",
          "block.minecraft.cyan_wool",
          "block.minecraft.gray_wool",
          "block.minecraft.green_wool",
          "block.minecraft.light_blue_wool",
          "block.minecraft.light_gray_wool",
          "block.minecraft.lime_wool",
          "block.minecraft.magenta_wool",
          "block.minecraft.orange_wool",
          "block.minecraft.pink_wool",
          "block.minecraft.purple_wool",
          "block.minecraft.red_wool",
          "block.minecraft.white_wool",
          "block.minecraft.yellow_wool"
        ]
      ]
    },
    {
      "output": "block.minecraft.brown_wool",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.brown_dye"
        ],
        [
          "block.minecraft.black_wool",
          "block.minecraft.blue_wool",
          "block.minecraft.cyan_wool",
          "block.minecraft.gray_wool",
          "block.minecraft.green_wool",
          "block.minecraft.light_blue_wool",
          "block.minecraft.light_gray_wool",
          "block.minecraft.lime_wool",
          "block.minecraft.magenta_wool",
          "block.minecraft.orange_wool",
          "block.minecraft.pink_wool",
          "block.minecraft.purple_wool",
          "block.minecraft.red_wool",
          "block.minecraft.white_wool",
          "block.minecraft.yellow_wool"
        ]
      ]
    },
    {
      "output": "block.minecraft.cyan_wool",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.cyan_dye"
        ],
        [
          "block.minecraft.black_wool",
          "block.minecraft.blue_wool",
          "block.minecraft.brown_wool",
          "block.minecraft.gray_wool",
          "block.minecraft.green_wool",
          "block.minecraft.light_blue_wool",
          "block.minecraft.light_gray_wool",
          "block.minecraft.lime_wool",
          "block.minecraft.magenta_wool",
          "block.minecraft.orange_wool",
          "block.minecraft.pink_wool",
          "block.minecraft.purple_wool",
          "block.minecraft.red_wool",
          "block.minecraft.white_wool",
          "block.minecraft.yellow_wool"
        ]
      ]
    },
    {
      "output": "block.minecraft.gray_wool",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.gray_dye"
        ],
        [
          "block.minecraft.black_wool",
          "block.minecraft.blue_wool",
          "block.minecraft.brown_wool",
          "block.minecraft.cyan_wool",
          "block.minecraft.green_wool",
          "block.minecraft.light_blue_wool",
          "block.minecraft.light_gray_wool",
          "block.minecraft.lime_wool",
          "block.minecraft.magenta_wool",
          "block.minecraft.orange_wool",
          "block.minecraft.pink_wool",
          "block.minecraft.purple_wool",
          "block.minecraft.red_wool",
          "block.minecraft.white_wool",
          "block.minecraft.yellow_wool"
        ]
      ]
    },
    {
      "output": "block.minecraft.green_wool",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.green_dye"
        ],
        [
          "block.minecraft.black_wool",
          "block.minecraft.blue_wool",
          "block.minecraft.brown_wool",
          "block.minecraft.cyan_wool",
          "block.minecraft.gray_wool",
          "block.minecraft.light_blue_wool",
          "block.minecraft.light_gray_wool",
          "block.minecraft.lime_wool",
          "block.minecraft.magenta_wool",
          "block.minecraft.orange_wool",
          "block.minecraft.pink_wool",
          "block.minecraft.purple_wool",
          "block.minecraft.red_wool",
          "block.minecraft.white_wool",
          "block.minecraft.yellow_wool"
        ]
      ]
    },
    {
      "output": "block.minecraft.light_blue_wool",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.light_blue_dye"
        ],
        [
          "block.minecraft.black_wool",
          "block.minecraft.blue_wool",
          "block.minecraft.brown_wool",
          "block.minecraft.cyan_wool",
          "block.minecraft.gray_wool",
          "block.minecraft.green_wool",
          "block.minecraft.light_gray_wool",
          "block.minecraft.lime_wool",
          "block.minecraft.magenta_wool",
          "block.minecraft.orange_wool",
          "block.minecraft.pink_wool",
          "block.minecraft.purple_wool",
          "block.minecraft.red_wool",
          "block.minecraft.white_wool",
          "block.minecraft.yellow_wool"
        ]
      ]
    },
    {
      "output": "block.minecraft.light_gray_wool",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.light_gray_dye"
        ],
        [
          "block.minecraft.black_wool",
          "block.minecraft.blue_wool",
          "block.minecraft.brown_wool",
          "block.minecraft.cyan_wool",
          "block.minecraft.gray_wool",
          "block.minecraft.green_wool",
          "block.minecraft.light_blue_wool",
          "block.minecraft.lime_wool",
          "block.minecraft.magenta_wool",
          "block.minecraft.orange_wool",
          "block.minecraft.pink_wool",
          "block.minecraft.purple_wool",
          "block.minecraft.red_wool",
          "block.minecraft.white_wool",
          "block.minecraft.yellow_wool"
        ]
      ]
    },
    {
      "output": "block.minecraft.lime_wool",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.lime_dye"
        ],
        [
          "block.minecraft.black_wool",
          "block.minecraft.blue_wool",
          "block.minecraft.brown_wool",
          "block.minecraft.cyan_wool",
          "block.minecraft.gray_wool",
          "block.minecraft.green_wool",
          "block.minecraft.light_blue_wool",
          "block.minecraft.light_gray_wool",
          "block.minecraft.magenta_wool",
          "block.minecraft.orange_wool",
          "block.minecraft.pink_wool",
          "block.minecraft.purple_wool",
          "block.minecraft.red_wool",
          "block.minecraft.white_wool",
          "block.minecraft.yellow_wool"
        ]
      ]
    },
    {
      "output": "block.minecraft.magenta_wool",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.magenta_dye"
        ],
        [
          "block.minecraft.black_wool",
          "block.minecraft.blue_wool",
          "block.minecraft.brown_wool",
          "block.minecraft.cyan_wool",
          "block.minecraft.gray_wool",
          "block.minecraft.green_wool",
          "block.minecraft.light_blue_wool",
          "block.minecraft.light_gray_wool",
          "block.minecraft.lime_wool",
          "block.minecraft.orange_wool",
          "block.minecraft.pink_wool",
          "block.minecraft.purple_wool",
          "block.minecraft.red_wool",
          "block.minecraft.white_wool",
          "block.minecraft.yellow_wool"
        ]
      ]
    },
    {
      "output": "block.minecraft.orange_wool",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.orange_dye"
        ],
        [
          "block.minecraft.black_wool",
          "block.minecraft.blue_wool",
          "block.minecraft.brown_wool",
          "block.minecraft.cyan_wool",
          "block.minecraft.gray_wool",
          "block.minecraft.green_wool",
          "block.minecraft.light_blue_wool",
          "block.minecraft.light_gray_wool",
          "block.minecraft.lime_wool",
          "block.minecraft.magenta_wool",
          "block.minecraft.pink_wool",
          "block.minecraft.purple_wool",
          "block.minecraft.red_wool",
          "block.minecraft.white_wool",
          "block.minecraft.yellow_wool"
        ]
      ]
    },
    {
      "output": "block.minecraft.pink_wool",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.pink_dye"
        ],
        [
          "block.minecraft.black_wool",
          "block.minecraft.blue_wool",
          "block.minecraft.brown_wool",
          "block.minecraft.cyan_wool",
          "block.minecraft.gray_wool",
          "block.minecraft.green_wool",
          "block.minecraft.light_blue_wool",
          "block.minecraft.light_gray_wool",
          "block.minecraft.lime_wool",
          "block.minecraft.magenta_wool",
          "block.minecraft.orange_wool",
          "block.minecraft.purple_wool",
          "block.minecraft.red_wool",
          "block.minecraft.white_wool",
          "block.minecraft.yellow_wool"
        ]
      ]
    },
    {
      "output": "block.minecraft.purple_wool",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.purple_dye"
        ],
        [
          "block.minecraft.black_wool",
          "block.minecraft.blue_wool",
          "block.minecraft.brown_wool",
          "block.minecraft.cyan_wool",
          "block.minecraft.gray_wool",
          "block.minecraft.green_wool",
          "block.minecraft.light_blue_wool",
          "block.minecraft.light_gray_wool",
          "block.minecraft.lime_wool",
          "block.minecraft.magenta_wool",
          "block.minecraft.orange_wool",
          "block.minecraft.pink_wool",
          "block.minecraft.red_wool",
          "block.minecraft.white_wool",
          "block.minecraft.yellow_wool"
        ]
      ]
    },
    {
      "output": "block.minecraft.red_wool",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.red_dye"
        ],
        [
          "block.minecraft.black_wool",
          "block.minecraft.blue_wool",
          "block.minecraft.brown_wool",
          "block.minecraft.cyan_wool",
          "block.minecraft.gray_wool",
          "block.minecraft.green_wool",
          "block.minecraft.light_blue_wool",
          "block.minecraft.light_gray_wool",
          "block.minecraft.lime_wool",
          "block.minecraft.magenta_wool",
          "block.minecraft.orange_wool",
          "block.minecraft.pink_wool",
          "block.minecraft.purple_wool",
          "block.minecraft.white_wool",
          "block.minecraft.yellow_wool"
        ]
      ]
    },
    {
      "output": "block.minecraft.white_wool",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.white_dye"
        ],
        [
          "block.minecraft.black_wool",
          "block.minecraft.blue_wool",
          "block.minecraft.brown_wool",
          "block.minecraft.cyan_wool",
          "block.minecraft.gray_wool",
          "block.minecraft.green_wool",
          "block.minecraft.light_blue_wool",
          "block.minecraft.light_gray_wool",
          "block.minecraft.lime_wool",
          "block.minecraft.magenta_wool",
          "block.minecraft.orange_wool",
          "block.minecraft.pink_wool",
          "block.minecraft.purple_wool",
          "block.minecraft.red_wool",
          "block.minecraft.yellow_wool"
        ]
      ]
    },
    {
      "output": "block.minecraft.yellow_wool",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.yellow_dye"
        ],
        [
          "block.minecraft.black_wool",
          "block.minecraft.blue_wool",
          "block.minecraft.brown_wool",
          "block.minecraft.cyan_wool",
          "block.minecraft.gray_wool",
          "block.minecraft.green_wool",
          "block.minecraft.light_blue_wool",
          "block.minecraft.light_gray_wool",
          "block.minecraft.lime_wool",
          "block.minecraft.magenta_wool",
          "block.minecraft.orange_wool",
          "block.minecraft.pink_wool",
          "block.minecraft.purple_wool",
          "block.minecraft.red_wool",
          "block.minecraft.white_wool"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.blackstone_slab",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.blackstone"
        ],
        [
          "block.minecraft.blackstone"
        ],
        [
          "block.minecraft.blackstone"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.blackstone_stairs",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.blackstone"
        ],
        [
          "block.minecraft.blackstone"
        ],
        [
          "block.minecraft.blackstone"
        ],
        [
          "block.minecraft.blackstone"
        ],
        [
          "block.minecraft.blackstone"
        ],
        [
          "block.minecraft.blackstone"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.blackstone_wall",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.blackstone"
        ],
        [
          "block.minecraft.blackstone"
        ],
        [
          "block.minecraft.blackstone"
        ],
        [
          "block.minecraft.blackstone"
        ],
        [
          "block.minecraft.blackstone"
        ],
        [
          "block.minecraft.blackstone"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.blast_furnace",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "block.minecraft.furnace"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "block.minecraft.smooth_stone"
        ],
        [
          "block.minecraft.smooth_stone"
        ],
        [
          "block.minecraft.smooth_stone"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.blue_ice",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.packed_ice"
        ],
        [
          "block.minecraft.packed_ice"
        ],
        [
          "block.minecraft.packed_ice"
        ],
        [
          "block.minecraft.packed_ice"
        ],
        [
          "block.minecraft.packed_ice"
        ],
        [
          "block.minecraft.packed_ice"
        ],
        [
          "block.minecraft.packed_ice"
        ],
        [
          "block.minecraft.packed_ice"
        ],
        [
          "block.minecraft.packed_ice"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.bone_block",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.bone_meal"
        ],
        [
          "item.minecraft.bone_meal"
        ],
        [
          "item.minecraft.bone_meal"
        ],
        [
          "item.minecraft.bone_meal"
        ],
        [
          "item.minecraft.bone_meal"
        ],
        [
          "item.minecraft.bone_meal"
        ],
        [
          "item.minecraft.bone_meal"
        ],
        [
          "item.minecraft.bone_meal"
        ],
        [
          "item.minecraft.bone_meal"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.bookshelf",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "item.minecraft.book"
        ],
        [
          "item.minecraft.book"
        ],
        [
          "item.minecraft.book"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.brewing_stand",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.blaze_rod"
        ],
        [
          "block.minecraft.blackstone",
          "block.minecraft.cobbled_deepslate",
          "block.minecraft.cobblestone"
        ],
        [
          "block.minecraft.blackstone",
          "block.minecraft.cobbled_deepslate",
          "block.minecraft.cobblestone"
        ],
        [
          "block.minecraft.blackstone",
          "block.minecraft.cobbled_deepslate",
          "block.minecraft.cobblestone"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.brick_slab",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.bricks"
        ],
        [
          "block.minecraft.bricks"
        ],
        [
          "block.minecraft.bricks"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.brick_stairs",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.bricks"
        ],
        [
          "block.minecraft.bricks"
        ],
        [
          "block.minecraft.bricks"
        ],
        [
          "block.minecraft.bricks"
        ],
        [
          "block.minecraft.bricks"
        ],
        [
          "block.minecraft.bricks"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.brick_wall",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.bricks"
        ],
        [
          "block.minecraft.bricks"
        ],
        [
          "block.minecraft.bricks"
        ],
        [
          "block.minecraft.bricks"
        ],
        [
          "block.minecraft.bricks"
        ],
        [
          "block.minecraft.bricks"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.bricks",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.brick"
        ],
        [
          "item.minecraft.brick"
        ],
        [
          "item.minecraft.brick"
        ],
        [
          "item.minecraft.brick"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.cake",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.milk_bucket"
        ],
        [
          "item.minecraft.milk_bucket"
        ],
        [
          "item.minecraft.milk_bucket"
        ],
        [
          "item.minecraft.sugar"
        ],
        [
          "item.minecraft.blue_egg",
          "item.minecraft.brown_egg",
          "item.minecraft.egg"
        ],
        [
          "item.minecraft.sugar"
        ],
        [
          "item.minecraft.wheat"
        ],
        [
          "item.minecraft.wheat"
        ],
        [
          "item.minecraft.wheat"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.calibrated_sculk_sensor",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.amethyst_shard"
        ],
        [
          "item.minecraft.amethyst_shard"
        ],
        [
          "block.minecraft.sculk_sensor"
        ],
        [
          "item.minecraft.amethyst_shard"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.campfire",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.charcoal",
          "item.minecraft.coal"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "block.minecraft.acacia_log",
          "block.minecraft.acacia_wood",
          "block.minecraft.birch_log",
          "block.minecraft.birch_wood",
          "block.minecraft.cherry_log",
          "block.minecraft.cherry_wood",
          "block.minecraft.crimson_hyphae",
          "block.minecraft.crimson_stem",
          "block.minecraft.dark_oak_log",
          "block.minecraft.dark_oak_wood",
          "block.minecraft.jungle_log",
          "block.minecraft.jungle_wood",
          "block.minecraft.mangrove_log",
          "block.minecraft.mangrove_wood",
          "block.minecraft.oak_log",
          "block.minecraft.oak_wood",
          "block.minecraft.pale_oak_log",
          "block.minecraft.pale_oak_wood",
          "block.minecraft.spruce_log",
          "block.minecraft.spruce_wood",
          "block.minecraft.stripped_acacia_log",
          "block.minecraft.stripped_acacia_wood",
          "block.minecraft.stripped_birch_log",
          "block.minecraft.stripped_birch_wood",
          "block.minecraft.stripped_cherry_log",
          "block.minecraft.stripped_cherry_wood",
          "block.minecraft.stripped_crimson_hyphae",
          "block.minecraft.stripped_crimson_stem",
          "block.minecraft.stripped_dark_oak_log",
          "block.minecraft.stripped_dark_oak_wood",
          "block.minecraft.stripped_jungle_log",
          "block.minecraft.stripped_jungle_wood",
          "block.minecraft.stripped_mangrove_log",
          "block.minecraft.stripped_mangrove_wood",
          "block.minecraft.stripped_oak_log",
          "block.minecraft.stripped_oak_wood",
          "block.minecraft.stripped_pale_oak_log",
          "block.minecraft.stripped_pale_oak_wood",
          "block.minecraft.stripped_spruce_log",
          "block.minecraft.stripped_spruce_wood",
          "block.minecraft.stripped_warped_hyphae",
          "block.minecraft.stripped_warped_stem",
          "block.minecraft.warped_hyphae",
          "block.minecraft.warped_stem"
        ],
        [
          "block.minecraft.acacia_log",
          "block.minecraft.acacia_wood",
          "block.minecraft.birch_log",
          "block.minecraft.birch_wood",
          "block.minecraft.cherry_log",
          "block.minecraft.cherry_wood",
          "block.minecraft.crimson_hyphae",
          "block.minecraft.crimson_stem",
          "block.minecraft.dark_oak_log",
          "block.minecraft.dark_oak_wood",
          "block.minecraft.jungle_log",
          "block.minecraft.jungle_wood",
          "block.minecraft.mangrove_log",
          "block.minecraft.mangrove_wood",
          "block.minecraft.oak_log",
          "block.minecraft.oak_wood",
          "block.minecraft.pale_oak_log",
          "block.minecraft.pale_oak_wood",
          "block.minecraft.spruce_log",
          "block.minecraft.spruce_wood",
          "block.minecraft.stripped_acacia_log",
          "block.minecraft.stripped_acacia_wood",
          "block.minecraft.stripped_birch_log",
          "block.minecraft.stripped_birch_wood",
          "block.minecraft.stripped_cherry_log",
          "block.minecraft.stripped_cherry_wood",
          "block.minecraft.stripped_crimson_hyphae",
          "block.minecraft.stripped_crimson_stem",
          "block.minecraft.stripped_dark_oak_log",
          "block.minecraft.stripped_dark_oak_wood",
          "block.minecraft.stripped_jungle_log",
          "block.minecraft.stripped_jungle_wood",
          "block.minecraft.stripped_mangrove_log",
          "block.minecraft.stripped_mangrove_wood",
          "block.minecraft.stripped_oak_log",
          "block.minecraft.stripped_oak_wood",
          "block.minecraft.stripped_pale_oak_log",
          "block.minecraft.stripped_pale_oak_wood",
          "block.minecraft.stripped_spruce_log",
          "block.minecraft.stripped_spruce_wood",
          "block.minecraft.stripped_warped_hyphae",
          "block.minecraft.stripped_warped_stem",
          "block.minecraft.warped_hyphae",
          "block.minecraft.warped_stem"
        ],
        [
          "block.minecraft.acacia_log",
          "block.minecraft.acacia_wood",
          "block.minecraft.birch_log",
          "block.minecraft.birch_wood",
          "block.minecraft.cherry_log",
          "block.minecraft.cherry_wood",
          "block.minecraft.crimson_hyphae",
          "block.minecraft.crimson_stem",
          "block.minecraft.dark_oak_log",
          "block.minecraft.dark_oak_wood",
          "block.minecraft.jungle_log",
          "block.minecraft.jungle_wood",
          "block.minecraft.mangrove_log",
          "block.minecraft.mangrove_wood",
          "block.minecraft.oak_log",
          "block.minecraft.oak_wood",
          "block.minecraft.pale_oak_log",
          "block.minecraft.pale_oak_wood",
          "block.minecraft.spruce_log",
          "block.minecraft.spruce_wood",
          "block.minecraft.stripped_acacia_log",
          "block.minecraft.stripped_acacia_wood",
          "block.minecraft.stripped_birch_log",
          "block.minecraft.stripped_birch_wood",
          "block.minecraft.stripped_cherry_log",
          "block.minecraft.stripped_cherry_wood",
          "block.minecraft.stripped_crimson_hyphae",
          "block.minecraft.stripped_crimson_stem",
          "block.minecraft.stripped_dark_oak_log",
          "block.minecraft.stripped_dark_oak_wood",
          "block.minecraft.stripped_jungle_log",
          "block.minecraft.stripped_jungle_wood",
          "block.minecraft.stripped_mangrove_log",
          "block.minecraft.stripped_mangrove_wood",
          "block.minecraft.stripped_oak_log",
          "block.minecraft.stripped_oak_wood",
          "block.minecraft.stripped_pale_oak_log",
          "block.minecraft.stripped_pale_oak_wood",
          "block.minecraft.stripped_spruce_log",
          "block.minecraft.stripped_spruce_wood",
          "block.minecraft.stripped_warped_hyphae",
          "block.minecraft.stripped_warped_stem",
          "block.minecraft.warped_hyphae",
          "block.minecraft.warped_stem"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.candle",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.string"
        ],
        [
          "item.minecraft.honeycomb"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.cartography_table",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.paper"
        ],
        [
          "item.minecraft.paper"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.cauldron",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.chest",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.chiseled_bookshelf",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.acacia_slab",
          "block.minecraft.bamboo_slab",
          "block.minecraft.birch_slab",
          "block.minecraft.cherry_slab",
          "block.minecraft.crimson_slab",
          "block.minecraft.dark_oak_slab",
          "block.minecraft.jungle_slab",
          "block.minecraft.mangrove_slab",
          "block.minecraft.oak_slab",
          "block.minecraft.pale_oak_slab",
          "block.minecraft.spruce_slab",
          "block.minecraft.warped_slab"
        ],
        [
          "block.minecraft.acacia_slab",
          "block.minecraft.bamboo_slab",
          "block.minecraft.birch_slab",
          "block.minecraft.cherry_slab",
          "block.minecraft.crimson_slab",
          "block.minecraft.dark_oak_slab",
          "block.minecraft.jungle_slab",
          "block.minecraft.mangrove_slab",
          "block.minecraft.oak_slab",
          "block.minecraft.pale_oak_slab",
          "block.minecraft.spruce_slab",
          "block.minecraft.warped_slab"
        ],
        [
          "block.minecraft.acacia_slab",
          "block.minecraft.bamboo_slab",
          "block.minecraft.birch_slab",
          "block.minecraft.cherry_slab",
          "block.minecraft.crimson_slab",
          "block.minecraft.dark_oak_slab",
          "block.minecraft.jungle_slab",
          "block.minecraft.mangrove_slab",
          "block.minecraft.oak_slab",
          "block.minecraft.pale_oak_slab",
          "block.minecraft.spruce_slab",
          "block.minecraft.warped_slab"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.chiseled_copper",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.cut_copper_slab"
        ],
        [
          "block.minecraft.cut_copper_slab"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.chiseled_deepslate",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.cobbled_deepslate_slab"
        ],
        [
          "block.minecraft.cobbled_deepslate_slab"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.chiseled_nether_bricks",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.nether_brick_slab"
        ],
        [
          "block.minecraft.nether_brick_slab"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.chiseled_polished_blackstone",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.polished_blackstone_slab"
        ],
        [
          "block.minecraft.polished_blackstone_slab"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.chiseled_quartz_block",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.quartz_slab"
        ],
        [
          "block.minecraft.quartz_slab"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.chiseled_red_sandstone",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.red_sandstone_slab"
        ],
        [
          "block.minecraft.red_sandstone_slab"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.chiseled_resin_bricks",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.resin_brick_slab"
        ],
        [
          "block.minecraft.resin_brick_slab"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.chiseled_sandstone",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.sandstone_slab"
        ],
        [
          "block.minecraft.sandstone_slab"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.chiseled_stone_bricks",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.stone_brick_slab"
        ],
        [
          "block.minecraft.stone_brick_slab"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.chiseled_tuff",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.tuff_slab"
        ],
        [
          "block.minecraft.tuff_slab"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.chiseled_tuff_bricks",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.tuff_brick_slab"
        ],
        [
          "block.minecraft.tuff_brick_slab"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.clay",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.clay_ball"
        ],
        [
          "item.minecraft.clay_ball"
        ],
        [
          "item.minecraft.clay_ball"
        ],
        [
          "item.minecraft.clay_ball"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.coal_block",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.coal"
        ],
        [
          "item.minecraft.coal"
        ],
        [
          "item.minecraft.coal"
        ],
        [
          "item.minecraft.coal"
        ],
        [
          "item.minecraft.coal"
        ],
        [
          "item.minecraft.coal"
        ],
        [
          "item.minecraft.coal"
        ],
        [
          "item.minecraft.coal"
        ],
        [
          "item.minecraft.coal"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.coarse_dirt",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.dirt"
        ],
        [
          "block.minecraft.gravel"
        ],
        [
          "block.minecraft.gravel"
        ],
        [
          "block.minecraft.dirt"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.cobbled_deepslate_slab",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.cobbled_deepslate"
        ],
        [
          "block.minecraft.cobbled_deepslate"
        ],
        [
          "block.minecraft.cobbled_deepslate"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.cobbled_deepslate_stairs",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.cobbled_deepslate"
        ],
        [
          "block.minecraft.cobbled_deepslate"
        ],
        [
          "block.minecraft.cobbled_deepslate"
        ],
        [
          "block.minecraft.cobbled_deepslate"
        ],
        [
          "block.minecraft.cobbled_deepslate"
        ],
        [
          "block.minecraft.cobbled_deepslate"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.cobbled_deepslate_wall",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.cobbled_deepslate"
        ],
        [
          "block.minecraft.cobbled_deepslate"
        ],
        [
          "block.minecraft.cobbled_deepslate"
        ],
        [
          "block.minecraft.cobbled_deepslate"
        ],
        [
          "block.minecraft.cobbled_deepslate"
        ],
        [
          "block.minecraft.cobbled_deepslate"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.cobblestone_slab",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.cobblestone"
        ],
        [
          "block.minecraft.cobblestone"
        ],
        [
          "block.minecraft.cobblestone"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.cobblestone_stairs",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.cobblestone"
        ],
        [
          "block.minecraft.cobblestone"
        ],
        [
          "block.minecraft.cobblestone"
        ],
        [
          "block.minecraft.cobblestone"
        ],
        [
          "block.minecraft.cobblestone"
        ],
        [
          "block.minecraft.cobblestone"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.cobblestone_wall",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.cobblestone"
        ],
        [
          "block.minecraft.cobblestone"
        ],
        [
          "block.minecraft.cobblestone"
        ],
        [
          "block.minecraft.cobblestone"
        ],
        [
          "block.minecraft.cobblestone"
        ],
        [
          "block.minecraft.cobblestone"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.comparator",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.redstone_torch"
        ],
        [
          "block.minecraft.redstone_torch"
        ],
        [
          "item.minecraft.quartz"
        ],
        [
          "block.minecraft.redstone_torch"
        ],
        [
          "block.minecraft.stone"
        ],
        [
          "block.minecraft.stone"
        ],
        [
          "block.minecraft.stone"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.composter",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.acacia_slab",
          "block.minecraft.bamboo_slab",
          "block.minecraft.birch_slab",
          "block.minecraft.cherry_slab",
          "block.minecraft.crimson_slab",
          "block.minecraft.dark_oak_slab",
          "block.minecraft.jungle_slab",
          "block.minecraft.mangrove_slab",
          "block.minecraft.oak_slab",
          "block.minecraft.pale_oak_slab",
          "block.minecraft.spruce_slab",
          "block.minecraft.warped_slab"
        ],
        [
          "block.minecraft.acacia_slab",
          "block.minecraft.bamboo_slab",
          "block.minecraft.birch_slab",
          "block.minecraft.cherry_slab",
          "block.minecraft.crimson_slab",
          "block.minecraft.dark_oak_slab",
          "block.minecraft.jungle_slab",
          "block.minecraft.mangrove_slab",
          "block.minecraft.oak_slab",
          "block.minecraft.pale_oak_slab",
          "block.minecraft.spruce_slab",
          "block.minecraft.warped_slab"
        ],
        [
          "block.minecraft.acacia_slab",
          "block.minecraft.bamboo_slab",
          "block.minecraft.birch_slab",
          "block.minecraft.cherry_slab",
          "block.minecraft.crimson_slab",
          "block.minecraft.dark_oak_slab",
          "block.minecraft.jungle_slab",
          "block.minecraft.mangrove_slab",
          "block.minecraft.oak_slab",
          "block.minecraft.pale_oak_slab",
          "block.minecraft.spruce_slab",
          "block.minecraft.warped_slab"
        ],
        [
          "block.minecraft.acacia_slab",
          "block.minecraft.bamboo_slab",
          "block.minecraft.birch_slab",
          "block.minecraft.cherry_slab",
          "block.minecraft.crimson_slab",
          "block.minecraft.dark_oak_slab",
          "block.minecraft.jungle_slab",
          "block.minecraft.mangrove_slab",
          "block.minecraft.oak_slab",
          "block.minecraft.pale_oak_slab",
          "block.minecraft.spruce_slab",
          "block.minecraft.warped_slab"
        ],
        [
          "block.minecraft.acacia_slab",
          "block.minecraft.bamboo_slab",
          "block.minecraft.birch_slab",
          "block.minecraft.cherry_slab",
          "block.minecraft.crimson_slab",
          "block.minecraft.dark_oak_slab",
          "block.minecraft.jungle_slab",
          "block.minecraft.mangrove_slab",
          "block.minecraft.oak_slab",
          "block.minecraft.pale_oak_slab",
          "block.minecraft.spruce_slab",
          "block.minecraft.warped_slab"
        ],
        [
          "block.minecraft.acacia_slab",
          "block.minecraft.bamboo_slab",
          "block.minecraft.birch_slab",
          "block.minecraft.cherry_slab",
          "block.minecraft.crimson_slab",
          "block.minecraft.dark_oak_slab",
          "block.minecraft.jungle_slab",
          "block.minecraft.mangrove_slab",
          "block.minecraft.oak_slab",
          "block.minecraft.pale_oak_slab",
          "block.minecraft.spruce_slab",
          "block.minecraft.warped_slab"
        ],
        [
          "block.minecraft.acacia_slab",
          "block.minecraft.bamboo_slab",
          "block.minecraft.birch_slab",
          "block.minecraft.cherry_slab",
          "block.minecraft.crimson_slab",
          "block.minecraft.dark_oak_slab",
          "block.minecraft.jungle_slab",
          "block.minecraft.mangrove_slab",
          "block.minecraft.oak_slab",
          "block.minecraft.pale_oak_slab",
          "block.minecraft.spruce_slab",
          "block.minecraft.warped_slab"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.conduit",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.nautilus_shell"
        ],
        [
          "item.minecraft.nautilus_shell"
        ],
        [
          "item.minecraft.nautilus_shell"
        ],
        [
          "item.minecraft.nautilus_shell"
        ],
        [
          "item.minecraft.heart_of_the_sea"
        ],
        [
          "item.minecraft.nautilus_shell"
        ],
        [
          "item.minecraft.nautilus_shell"
        ],
        [
          "item.minecraft.nautilus_shell"
        ],
        [
          "item.minecraft.nautilus_shell"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.copper_bars",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.copper_ingot"
        ],
        [
          "item.minecraft.copper_ingot"
        ],
        [
          "item.minecraft.copper_ingot"
        ],
        [
          "item.minecraft.copper_ingot"
        ],
        [
          "item.minecraft.copper_ingot"
        ],
        [
          "item.minecraft.copper_ingot"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.copper_block",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.copper_ingot"
        ],
        [
          "item.minecraft.copper_ingot"
        ],
        [
          "item.minecraft.copper_ingot"
        ],
        [
          "item.minecraft.copper_ingot"
        ],
        [
          "item.minecraft.copper_ingot"
        ],
        [
          "item.minecraft.copper_ingot"
        ],
        [
          "item.minecraft.copper_ingot"
        ],
        [
          "item.minecraft.copper_ingot"
        ],
        [
          "item.minecraft.copper_ingot"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.copper_bulb",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.copper_block"
        ],
        [
          "block.minecraft.copper_block"
        ],
        [
          "item.minecraft.blaze_rod"
        ],
        [
          "block.minecraft.copper_block"
        ],
        [
          "item.minecraft.redstone"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.copper_chain",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.copper_nugget"
        ],
        [
          "item.minecraft.copper_ingot"
        ],
        [
          "item.minecraft.copper_nugget"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.copper_chest",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.copper_ingot"
        ],
        [
          "item.minecraft.copper_ingot"
        ],
        [
          "item.minecraft.copper_ingot"
        ],
        [
          "item.minecraft.copper_ingot"
        ],
        [
          "block.minecraft.chest"
        ],
        [
          "item.minecraft.copper_ingot"
        ],
        [
          "item.minecraft.copper_ingot"
        ],
        [
          "item.minecraft.copper_ingot"
        ],
        [
          "item.minecraft.copper_ingot"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.copper_door",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.copper_ingot"
        ],
        [
          "item.minecraft.copper_ingot"
        ],
        [
          "item.minecraft.copper_ingot"
        ],
        [
          "item.minecraft.copper_ingot"
        ],
        [
          "item.minecraft.copper_ingot"
        ],
        [
          "item.minecraft.copper_ingot"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.copper_grate",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.copper_block"
        ],
        [
          "block.minecraft.copper_block"
        ],
        [
          "block.minecraft.copper_block"
        ],
        [
          "block.minecraft.copper_block"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.copper_lantern",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.copper_nugget"
        ],
        [
          "item.minecraft.copper_nugget"
        ],
        [
          "item.minecraft.copper_nugget"
        ],
        [
          "item.minecraft.copper_nugget"
        ],
        [
          "block.minecraft.copper_torch"
        ],
        [
          "item.minecraft.copper_nugget"
        ],
        [
          "item.minecraft.copper_nugget"
        ],
        [
          "item.minecraft.copper_nugget"
        ],
        [
          "item.minecraft.copper_nugget"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.copper_torch",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.copper_nugget"
        ],
        [
          "item.minecraft.charcoal",
          "item.minecraft.coal"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.copper_trapdoor",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.copper_ingot"
        ],
        [
          "item.minecraft.copper_ingot"
        ],
        [
          "item.minecraft.copper_ingot"
        ],
        [
          "item.minecraft.copper_ingot"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.crafter",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "block.minecraft.crafting_table"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.redstone"
        ],
        [
          "block.minecraft.dropper"
        ],
        [
          "item.minecraft.redstone"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.crafting_table",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.creaking_heart",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.pale_oak_log"
        ],
        [
          "block.minecraft.resin_block"
        ],
        [
          "block.minecraft.pale_oak_log"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.cut_copper",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.copper_block"
        ],
        [
          "block.minecraft.copper_block"
        ],
        [
          "block.minecraft.copper_block"
        ],
        [
          "block.minecraft.copper_block"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.cut_copper_slab",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.cut_copper"
        ],
        [
          "block.minecraft.cut_copper"
        ],
        [
          "block.minecraft.cut_copper"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.cut_copper_stairs",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.cut_copper"
        ],
        [
          "block.minecraft.cut_copper"
        ],
        [
          "block.minecraft.cut_copper"
        ],
        [
          "block.minecraft.cut_copper"
        ],
        [
          "block.minecraft.cut_copper"
        ],
        [
          "block.minecraft.cut_copper"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.cut_red_sandstone",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.red_sandstone"
        ],
        [
          "block.minecraft.red_sandstone"
        ],
        [
          "block.minecraft.red_sandstone"
        ],
        [
          "block.minecraft.red_sandstone"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.cut_red_sandstone_slab",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.cut_red_sandstone"
        ],
        [
          "block.minecraft.cut_red_sandstone"
        ],
        [
          "block.minecraft.cut_red_sandstone"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.cut_sandstone",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.sandstone"
        ],
        [
          "block.minecraft.sandstone"
        ],
        [
          "block.minecraft.sandstone"
        ],
        [
          "block.minecraft.sandstone"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.cut_sandstone_slab",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.cut_sandstone"
        ],
        [
          "block.minecraft.cut_sandstone"
        ],
        [
          "block.minecraft.cut_sandstone"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.dark_prismarine",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.prismarine_shard"
        ],
        [
          "item.minecraft.prismarine_shard"
        ],
        [
          "item.minecraft.prismarine_shard"
        ],
        [
          "item.minecraft.prismarine_shard"
        ],
        [
          "item.minecraft.black_dye"
        ],
        [
          "item.minecraft.prismarine_shard"
        ],
        [
          "item.minecraft.prismarine_shard"
        ],
        [
          "item.minecraft.prismarine_shard"
        ],
        [
          "item.minecraft.prismarine_shard"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.dark_prismarine_slab",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.dark_prismarine"
        ],
        [
          "block.minecraft.dark_prismarine"
        ],
        [
          "block.minecraft.dark_prismarine"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.dark_prismarine_stairs",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.dark_prismarine"
        ],
        [
          "block.minecraft.dark_prismarine"
        ],
        [
          "block.minecraft.dark_prismarine"
        ],
        [
          "block.minecraft.dark_prismarine"
        ],
        [
          "block.minecraft.dark_prismarine"
        ],
        [
          "block.minecraft.dark_prismarine"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.daylight_detector",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "item.minecraft.quartz"
        ],
        [
          "item.minecraft.quartz"
        ],
        [
          "item.minecraft.quartz"
        ],
        [
          "block.minecraft.acacia_slab",
          "block.minecraft.bamboo_slab",
          "block.minecraft.birch_slab",
          "block.minecraft.cherry_slab",
          "block.minecraft.crimson_slab",
          "block.minecraft.dark_oak_slab",
          "block.minecraft.jungle_slab",
          "block.minecraft.mangrove_slab",
          "block.minecraft.oak_slab",
          "block.minecraft.pale_oak_slab",
          "block.minecraft.spruce_slab",
          "block.minecraft.warped_slab"
        ],
        [
          "block.minecraft.acacia_slab",
          "block.minecraft.bamboo_slab",
          "block.minecraft.birch_slab",
          "block.minecraft.cherry_slab",
          "block.minecraft.crimson_slab",
          "block.minecraft.dark_oak_slab",
          "block.minecraft.jungle_slab",
          "block.minecraft.mangrove_slab",
          "block.minecraft.oak_slab",
          "block.minecraft.pale_oak_slab",
          "block.minecraft.spruce_slab",
          "block.minecraft.warped_slab"
        ],
        [
          "block.minecraft.acacia_slab",
          "block.minecraft.bamboo_slab",
          "block.minecraft.birch_slab",
          "block.minecraft.cherry_slab",
          "block.minecraft.crimson_slab",
          "block.minecraft.dark_oak_slab",
          "block.minecraft.jungle_slab",
          "block.minecraft.mangrove_slab",
          "block.minecraft.oak_slab",
          "block.minecraft.pale_oak_slab",
          "block.minecraft.spruce_slab",
          "block.minecraft.warped_slab"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.decorated_pot",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.brick"
        ],
        [
          "item.minecraft.brick"
        ],
        [
          "item.minecraft.brick"
        ],
        [
          "item.minecraft.brick"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.deepslate_brick_slab",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.deepslate_bricks"
        ],
        [
          "block.minecraft.deepslate_bricks"
        ],
        [
          "block.minecraft.deepslate_bricks"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.deepslate_brick_stairs",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.deepslate_bricks"
        ],
        [
          "block.minecraft.deepslate_bricks"
        ],
        [
          "block.minecraft.deepslate_bricks"
        ],
        [
          "block.minecraft.deepslate_bricks"
        ],
        [
          "block.minecraft.deepslate_bricks"
        ],
        [
          "block.minecraft.deepslate_bricks"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.deepslate_brick_wall",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.deepslate_bricks"
        ],
        [
          "block.minecraft.deepslate_bricks"
        ],
        [
          "block.minecraft.deepslate_bricks"
        ],
        [
          "block.minecraft.deepslate_bricks"
        ],
        [
          "block.minecraft.deepslate_bricks"
        ],
        [
          "block.minecraft.deepslate_bricks"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.deepslate_bricks",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.polished_deepslate"
        ],
        [
          "block.minecraft.polished_deepslate"
        ],
        [
          "block.minecraft.polished_deepslate"
        ],
        [
          "block.minecraft.polished_deepslate"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.deepslate_tile_slab",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.deepslate_tiles"
        ],
        [
          "block.minecraft.deepslate_tiles"
        ],
        [
          "block.minecraft.deepslate_tiles"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.deepslate_tile_stairs",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.deepslate_tiles"
        ],
        [
          "block.minecraft.deepslate_tiles"
        ],
        [
          "block.minecraft.deepslate_tiles"
        ],
        [
          "block.minecraft.deepslate_tiles"
        ],
        [
          "block.minecraft.deepslate_tiles"
        ],
        [
          "block.minecraft.deepslate_tiles"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.deepslate_tile_wall",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.deepslate_tiles"
        ],
        [
          "block.minecraft.deepslate_tiles"
        ],
        [
          "block.minecraft.deepslate_tiles"
        ],
        [
          "block.minecraft.deepslate_tiles"
        ],
        [
          "block.minecraft.deepslate_tiles"
        ],
        [
          "block.minecraft.deepslate_tiles"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.deepslate_tiles",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.deepslate_bricks"
        ],
        [
          "block.minecraft.deepslate_bricks"
        ],
        [
          "block.minecraft.deepslate_bricks"
        ],
        [
          "block.minecraft.deepslate_bricks"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.detector_rail",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "block.minecraft.stone_pressure_plate"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.redstone"
        ],
        [
          "item.minecraft.iron_ingot"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.diamond_block",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.diorite",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.cobblestone"
        ],
        [
          "item.minecraft.quartz"
        ],
        [
          "item.minecraft.quartz"
        ],
        [
          "block.minecraft.cobblestone"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.diorite_slab",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.diorite"
        ],
        [
          "block.minecraft.diorite"
        ],
        [
          "block.minecraft.diorite"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.diorite_stairs",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.diorite"
        ],
        [
          "block.minecraft.diorite"
        ],
        [
          "block.minecraft.diorite"
        ],
        [
          "block.minecraft.diorite"
        ],
        [
          "block.minecraft.diorite"
        ],
        [
          "block.minecraft.diorite"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.diorite_wall",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.diorite"
        ],
        [
          "block.minecraft.diorite"
        ],
        [
          "block.minecraft.diorite"
        ],
        [
          "block.minecraft.diorite"
        ],
        [
          "block.minecraft.diorite"
        ],
        [
          "block.minecraft.diorite"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.dispenser",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.cobblestone"
        ],
        [
          "block.minecraft.cobblestone"
        ],
        [
          "block.minecraft.cobblestone"
        ],
        [
          "block.minecraft.cobblestone"
        ],
        [
          "item.minecraft.bow"
        ],
        [
          "block.minecraft.cobblestone"
        ],
        [
          "block.minecraft.cobblestone"
        ],
        [
          "item.minecraft.redstone"
        ],
        [
          "block.minecraft.cobblestone"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.dried_ghast",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.ghast_tear"
        ],
        [
          "item.minecraft.ghast_tear"
        ],
        [
          "item.minecraft.ghast_tear"
        ],
        [
          "item.minecraft.ghast_tear"
        ],
        [
          "block.minecraft.soul_sand"
        ],
        [
          "item.minecraft.ghast_tear"
        ],
        [
          "item.minecraft.ghast_tear"
        ],
        [
          "item.minecraft.ghast_tear"
        ],
        [
          "item.minecraft.ghast_tear"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.dried_kelp_block",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.dried_kelp"
        ],
        [
          "item.minecraft.dried_kelp"
        ],
        [
          "item.minecraft.dried_kelp"
        ],
        [
          "item.minecraft.dried_kelp"
        ],
        [
          "item.minecraft.dried_kelp"
        ],
        [
          "item.minecraft.dried_kelp"
        ],
        [
          "item.minecraft.dried_kelp"
        ],
        [
          "item.minecraft.dried_kelp"
        ],
        [
          "item.minecraft.dried_kelp"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.dripstone_block",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.pointed_dripstone"
        ],
        [
          "block.minecraft.pointed_dripstone"
        ],
        [
          "block.minecraft.pointed_dripstone"
        ],
        [
          "block.minecraft.pointed_dripstone"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.dropper",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.cobblestone"
        ],
        [
          "block.minecraft.cobblestone"
        ],
        [
          "block.minecraft.cobblestone"
        ],
        [
          "block.minecraft.cobblestone"
        ],
        [
          "block.minecraft.cobblestone"
        ],
        [
          "block.minecraft.cobblestone"
        ],
        [
          "item.minecraft.redstone"
        ],
        [
          "block.minecraft.cobblestone"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.emerald_block",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.emerald"
        ],
        [
          "item.minecraft.emerald"
        ],
        [
          "item.minecraft.emerald"
        ],
        [
          "item.minecraft.emerald"
        ],
        [
          "item.minecraft.emerald"
        ],
        [
          "item.minecraft.emerald"
        ],
        [
          "item.minecraft.emerald"
        ],
        [
          "item.minecraft.emerald"
        ],
        [
          "item.minecraft.emerald"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.enchanting_table",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.book"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "block.minecraft.obsidian"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "block.minecraft.obsidian"
        ],
        [
          "block.minecraft.obsidian"
        ],
        [
          "block.minecraft.obsidian"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.end_rod",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.blaze_rod"
        ],
        [
          "item.minecraft.popped_chorus_fruit"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.end_stone_brick_slab",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.end_stone_bricks"
        ],
        [
          "block.minecraft.end_stone_bricks"
        ],
        [
          "block.minecraft.end_stone_bricks"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.end_stone_brick_stairs",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.end_stone_bricks"
        ],
        [
          "block.minecraft.end_stone_bricks"
        ],
        [
          "block.minecraft.end_stone_bricks"
        ],
        [
          "block.minecraft.end_stone_bricks"
        ],
        [
          "block.minecraft.end_stone_bricks"
        ],
        [
          "block.minecraft.end_stone_bricks"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.end_stone_brick_wall",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.end_stone_bricks"
        ],
        [
          "block.minecraft.end_stone_bricks"
        ],
        [
          "block.minecraft.end_stone_bricks"
        ],
        [
          "block.minecraft.end_stone_bricks"
        ],
        [
          "block.minecraft.end_stone_bricks"
        ],
        [
          "block.minecraft.end_stone_bricks"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.end_stone_bricks",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.end_stone"
        ],
        [
          "block.minecraft.end_stone"
        ],
        [
          "block.minecraft.end_stone"
        ],
        [
          "block.minecraft.end_stone"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.ender_chest",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.obsidian"
        ],
        [
          "block.minecraft.obsidian"
        ],
        [
          "block.minecraft.obsidian"
        ],
        [
          "block.minecraft.obsidian"
        ],
        [
          "item.minecraft.ender_eye"
        ],
        [
          "block.minecraft.obsidian"
        ],
        [
          "block.minecraft.obsidian"
        ],
        [
          "block.minecraft.obsidian"
        ],
        [
          "block.minecraft.obsidian"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.exposed_chiseled_copper",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.exposed_cut_copper_slab"
        ],
        [
          "block.minecraft.exposed_cut_copper_slab"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.exposed_copper_bulb",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.exposed_copper"
        ],
        [
          "block.minecraft.exposed_copper"
        ],
        [
          "item.minecraft.blaze_rod"
        ],
        [
          "block.minecraft.exposed_copper"
        ],
        [
          "item.minecraft.redstone"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.exposed_copper_grate",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.exposed_copper"
        ],
        [
          "block.minecraft.exposed_copper"
        ],
        [
          "block.minecraft.exposed_copper"
        ],
        [
          "block.minecraft.exposed_copper"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.exposed_cut_copper",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.exposed_copper"
        ],
        [
          "block.minecraft.exposed_copper"
        ],
        [
          "block.minecraft.exposed_copper"
        ],
        [
          "block.minecraft.exposed_copper"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.exposed_cut_copper_slab",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.exposed_cut_copper"
        ],
        [
          "block.minecraft.exposed_cut_copper"
        ],
        [
          "block.minecraft.exposed_cut_copper"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.exposed_cut_copper_stairs",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.exposed_cut_copper"
        ],
        [
          "block.minecraft.exposed_cut_copper"
        ],
        [
          "block.minecraft.exposed_cut_copper"
        ],
        [
          "block.minecraft.exposed_cut_copper"
        ],
        [
          "block.minecraft.exposed_cut_copper"
        ],
        [
          "block.minecraft.exposed_cut_copper"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.fletching_table",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.flint"
        ],
        [
          "item.minecraft.flint"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.flower_pot",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.brick"
        ],
        [
          "item.minecraft.brick"
        ],
        [
          "item.minecraft.brick"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.furnace",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.blackstone",
          "block.minecraft.cobbled_deepslate",
          "block.minecraft.cobblestone"
        ],
        [
          "block.minecraft.blackstone",
          "block.minecraft.cobbled_deepslate",
          "block.minecraft.cobblestone"
        ],
        [
          "block.minecraft.blackstone",
          "block.minecraft.cobbled_deepslate",
          "block.minecraft.cobblestone"
        ],
        [
          "block.minecraft.blackstone",
          "block.minecraft.cobbled_deepslate",
          "block.minecraft.cobblestone"
        ],
        [
          "block.minecraft.blackstone",
          "block.minecraft.cobbled_deepslate",
          "block.minecraft.cobblestone"
        ],
        [
          "block.minecraft.blackstone",
          "block.minecraft.cobbled_deepslate",
          "block.minecraft.cobblestone"
        ],
        [
          "block.minecraft.blackstone",
          "block.minecraft.cobbled_deepslate",
          "block.minecraft.cobblestone"
        ],
        [
          "block.minecraft.blackstone",
          "block.minecraft.cobbled_deepslate",
          "block.minecraft.cobblestone"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.glass_pane",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.glowstone",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.glowstone_dust"
        ],
        [
          "item.minecraft.glowstone_dust"
        ],
        [
          "item.minecraft.glowstone_dust"
        ],
        [
          "item.minecraft.glowstone_dust"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.gold_block",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.gold_ingot"
        ],
        [
          "item.minecraft.gold_ingot"
        ],
        [
          "item.minecraft.gold_ingot"
        ],
        [
          "item.minecraft.gold_ingot"
        ],
        [
          "item.minecraft.gold_ingot"
        ],
        [
          "item.minecraft.gold_ingot"
        ],
        [
          "item.minecraft.gold_ingot"
        ],
        [
          "item.minecraft.gold_ingot"
        ],
        [
          "item.minecraft.gold_ingot"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.golden_dandelion",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.gold_nugget"
        ],
        [
          "item.minecraft.gold_nugget"
        ],
        [
          "item.minecraft.gold_nugget"
        ],
        [
          "item.minecraft.gold_nugget"
        ],
        [
          "block.minecraft.dandelion"
        ],
        [
          "item.minecraft.gold_nugget"
        ],
        [
          "item.minecraft.gold_nugget"
        ],
        [
          "item.minecraft.gold_nugget"
        ],
        [
          "item.minecraft.gold_nugget"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.granite",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.diorite"
        ],
        [
          "item.minecraft.quartz"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.granite_slab",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.granite"
        ],
        [
          "block.minecraft.granite"
        ],
        [
          "block.minecraft.granite"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.granite_stairs",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.granite"
        ],
        [
          "block.minecraft.granite"
        ],
        [
          "block.minecraft.granite"
        ],
        [
          "block.minecraft.granite"
        ],
        [
          "block.minecraft.granite"
        ],
        [
          "block.minecraft.granite"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.granite_wall",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.granite"
        ],
        [
          "block.minecraft.granite"
        ],
        [
          "block.minecraft.granite"
        ],
        [
          "block.minecraft.granite"
        ],
        [
          "block.minecraft.granite"
        ],
        [
          "block.minecraft.granite"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.grindstone",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.stick"
        ],
        [
          "block.minecraft.stone_slab"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.hay_block",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.wheat"
        ],
        [
          "item.minecraft.wheat"
        ],
        [
          "item.minecraft.wheat"
        ],
        [
          "item.minecraft.wheat"
        ],
        [
          "item.minecraft.wheat"
        ],
        [
          "item.minecraft.wheat"
        ],
        [
          "item.minecraft.wheat"
        ],
        [
          "item.minecraft.wheat"
        ],
        [
          "item.minecraft.wheat"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.heavy_weighted_pressure_plate",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.honey_block",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.honey_bottle"
        ],
        [
          "item.minecraft.honey_bottle"
        ],
        [
          "item.minecraft.honey_bottle"
        ],
        [
          "item.minecraft.honey_bottle"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.honeycomb_block",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.honeycomb"
        ],
        [
          "item.minecraft.honeycomb"
        ],
        [
          "item.minecraft.honeycomb"
        ],
        [
          "item.minecraft.honeycomb"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.hopper",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "block.minecraft.chest"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.iron_bars",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.iron_block",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.iron_chain",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.iron_nugget"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_nugget"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.iron_door",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.iron_trapdoor",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.jack_o_lantern",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.carved_pumpkin"
        ],
        [
          "block.minecraft.torch"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.jukebox",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.ladder",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.lantern",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.iron_nugget"
        ],
        [
          "item.minecraft.iron_nugget"
        ],
        [
          "item.minecraft.iron_nugget"
        ],
        [
          "item.minecraft.iron_nugget"
        ],
        [
          "block.minecraft.torch"
        ],
        [
          "item.minecraft.iron_nugget"
        ],
        [
          "item.minecraft.iron_nugget"
        ],
        [
          "item.minecraft.iron_nugget"
        ],
        [
          "item.minecraft.iron_nugget"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.lapis_block",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.lapis_lazuli"
        ],
        [
          "item.minecraft.lapis_lazuli"
        ],
        [
          "item.minecraft.lapis_lazuli"
        ],
        [
          "item.minecraft.lapis_lazuli"
        ],
        [
          "item.minecraft.lapis_lazuli"
        ],
        [
          "item.minecraft.lapis_lazuli"
        ],
        [
          "item.minecraft.lapis_lazuli"
        ],
        [
          "item.minecraft.lapis_lazuli"
        ],
        [
          "item.minecraft.lapis_lazuli"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.lectern",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.acacia_slab",
          "block.minecraft.bamboo_slab",
          "block.minecraft.birch_slab",
          "block.minecraft.cherry_slab",
          "block.minecraft.crimson_slab",
          "block.minecraft.dark_oak_slab",
          "block.minecraft.jungle_slab",
          "block.minecraft.mangrove_slab",
          "block.minecraft.oak_slab",
          "block.minecraft.pale_oak_slab",
          "block.minecraft.spruce_slab",
          "block.minecraft.warped_slab"
        ],
        [
          "block.minecraft.acacia_slab",
          "block.minecraft.bamboo_slab",
          "block.minecraft.birch_slab",
          "block.minecraft.cherry_slab",
          "block.minecraft.crimson_slab",
          "block.minecraft.dark_oak_slab",
          "block.minecraft.jungle_slab",
          "block.minecraft.mangrove_slab",
          "block.minecraft.oak_slab",
          "block.minecraft.pale_oak_slab",
          "block.minecraft.spruce_slab",
          "block.minecraft.warped_slab"
        ],
        [
          "block.minecraft.acacia_slab",
          "block.minecraft.bamboo_slab",
          "block.minecraft.birch_slab",
          "block.minecraft.cherry_slab",
          "block.minecraft.crimson_slab",
          "block.minecraft.dark_oak_slab",
          "block.minecraft.jungle_slab",
          "block.minecraft.mangrove_slab",
          "block.minecraft.oak_slab",
          "block.minecraft.pale_oak_slab",
          "block.minecraft.spruce_slab",
          "block.minecraft.warped_slab"
        ],
        [
          "block.minecraft.bookshelf"
        ],
        [
          "block.minecraft.acacia_slab",
          "block.minecraft.bamboo_slab",
          "block.minecraft.birch_slab",
          "block.minecraft.cherry_slab",
          "block.minecraft.crimson_slab",
          "block.minecraft.dark_oak_slab",
          "block.minecraft.jungle_slab",
          "block.minecraft.mangrove_slab",
          "block.minecraft.oak_slab",
          "block.minecraft.pale_oak_slab",
          "block.minecraft.spruce_slab",
          "block.minecraft.warped_slab"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.lever",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.stick"
        ],
        [
          "block.minecraft.cobblestone"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.light_weighted_pressure_plate",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.gold_ingot"
        ],
        [
          "item.minecraft.gold_ingot"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.lightning_rod",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.copper_ingot"
        ],
        [
          "item.minecraft.copper_ingot"
        ],
        [
          "item.minecraft.copper_ingot"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.lodestone",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.chiseled_stone_bricks"
        ],
        [
          "block.minecraft.chiseled_stone_bricks"
        ],
        [
          "block.minecraft.chiseled_stone_bricks"
        ],
        [
          "block.minecraft.chiseled_stone_bricks"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "block.minecraft.chiseled_stone_bricks"
        ],
        [
          "block.minecraft.chiseled_stone_bricks"
        ],
        [
          "block.minecraft.chiseled_stone_bricks"
        ],
        [
          "block.minecraft.chiseled_stone_bricks"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.loom",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.string"
        ],
        [
          "item.minecraft.string"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.magma_block",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.magma_cream"
        ],
        [
          "item.minecraft.magma_cream"
        ],
        [
          "item.minecraft.magma_cream"
        ],
        [
          "item.minecraft.magma_cream"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.melon",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.melon_slice"
        ],
        [
          "item.minecraft.melon_slice"
        ],
        [
          "item.minecraft.melon_slice"
        ],
        [
          "item.minecraft.melon_slice"
        ],
        [
          "item.minecraft.melon_slice"
        ],
        [
          "item.minecraft.melon_slice"
        ],
        [
          "item.minecraft.melon_slice"
        ],
        [
          "item.minecraft.melon_slice"
        ],
        [
          "item.minecraft.melon_slice"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.mossy_cobblestone",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.cobblestone"
        ],
        [
          "block.minecraft.moss_block"
        ]
      ]
    },
    {
      "output": "block.minecraft.mossy_cobblestone",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.cobblestone"
        ],
        [
          "block.minecraft.vine"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.mossy_cobblestone_slab",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.mossy_cobblestone"
        ],
        [
          "block.minecraft.mossy_cobblestone"
        ],
        [
          "block.minecraft.mossy_cobblestone"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.mossy_cobblestone_stairs",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.mossy_cobblestone"
        ],
        [
          "block.minecraft.mossy_cobblestone"
        ],
        [
          "block.minecraft.mossy_cobblestone"
        ],
        [
          "block.minecraft.mossy_cobblestone"
        ],
        [
          "block.minecraft.mossy_cobblestone"
        ],
        [
          "block.minecraft.mossy_cobblestone"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.mossy_cobblestone_wall",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.mossy_cobblestone"
        ],
        [
          "block.minecraft.mossy_cobblestone"
        ],
        [
          "block.minecraft.mossy_cobblestone"
        ],
        [
          "block.minecraft.mossy_cobblestone"
        ],
        [
          "block.minecraft.mossy_cobblestone"
        ],
        [
          "block.minecraft.mossy_cobblestone"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.mossy_stone_brick_slab",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.mossy_stone_bricks"
        ],
        [
          "block.minecraft.mossy_stone_bricks"
        ],
        [
          "block.minecraft.mossy_stone_bricks"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.mossy_stone_brick_stairs",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.mossy_stone_bricks"
        ],
        [
          "block.minecraft.mossy_stone_bricks"
        ],
        [
          "block.minecraft.mossy_stone_bricks"
        ],
        [
          "block.minecraft.mossy_stone_bricks"
        ],
        [
          "block.minecraft.mossy_stone_bricks"
        ],
        [
          "block.minecraft.mossy_stone_bricks"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.mossy_stone_brick_wall",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.mossy_stone_bricks"
        ],
        [
          "block.minecraft.mossy_stone_bricks"
        ],
        [
          "block.minecraft.mossy_stone_bricks"
        ],
        [
          "block.minecraft.mossy_stone_bricks"
        ],
        [
          "block.minecraft.mossy_stone_bricks"
        ],
        [
          "block.minecraft.mossy_stone_bricks"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.mossy_stone_bricks",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.stone_bricks"
        ],
        [
          "block.minecraft.moss_block"
        ]
      ]
    },
    {
      "output": "block.minecraft.mossy_stone_bricks",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.stone_bricks"
        ],
        [
          "block.minecraft.vine"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.mud_brick_slab",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.mud_bricks"
        ],
        [
          "block.minecraft.mud_bricks"
        ],
        [
          "block.minecraft.mud_bricks"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.mud_brick_stairs",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.mud_bricks"
        ],
        [
          "block.minecraft.mud_bricks"
        ],
        [
          "block.minecraft.mud_bricks"
        ],
        [
          "block.minecraft.mud_bricks"
        ],
        [
          "block.minecraft.mud_bricks"
        ],
        [
          "block.minecraft.mud_bricks"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.mud_brick_wall",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.mud_bricks"
        ],
        [
          "block.minecraft.mud_bricks"
        ],
        [
          "block.minecraft.mud_bricks"
        ],
        [
          "block.minecraft.mud_bricks"
        ],
        [
          "block.minecraft.mud_bricks"
        ],
        [
          "block.minecraft.mud_bricks"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.mud_bricks",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.packed_mud"
        ],
        [
          "block.minecraft.packed_mud"
        ],
        [
          "block.minecraft.packed_mud"
        ],
        [
          "block.minecraft.packed_mud"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.muddy_mangrove_roots",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.mud"
        ],
        [
          "block.minecraft.mangrove_roots"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.nether_brick_fence",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.nether_bricks"
        ],
        [
          "item.minecraft.nether_brick"
        ],
        [
          "block.minecraft.nether_bricks"
        ],
        [
          "block.minecraft.nether_bricks"
        ],
        [
          "item.minecraft.nether_brick"
        ],
        [
          "block.minecraft.nether_bricks"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.nether_brick_slab",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.nether_bricks"
        ],
        [
          "block.minecraft.nether_bricks"
        ],
        [
          "block.minecraft.nether_bricks"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.nether_brick_stairs",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.nether_bricks"
        ],
        [
          "block.minecraft.nether_bricks"
        ],
        [
          "block.minecraft.nether_bricks"
        ],
        [
          "block.minecraft.nether_bricks"
        ],
        [
          "block.minecraft.nether_bricks"
        ],
        [
          "block.minecraft.nether_bricks"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.nether_brick_wall",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.nether_bricks"
        ],
        [
          "block.minecraft.nether_bricks"
        ],
        [
          "block.minecraft.nether_bricks"
        ],
        [
          "block.minecraft.nether_bricks"
        ],
        [
          "block.minecraft.nether_bricks"
        ],
        [
          "block.minecraft.nether_bricks"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.nether_bricks",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.nether_brick"
        ],
        [
          "item.minecraft.nether_brick"
        ],
        [
          "item.minecraft.nether_brick"
        ],
        [
          "item.minecraft.nether_brick"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.nether_wart_block",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.nether_wart"
        ],
        [
          "item.minecraft.nether_wart"
        ],
        [
          "item.minecraft.nether_wart"
        ],
        [
          "item.minecraft.nether_wart"
        ],
        [
          "item.minecraft.nether_wart"
        ],
        [
          "item.minecraft.nether_wart"
        ],
        [
          "item.minecraft.nether_wart"
        ],
        [
          "item.minecraft.nether_wart"
        ],
        [
          "item.minecraft.nether_wart"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.netherite_block",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.netherite_ingot"
        ],
        [
          "item.minecraft.netherite_ingot"
        ],
        [
          "item.minecraft.netherite_ingot"
        ],
        [
          "item.minecraft.netherite_ingot"
        ],
        [
          "item.minecraft.netherite_ingot"
        ],
        [
          "item.minecraft.netherite_ingot"
        ],
        [
          "item.minecraft.netherite_ingot"
        ],
        [
          "item.minecraft.netherite_ingot"
        ],
        [
          "item.minecraft.netherite_ingot"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.note_block",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "item.minecraft.redstone"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.observer",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.cobblestone"
        ],
        [
          "block.minecraft.cobblestone"
        ],
        [
          "block.minecraft.cobblestone"
        ],
        [
          "item.minecraft.redstone"
        ],
        [
          "item.minecraft.redstone"
        ],
        [
          "item.minecraft.quartz"
        ],
        [
          "block.minecraft.cobblestone"
        ],
        [
          "block.minecraft.cobblestone"
        ],
        [
          "block.minecraft.cobblestone"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.oxidized_chiseled_copper",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.oxidized_cut_copper_slab"
        ],
        [
          "block.minecraft.oxidized_cut_copper_slab"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.oxidized_copper_bulb",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.oxidized_copper"
        ],
        [
          "block.minecraft.oxidized_copper"
        ],
        [
          "item.minecraft.blaze_rod"
        ],
        [
          "block.minecraft.oxidized_copper"
        ],
        [
          "item.minecraft.redstone"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.oxidized_copper_grate",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.oxidized_copper"
        ],
        [
          "block.minecraft.oxidized_copper"
        ],
        [
          "block.minecraft.oxidized_copper"
        ],
        [
          "block.minecraft.oxidized_copper"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.oxidized_cut_copper",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.oxidized_copper"
        ],
        [
          "block.minecraft.oxidized_copper"
        ],
        [
          "block.minecraft.oxidized_copper"
        ],
        [
          "block.minecraft.oxidized_copper"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.oxidized_cut_copper_slab",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.oxidized_cut_copper"
        ],
        [
          "block.minecraft.oxidized_cut_copper"
        ],
        [
          "block.minecraft.oxidized_cut_copper"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.oxidized_cut_copper_stairs",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.oxidized_cut_copper"
        ],
        [
          "block.minecraft.oxidized_cut_copper"
        ],
        [
          "block.minecraft.oxidized_cut_copper"
        ],
        [
          "block.minecraft.oxidized_cut_copper"
        ],
        [
          "block.minecraft.oxidized_cut_copper"
        ],
        [
          "block.minecraft.oxidized_cut_copper"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.packed_ice",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.ice"
        ],
        [
          "block.minecraft.ice"
        ],
        [
          "block.minecraft.ice"
        ],
        [
          "block.minecraft.ice"
        ],
        [
          "block.minecraft.ice"
        ],
        [
          "block.minecraft.ice"
        ],
        [
          "block.minecraft.ice"
        ],
        [
          "block.minecraft.ice"
        ],
        [
          "block.minecraft.ice"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.packed_mud",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.mud"
        ],
        [
          "item.minecraft.wheat"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.piston",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.cobblestone"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "block.minecraft.cobblestone"
        ],
        [
          "block.minecraft.cobblestone"
        ],
        [
          "item.minecraft.redstone"
        ],
        [
          "block.minecraft.cobblestone"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.polished_andesite",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.andesite"
        ],
        [
          "block.minecraft.andesite"
        ],
        [
          "block.minecraft.andesite"
        ],
        [
          "block.minecraft.andesite"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.polished_andesite_slab",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.polished_andesite"
        ],
        [
          "block.minecraft.polished_andesite"
        ],
        [
          "block.minecraft.polished_andesite"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.polished_andesite_stairs",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.polished_andesite"
        ],
        [
          "block.minecraft.polished_andesite"
        ],
        [
          "block.minecraft.polished_andesite"
        ],
        [
          "block.minecraft.polished_andesite"
        ],
        [
          "block.minecraft.polished_andesite"
        ],
        [
          "block.minecraft.polished_andesite"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.polished_basalt",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.basalt"
        ],
        [
          "block.minecraft.basalt"
        ],
        [
          "block.minecraft.basalt"
        ],
        [
          "block.minecraft.basalt"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.polished_blackstone",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.blackstone"
        ],
        [
          "block.minecraft.blackstone"
        ],
        [
          "block.minecraft.blackstone"
        ],
        [
          "block.minecraft.blackstone"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.polished_blackstone_brick_slab",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.polished_blackstone_bricks"
        ],
        [
          "block.minecraft.polished_blackstone_bricks"
        ],
        [
          "block.minecraft.polished_blackstone_bricks"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.polished_blackstone_brick_stairs",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.polished_blackstone_bricks"
        ],
        [
          "block.minecraft.polished_blackstone_bricks"
        ],
        [
          "block.minecraft.polished_blackstone_bricks"
        ],
        [
          "block.minecraft.polished_blackstone_bricks"
        ],
        [
          "block.minecraft.polished_blackstone_bricks"
        ],
        [
          "block.minecraft.polished_blackstone_bricks"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.polished_blackstone_brick_wall",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.polished_blackstone_bricks"
        ],
        [
          "block.minecraft.polished_blackstone_bricks"
        ],
        [
          "block.minecraft.polished_blackstone_bricks"
        ],
        [
          "block.minecraft.polished_blackstone_bricks"
        ],
        [
          "block.minecraft.polished_blackstone_bricks"
        ],
        [
          "block.minecraft.polished_blackstone_bricks"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.polished_blackstone_bricks",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.polished_blackstone"
        ],
        [
          "block.minecraft.polished_blackstone"
        ],
        [
          "block.minecraft.polished_blackstone"
        ],
        [
          "block.minecraft.polished_blackstone"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.polished_blackstone_button",
      "size": 1,
      "ingredients": [
        [
          "block.minecraft.polished_blackstone"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.polished_blackstone_pressure_plate",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.polished_blackstone"
        ],
        [
          "block.minecraft.polished_blackstone"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.polished_blackstone_slab",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.polished_blackstone"
        ],
        [
          "block.minecraft.polished_blackstone"
        ],
        [
          "block.minecraft.polished_blackstone"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.polished_blackstone_stairs",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.polished_blackstone"
        ],
        [
          "block.minecraft.polished_blackstone"
        ],
        [
          "block.minecraft.polished_blackstone"
        ],
        [
          "block.minecraft.polished_blackstone"
        ],
        [
          "block.minecraft.polished_blackstone"
        ],
        [
          "block.minecraft.polished_blackstone"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.polished_blackstone_wall",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.polished_blackstone"
        ],
        [
          "block.minecraft.polished_blackstone"
        ],
        [
          "block.minecraft.polished_blackstone"
        ],
        [
          "block.minecraft.polished_blackstone"
        ],
        [
          "block.minecraft.polished_blackstone"
        ],
        [
          "block.minecraft.polished_blackstone"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.polished_deepslate",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.cobbled_deepslate"
        ],
        [
          "block.minecraft.cobbled_deepslate"
        ],
        [
          "block.minecraft.cobbled_deepslate"
        ],
        [
          "block.minecraft.cobbled_deepslate"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.polished_deepslate_slab",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.polished_deepslate"
        ],
        [
          "block.minecraft.polished_deepslate"
        ],
        [
          "block.minecraft.polished_deepslate"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.polished_deepslate_stairs",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.polished_deepslate"
        ],
        [
          "block.minecraft.polished_deepslate"
        ],
        [
          "block.minecraft.polished_deepslate"
        ],
        [
          "block.minecraft.polished_deepslate"
        ],
        [
          "block.minecraft.polished_deepslate"
        ],
        [
          "block.minecraft.polished_deepslate"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.polished_deepslate_wall",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.polished_deepslate"
        ],
        [
          "block.minecraft.polished_deepslate"
        ],
        [
          "block.minecraft.polished_deepslate"
        ],
        [
          "block.minecraft.polished_deepslate"
        ],
        [
          "block.minecraft.polished_deepslate"
        ],
        [
          "block.minecraft.polished_deepslate"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.polished_diorite",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.diorite"
        ],
        [
          "block.minecraft.diorite"
        ],
        [
          "block.minecraft.diorite"
        ],
        [
          "block.minecraft.diorite"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.polished_diorite_slab",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.polished_diorite"
        ],
        [
          "block.minecraft.polished_diorite"
        ],
        [
          "block.minecraft.polished_diorite"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.polished_diorite_stairs",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.polished_diorite"
        ],
        [
          "block.minecraft.polished_diorite"
        ],
        [
          "block.minecraft.polished_diorite"
        ],
        [
          "block.minecraft.polished_diorite"
        ],
        [
          "block.minecraft.polished_diorite"
        ],
        [
          "block.minecraft.polished_diorite"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.polished_granite",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.granite"
        ],
        [
          "block.minecraft.granite"
        ],
        [
          "block.minecraft.granite"
        ],
        [
          "block.minecraft.granite"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.polished_granite_slab",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.polished_granite"
        ],
        [
          "block.minecraft.polished_granite"
        ],
        [
          "block.minecraft.polished_granite"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.polished_granite_stairs",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.polished_granite"
        ],
        [
          "block.minecraft.polished_granite"
        ],
        [
          "block.minecraft.polished_granite"
        ],
        [
          "block.minecraft.polished_granite"
        ],
        [
          "block.minecraft.polished_granite"
        ],
        [
          "block.minecraft.polished_granite"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.polished_tuff",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.tuff"
        ],
        [
          "block.minecraft.tuff"
        ],
        [
          "block.minecraft.tuff"
        ],
        [
          "block.minecraft.tuff"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.polished_tuff_slab",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.polished_tuff"
        ],
        [
          "block.minecraft.polished_tuff"
        ],
        [
          "block.minecraft.polished_tuff"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.polished_tuff_stairs",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.polished_tuff"
        ],
        [
          "block.minecraft.polished_tuff"
        ],
        [
          "block.minecraft.polished_tuff"
        ],
        [
          "block.minecraft.polished_tuff"
        ],
        [
          "block.minecraft.polished_tuff"
        ],
        [
          "block.minecraft.polished_tuff"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.polished_tuff_wall",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.polished_tuff"
        ],
        [
          "block.minecraft.polished_tuff"
        ],
        [
          "block.minecraft.polished_tuff"
        ],
        [
          "block.minecraft.polished_tuff"
        ],
        [
          "block.minecraft.polished_tuff"
        ],
        [
          "block.minecraft.polished_tuff"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.powered_rail",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.gold_ingot"
        ],
        [
          "item.minecraft.gold_ingot"
        ],
        [
          "item.minecraft.gold_ingot"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.gold_ingot"
        ],
        [
          "item.minecraft.gold_ingot"
        ],
        [
          "item.minecraft.redstone"
        ],
        [
          "item.minecraft.gold_ingot"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.prismarine",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.prismarine_shard"
        ],
        [
          "item.minecraft.prismarine_shard"
        ],
        [
          "item.minecraft.prismarine_shard"
        ],
        [
          "item.minecraft.prismarine_shard"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.prismarine_brick_slab",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.prismarine_bricks"
        ],
        [
          "block.minecraft.prismarine_bricks"
        ],
        [
          "block.minecraft.prismarine_bricks"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.prismarine_brick_stairs",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.prismarine_bricks"
        ],
        [
          "block.minecraft.prismarine_bricks"
        ],
        [
          "block.minecraft.prismarine_bricks"
        ],
        [
          "block.minecraft.prismarine_bricks"
        ],
        [
          "block.minecraft.prismarine_bricks"
        ],
        [
          "block.minecraft.prismarine_bricks"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.prismarine_bricks",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.prismarine_shard"
        ],
        [
          "item.minecraft.prismarine_shard"
        ],
        [
          "item.minecraft.prismarine_shard"
        ],
        [
          "item.minecraft.prismarine_shard"
        ],
        [
          "item.minecraft.prismarine_shard"
        ],
        [
          "item.minecraft.prismarine_shard"
        ],
        [
          "item.minecraft.prismarine_shard"
        ],
        [
          "item.minecraft.prismarine_shard"
        ],
        [
          "item.minecraft.prismarine_shard"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.prismarine_slab",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.prismarine"
        ],
        [
          "block.minecraft.prismarine"
        ],
        [
          "block.minecraft.prismarine"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.prismarine_stairs",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.prismarine"
        ],
        [
          "block.minecraft.prismarine"
        ],
        [
          "block.minecraft.prismarine"
        ],
        [
          "block.minecraft.prismarine"
        ],
        [
          "block.minecraft.prismarine"
        ],
        [
          "block.minecraft.prismarine"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.prismarine_wall",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.prismarine"
        ],
        [
          "block.minecraft.prismarine"
        ],
        [
          "block.minecraft.prismarine"
        ],
        [
          "block.minecraft.prismarine"
        ],
        [
          "block.minecraft.prismarine"
        ],
        [
          "block.minecraft.prismarine"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.purpur_block",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.popped_chorus_fruit"
        ],
        [
          "item.minecraft.popped_chorus_fruit"
        ],
        [
          "item.minecraft.popped_chorus_fruit"
        ],
        [
          "item.minecraft.popped_chorus_fruit"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.purpur_pillar",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.purpur_slab"
        ],
        [
          "block.minecraft.purpur_slab"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.purpur_slab",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.purpur_block",
          "block.minecraft.purpur_pillar"
        ],
        [
          "block.minecraft.purpur_block",
          "block.minecraft.purpur_pillar"
        ],
        [
          "block.minecraft.purpur_block",
          "block.minecraft.purpur_pillar"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.purpur_stairs",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.purpur_block",
          "block.minecraft.purpur_pillar"
        ],
        [
          "block.minecraft.purpur_block",
          "block.minecraft.purpur_pillar"
        ],
        [
          "block.minecraft.purpur_block",
          "block.minecraft.purpur_pillar"
        ],
        [
          "block.minecraft.purpur_block",
          "block.minecraft.purpur_pillar"
        ],
        [
          "block.minecraft.purpur_block",
          "block.minecraft.purpur_pillar"
        ],
        [
          "block.minecraft.purpur_block",
          "block.minecraft.purpur_pillar"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.quartz_block",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.quartz"
        ],
        [
          "item.minecraft.quartz"
        ],
        [
          "item.minecraft.quartz"
        ],
        [
          "item.minecraft.quartz"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.quartz_bricks",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.quartz_block"
        ],
        [
          "block.minecraft.quartz_block"
        ],
        [
          "block.minecraft.quartz_block"
        ],
        [
          "block.minecraft.quartz_block"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.quartz_pillar",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.quartz_block"
        ],
        [
          "block.minecraft.quartz_block"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.quartz_slab",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.chiseled_quartz_block",
          "block.minecraft.quartz_block",
          "block.minecraft.quartz_pillar"
        ],
        [
          "block.minecraft.chiseled_quartz_block",
          "block.minecraft.quartz_block",
          "block.minecraft.quartz_pillar"
        ],
        [
          "block.minecraft.chiseled_quartz_block",
          "block.minecraft.quartz_block",
          "block.minecraft.quartz_pillar"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.quartz_stairs",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.chiseled_quartz_block",
          "block.minecraft.quartz_block",
          "block.minecraft.quartz_pillar"
        ],
        [
          "block.minecraft.chiseled_quartz_block",
          "block.minecraft.quartz_block",
          "block.minecraft.quartz_pillar"
        ],
        [
          "block.minecraft.chiseled_quartz_block",
          "block.minecraft.quartz_block",
          "block.minecraft.quartz_pillar"
        ],
        [
          "block.minecraft.chiseled_quartz_block",
          "block.minecraft.quartz_block",
          "block.minecraft.quartz_pillar"
        ],
        [
          "block.minecraft.chiseled_quartz_block",
          "block.minecraft.quartz_block",
          "block.minecraft.quartz_pillar"
        ],
        [
          "block.minecraft.chiseled_quartz_block",
          "block.minecraft.quartz_block",
          "block.minecraft.quartz_pillar"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.rail",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.raw_copper_block",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.raw_copper"
        ],
        [
          "item.minecraft.raw_copper"
        ],
        [
          "item.minecraft.raw_copper"
        ],
        [
          "item.minecraft.raw_copper"
        ],
        [
          "item.minecraft.raw_copper"
        ],
        [
          "item.minecraft.raw_copper"
        ],
        [
          "item.minecraft.raw_copper"
        ],
        [
          "item.minecraft.raw_copper"
        ],
        [
          "item.minecraft.raw_copper"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.raw_gold_block",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.raw_gold"
        ],
        [
          "item.minecraft.raw_gold"
        ],
        [
          "item.minecraft.raw_gold"
        ],
        [
          "item.minecraft.raw_gold"
        ],
        [
          "item.minecraft.raw_gold"
        ],
        [
          "item.minecraft.raw_gold"
        ],
        [
          "item.minecraft.raw_gold"
        ],
        [
          "item.minecraft.raw_gold"
        ],
        [
          "item.minecraft.raw_gold"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.raw_iron_block",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.raw_iron"
        ],
        [
          "item.minecraft.raw_iron"
        ],
        [
          "item.minecraft.raw_iron"
        ],
        [
          "item.minecraft.raw_iron"
        ],
        [
          "item.minecraft.raw_iron"
        ],
        [
          "item.minecraft.raw_iron"
        ],
        [
          "item.minecraft.raw_iron"
        ],
        [
          "item.minecraft.raw_iron"
        ],
        [
          "item.minecraft.raw_iron"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.red_nether_brick_slab",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.red_nether_bricks"
        ],
        [
          "block.minecraft.red_nether_bricks"
        ],
        [
          "block.minecraft.red_nether_bricks"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.red_nether_brick_stairs",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.red_nether_bricks"
        ],
        [
          "block.minecraft.red_nether_bricks"
        ],
        [
          "block.minecraft.red_nether_bricks"
        ],
        [
          "block.minecraft.red_nether_bricks"
        ],
        [
          "block.minecraft.red_nether_bricks"
        ],
        [
          "block.minecraft.red_nether_bricks"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.red_nether_brick_wall",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.red_nether_bricks"
        ],
        [
          "block.minecraft.red_nether_bricks"
        ],
        [
          "block.minecraft.red_nether_bricks"
        ],
        [
          "block.minecraft.red_nether_bricks"
        ],
        [
          "block.minecraft.red_nether_bricks"
        ],
        [
          "block.minecraft.red_nether_bricks"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.red_nether_bricks",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.nether_brick"
        ],
        [
          "item.minecraft.nether_wart"
        ],
        [
          "item.minecraft.nether_wart"
        ],
        [
          "item.minecraft.nether_brick"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.red_sandstone",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.red_sand"
        ],
        [
          "block.minecraft.red_sand"
        ],
        [
          "block.minecraft.red_sand"
        ],
        [
          "block.minecraft.red_sand"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.red_sandstone_slab",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.chiseled_red_sandstone",
          "block.minecraft.red_sandstone"
        ],
        [
          "block.minecraft.chiseled_red_sandstone",
          "block.minecraft.red_sandstone"
        ],
        [
          "block.minecraft.chiseled_red_sandstone",
          "block.minecraft.red_sandstone"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.red_sandstone_stairs",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.chiseled_red_sandstone",
          "block.minecraft.cut_red_sandstone",
          "block.minecraft.red_sandstone"
        ],
        [
          "block.minecraft.chiseled_red_sandstone",
          "block.minecraft.cut_red_sandstone",
          "block.minecraft.red_sandstone"
        ],
        [
          "block.minecraft.chiseled_red_sandstone",
          "block.minecraft.cut_red_sandstone",
          "block.minecraft.red_sandstone"
        ],
        [
          "block.minecraft.chiseled_red_sandstone",
          "block.minecraft.cut_red_sandstone",
          "block.minecraft.red_sandstone"
        ],
        [
          "block.minecraft.chiseled_red_sandstone",
          "block.minecraft.cut_red_sandstone",
          "block.minecraft.red_sandstone"
        ],
        [
          "block.minecraft.chiseled_red_sandstone",
          "block.minecraft.cut_red_sandstone",
          "block.minecraft.red_sandstone"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.red_sandstone_wall",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.red_sandstone"
        ],
        [
          "block.minecraft.red_sandstone"
        ],
        [
          "block.minecraft.red_sandstone"
        ],
        [
          "block.minecraft.red_sandstone"
        ],
        [
          "block.minecraft.red_sandstone"
        ],
        [
          "block.minecraft.red_sandstone"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.redstone_block",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.redstone"
        ],
        [
          "item.minecraft.redstone"
        ],
        [
          "item.minecraft.redstone"
        ],
        [
          "item.minecraft.redstone"
        ],
        [
          "item.minecraft.redstone"
        ],
        [
          "item.minecraft.redstone"
        ],
        [
          "item.minecraft.redstone"
        ],
        [
          "item.minecraft.redstone"
        ],
        [
          "item.minecraft.redstone"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.redstone_lamp",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.redstone"
        ],
        [
          "item.minecraft.redstone"
        ],
        [
          "block.minecraft.glowstone"
        ],
        [
          "item.minecraft.redstone"
        ],
        [
          "item.minecraft.redstone"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.redstone_torch",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.redstone"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.repeater",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.redstone_torch"
        ],
        [
          "item.minecraft.redstone"
        ],
        [
          "block.minecraft.redstone_torch"
        ],
        [
          "block.minecraft.stone"
        ],
        [
          "block.minecraft.stone"
        ],
        [
          "block.minecraft.stone"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.resin_block",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.resin_clump"
        ],
        [
          "item.minecraft.resin_clump"
        ],
        [
          "item.minecraft.resin_clump"
        ],
        [
          "item.minecraft.resin_clump"
        ],
        [
          "item.minecraft.resin_clump"
        ],
        [
          "item.minecraft.resin_clump"
        ],
        [
          "item.minecraft.resin_clump"
        ],
        [
          "item.minecraft.resin_clump"
        ],
        [
          "item.minecraft.resin_clump"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.resin_brick_slab",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.resin_bricks"
        ],
        [
          "block.minecraft.resin_bricks"
        ],
        [
          "block.minecraft.resin_bricks"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.resin_brick_stairs",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.resin_bricks"
        ],
        [
          "block.minecraft.resin_bricks"
        ],
        [
          "block.minecraft.resin_bricks"
        ],
        [
          "block.minecraft.resin_bricks"
        ],
        [
          "block.minecraft.resin_bricks"
        ],
        [
          "block.minecraft.resin_bricks"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.resin_brick_wall",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.resin_bricks"
        ],
        [
          "block.minecraft.resin_bricks"
        ],
        [
          "block.minecraft.resin_bricks"
        ],
        [
          "block.minecraft.resin_bricks"
        ],
        [
          "block.minecraft.resin_bricks"
        ],
        [
          "block.minecraft.resin_bricks"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.resin_bricks",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.resin_brick"
        ],
        [
          "item.minecraft.resin_brick"
        ],
        [
          "item.minecraft.resin_brick"
        ],
        [
          "item.minecraft.resin_brick"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.resin_clump",
      "size": 1,
      "ingredients": [
        [
          "block.minecraft.resin_block"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.respawn_anchor",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.crying_obsidian"
        ],
        [
          "block.minecraft.crying_obsidian"
        ],
        [
          "block.minecraft.crying_obsidian"
        ],
        [
          "block.minecraft.glowstone"
        ],
        [
          "block.minecraft.glowstone"
        ],
        [
          "block.minecraft.glowstone"
        ],
        [
          "block.minecraft.crying_obsidian"
        ],
        [
          "block.minecraft.crying_obsidian"
        ],
        [
          "block.minecraft.crying_obsidian"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.sandstone",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.sand"
        ],
        [
          "block.minecraft.sand"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.sandstone_slab",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.chiseled_sandstone",
          "block.minecraft.sandstone"
        ],
        [
          "block.minecraft.chiseled_sandstone",
          "block.minecraft.sandstone"
        ],
        [
          "block.minecraft.chiseled_sandstone",
          "block.minecraft.sandstone"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.sandstone_stairs",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.chiseled_sandstone",
          "block.minecraft.cut_sandstone",
          "block.minecraft.sandstone"
        ],
        [
          "block.minecraft.chiseled_sandstone",
          "block.minecraft.cut_sandstone",
          "block.minecraft.sandstone"
        ],
        [
          "block.minecraft.chiseled_sandstone",
          "block.minecraft.cut_sandstone",
          "block.minecraft.sandstone"
        ],
        [
          "block.minecraft.chiseled_sandstone",
          "block.minecraft.cut_sandstone",
          "block.minecraft.sandstone"
        ],
        [
          "block.minecraft.chiseled_sandstone",
          "block.minecraft.cut_sandstone",
          "block.minecraft.sandstone"
        ],
        [
          "block.minecraft.chiseled_sandstone",
          "block.minecraft.cut_sandstone",
          "block.minecraft.sandstone"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.sandstone_wall",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.sandstone"
        ],
        [
          "block.minecraft.sandstone"
        ],
        [
          "block.minecraft.sandstone"
        ],
        [
          "block.minecraft.sandstone"
        ],
        [
          "block.minecraft.sandstone"
        ],
        [
          "block.minecraft.sandstone"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.scaffolding",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.bamboo"
        ],
        [
          "item.minecraft.string"
        ],
        [
          "block.minecraft.bamboo"
        ],
        [
          "block.minecraft.bamboo"
        ],
        [
          "block.minecraft.bamboo"
        ],
        [
          "block.minecraft.bamboo"
        ],
        [
          "block.minecraft.bamboo"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.sea_lantern",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.prismarine_shard"
        ],
        [
          "item.minecraft.prismarine_crystals"
        ],
        [
          "item.minecraft.prismarine_shard"
        ],
        [
          "item.minecraft.prismarine_crystals"
        ],
        [
          "item.minecraft.prismarine_crystals"
        ],
        [
          "item.minecraft.prismarine_crystals"
        ],
        [
          "item.minecraft.prismarine_shard"
        ],
        [
          "item.minecraft.prismarine_crystals"
        ],
        [
          "item.minecraft.prismarine_shard"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.shulker_box",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.shulker_shell"
        ],
        [
          "block.minecraft.chest"
        ],
        [
          "item.minecraft.shulker_shell"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.slime_block",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.slime_ball"
        ],
        [
          "item.minecraft.slime_ball"
        ],
        [
          "item.minecraft.slime_ball"
        ],
        [
          "item.minecraft.slime_ball"
        ],
        [
          "item.minecraft.slime_ball"
        ],
        [
          "item.minecraft.slime_ball"
        ],
        [
          "item.minecraft.slime_ball"
        ],
        [
          "item.minecraft.slime_ball"
        ],
        [
          "item.minecraft.slime_ball"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.smithing_table",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.smoker",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.acacia_log",
          "block.minecraft.acacia_wood",
          "block.minecraft.birch_log",
          "block.minecraft.birch_wood",
          "block.minecraft.cherry_log",
          "block.minecraft.cherry_wood",
          "block.minecraft.crimson_hyphae",
          "block.minecraft.crimson_stem",
          "block.minecraft.dark_oak_log",
          "block.minecraft.dark_oak_wood",
          "block.minecraft.jungle_log",
          "block.minecraft.jungle_wood",
          "block.minecraft.mangrove_log",
          "block.minecraft.mangrove_wood",
          "block.minecraft.oak_log",
          "block.minecraft.oak_wood",
          "block.minecraft.pale_oak_log",
          "block.minecraft.pale_oak_wood",
          "block.minecraft.spruce_log",
          "block.minecraft.spruce_wood",
          "block.minecraft.stripped_acacia_log",
          "block.minecraft.stripped_acacia_wood",
          "block.minecraft.stripped_birch_log",
          "block.minecraft.stripped_birch_wood",
          "block.minecraft.stripped_cherry_log",
          "block.minecraft.stripped_cherry_wood",
          "block.minecraft.stripped_crimson_hyphae",
          "block.minecraft.stripped_crimson_stem",
          "block.minecraft.stripped_dark_oak_log",
          "block.minecraft.stripped_dark_oak_wood",
          "block.minecraft.stripped_jungle_log",
          "block.minecraft.stripped_jungle_wood",
          "block.minecraft.stripped_mangrove_log",
          "block.minecraft.stripped_mangrove_wood",
          "block.minecraft.stripped_oak_log",
          "block.minecraft.stripped_oak_wood",
          "block.minecraft.stripped_pale_oak_log",
          "block.minecraft.stripped_pale_oak_wood",
          "block.minecraft.stripped_spruce_log",
          "block.minecraft.stripped_spruce_wood",
          "block.minecraft.stripped_warped_hyphae",
          "block.minecraft.stripped_warped_stem",
          "block.minecraft.warped_hyphae",
          "block.minecraft.warped_stem"
        ],
        [
          "block.minecraft.acacia_log",
          "block.minecraft.acacia_wood",
          "block.minecraft.birch_log",
          "block.minecraft.birch_wood",
          "block.minecraft.cherry_log",
          "block.minecraft.cherry_wood",
          "block.minecraft.crimson_hyphae",
          "block.minecraft.crimson_stem",
          "block.minecraft.dark_oak_log",
          "block.minecraft.dark_oak_wood",
          "block.minecraft.jungle_log",
          "block.minecraft.jungle_wood",
          "block.minecraft.mangrove_log",
          "block.minecraft.mangrove_wood",
          "block.minecraft.oak_log",
          "block.minecraft.oak_wood",
          "block.minecraft.pale_oak_log",
          "block.minecraft.pale_oak_wood",
          "block.minecraft.spruce_log",
          "block.minecraft.spruce_wood",
          "block.minecraft.stripped_acacia_log",
          "block.minecraft.stripped_acacia_wood",
          "block.minecraft.stripped_birch_log",
          "block.minecraft.stripped_birch_wood",
          "block.minecraft.stripped_cherry_log",
          "block.minecraft.stripped_cherry_wood",
          "block.minecraft.stripped_crimson_hyphae",
          "block.minecraft.stripped_crimson_stem",
          "block.minecraft.stripped_dark_oak_log",
          "block.minecraft.stripped_dark_oak_wood",
          "block.minecraft.stripped_jungle_log",
          "block.minecraft.stripped_jungle_wood",
          "block.minecraft.stripped_mangrove_log",
          "block.minecraft.stripped_mangrove_wood",
          "block.minecraft.stripped_oak_log",
          "block.minecraft.stripped_oak_wood",
          "block.minecraft.stripped_pale_oak_log",
          "block.minecraft.stripped_pale_oak_wood",
          "block.minecraft.stripped_spruce_log",
          "block.minecraft.stripped_spruce_wood",
          "block.minecraft.stripped_warped_hyphae",
          "block.minecraft.stripped_warped_stem",
          "block.minecraft.warped_hyphae",
          "block.minecraft.warped_stem"
        ],
        [
          "block.minecraft.furnace"
        ],
        [
          "block.minecraft.acacia_log",
          "block.minecraft.acacia_wood",
          "block.minecraft.birch_log",
          "block.minecraft.birch_wood",
          "block.minecraft.cherry_log",
          "block.minecraft.cherry_wood",
          "block.minecraft.crimson_hyphae",
          "block.minecraft.crimson_stem",
          "block.minecraft.dark_oak_log",
          "block.minecraft.dark_oak_wood",
          "block.minecraft.jungle_log",
          "block.minecraft.jungle_wood",
          "block.minecraft.mangrove_log",
          "block.minecraft.mangrove_wood",
          "block.minecraft.oak_log",
          "block.minecraft.oak_wood",
          "block.minecraft.pale_oak_log",
          "block.minecraft.pale_oak_wood",
          "block.minecraft.spruce_log",
          "block.minecraft.spruce_wood",
          "block.minecraft.stripped_acacia_log",
          "block.minecraft.stripped_acacia_wood",
          "block.minecraft.stripped_birch_log",
          "block.minecraft.stripped_birch_wood",
          "block.minecraft.stripped_cherry_log",
          "block.minecraft.stripped_cherry_wood",
          "block.minecraft.stripped_crimson_hyphae",
          "block.minecraft.stripped_crimson_stem",
          "block.minecraft.stripped_dark_oak_log",
          "block.minecraft.stripped_dark_oak_wood",
          "block.minecraft.stripped_jungle_log",
          "block.minecraft.stripped_jungle_wood",
          "block.minecraft.stripped_mangrove_log",
          "block.minecraft.stripped_mangrove_wood",
          "block.minecraft.stripped_oak_log",
          "block.minecraft.stripped_oak_wood",
          "block.minecraft.stripped_pale_oak_log",
          "block.minecraft.stripped_pale_oak_wood",
          "block.minecraft.stripped_spruce_log",
          "block.minecraft.stripped_spruce_wood",
          "block.minecraft.stripped_warped_hyphae",
          "block.minecraft.stripped_warped_stem",
          "block.minecraft.warped_hyphae",
          "block.minecraft.warped_stem"
        ],
        [
          "block.minecraft.acacia_log",
          "block.minecraft.acacia_wood",
          "block.minecraft.birch_log",
          "block.minecraft.birch_wood",
          "block.minecraft.cherry_log",
          "block.minecraft.cherry_wood",
          "block.minecraft.crimson_hyphae",
          "block.minecraft.crimson_stem",
          "block.minecraft.dark_oak_log",
          "block.minecraft.dark_oak_wood",
          "block.minecraft.jungle_log",
          "block.minecraft.jungle_wood",
          "block.minecraft.mangrove_log",
          "block.minecraft.mangrove_wood",
          "block.minecraft.oak_log",
          "block.minecraft.oak_wood",
          "block.minecraft.pale_oak_log",
          "block.minecraft.pale_oak_wood",
          "block.minecraft.spruce_log",
          "block.minecraft.spruce_wood",
          "block.minecraft.stripped_acacia_log",
          "block.minecraft.stripped_acacia_wood",
          "block.minecraft.stripped_birch_log",
          "block.minecraft.stripped_birch_wood",
          "block.minecraft.stripped_cherry_log",
          "block.minecraft.stripped_cherry_wood",
          "block.minecraft.stripped_crimson_hyphae",
          "block.minecraft.stripped_crimson_stem",
          "block.minecraft.stripped_dark_oak_log",
          "block.minecraft.stripped_dark_oak_wood",
          "block.minecraft.stripped_jungle_log",
          "block.minecraft.stripped_jungle_wood",
          "block.minecraft.stripped_mangrove_log",
          "block.minecraft.stripped_mangrove_wood",
          "block.minecraft.stripped_oak_log",
          "block.minecraft.stripped_oak_wood",
          "block.minecraft.stripped_pale_oak_log",
          "block.minecraft.stripped_pale_oak_wood",
          "block.minecraft.stripped_spruce_log",
          "block.minecraft.stripped_spruce_wood",
          "block.minecraft.stripped_warped_hyphae",
          "block.minecraft.stripped_warped_stem",
          "block.minecraft.warped_hyphae",
          "block.minecraft.warped_stem"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.smooth_quartz_slab",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.smooth_quartz"
        ],
        [
          "block.minecraft.smooth_quartz"
        ],
        [
          "block.minecraft.smooth_quartz"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.smooth_quartz_stairs",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.smooth_quartz"
        ],
        [
          "block.minecraft.smooth_quartz"
        ],
        [
          "block.minecraft.smooth_quartz"
        ],
        [
          "block.minecraft.smooth_quartz"
        ],
        [
          "block.minecraft.smooth_quartz"
        ],
        [
          "block.minecraft.smooth_quartz"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.smooth_red_sandstone_slab",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.smooth_red_sandstone"
        ],
        [
          "block.minecraft.smooth_red_sandstone"
        ],
        [
          "block.minecraft.smooth_red_sandstone"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.smooth_red_sandstone_stairs",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.smooth_red_sandstone"
        ],
        [
          "block.minecraft.smooth_red_sandstone"
        ],
        [
          "block.minecraft.smooth_red_sandstone"
        ],
        [
          "block.minecraft.smooth_red_sandstone"
        ],
        [
          "block.minecraft.smooth_red_sandstone"
        ],
        [
          "block.minecraft.smooth_red_sandstone"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.smooth_sandstone_slab",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.smooth_sandstone"
        ],
        [
          "block.minecraft.smooth_sandstone"
        ],
        [
          "block.minecraft.smooth_sandstone"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.smooth_sandstone_stairs",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.smooth_sandstone"
        ],
        [
          "block.minecraft.smooth_sandstone"
        ],
        [
          "block.minecraft.smooth_sandstone"
        ],
        [
          "block.minecraft.smooth_sandstone"
        ],
        [
          "block.minecraft.smooth_sandstone"
        ],
        [
          "block.minecraft.smooth_sandstone"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.smooth_stone_slab",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.smooth_stone"
        ],
        [
          "block.minecraft.smooth_stone"
        ],
        [
          "block.minecraft.smooth_stone"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.snow",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.snow_block"
        ],
        [
          "block.minecraft.snow_block"
        ],
        [
          "block.minecraft.snow_block"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.snow_block",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.snowball"
        ],
        [
          "item.minecraft.snowball"
        ],
        [
          "item.minecraft.snowball"
        ],
        [
          "item.minecraft.snowball"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.soul_campfire",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "block.minecraft.soul_sand",
          "block.minecraft.soul_soil"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "block.minecraft.acacia_log",
          "block.minecraft.acacia_wood",
          "block.minecraft.birch_log",
          "block.minecraft.birch_wood",
          "block.minecraft.cherry_log",
          "block.minecraft.cherry_wood",
          "block.minecraft.crimson_hyphae",
          "block.minecraft.crimson_stem",
          "block.minecraft.dark_oak_log",
          "block.minecraft.dark_oak_wood",
          "block.minecraft.jungle_log",
          "block.minecraft.jungle_wood",
          "block.minecraft.mangrove_log",
          "block.minecraft.mangrove_wood",
          "block.minecraft.oak_log",
          "block.minecraft.oak_wood",
          "block.minecraft.pale_oak_log",
          "block.minecraft.pale_oak_wood",
          "block.minecraft.spruce_log",
          "block.minecraft.spruce_wood",
          "block.minecraft.stripped_acacia_log",
          "block.minecraft.stripped_acacia_wood",
          "block.minecraft.stripped_birch_log",
          "block.minecraft.stripped_birch_wood",
          "block.minecraft.stripped_cherry_log",
          "block.minecraft.stripped_cherry_wood",
          "block.minecraft.stripped_crimson_hyphae",
          "block.minecraft.stripped_crimson_stem",
          "block.minecraft.stripped_dark_oak_log",
          "block.minecraft.stripped_dark_oak_wood",
          "block.minecraft.stripped_jungle_log",
          "block.minecraft.stripped_jungle_wood",
          "block.minecraft.stripped_mangrove_log",
          "block.minecraft.stripped_mangrove_wood",
          "block.minecraft.stripped_oak_log",
          "block.minecraft.stripped_oak_wood",
          "block.minecraft.stripped_pale_oak_log",
          "block.minecraft.stripped_pale_oak_wood",
          "block.minecraft.stripped_spruce_log",
          "block.minecraft.stripped_spruce_wood",
          "block.minecraft.stripped_warped_hyphae",
          "block.minecraft.stripped_warped_stem",
          "block.minecraft.warped_hyphae",
          "block.minecraft.warped_stem"
        ],
        [
          "block.minecraft.acacia_log",
          "block.minecraft.acacia_wood",
          "block.minecraft.birch_log",
          "block.minecraft.birch_wood",
          "block.minecraft.cherry_log",
          "block.minecraft.cherry_wood",
          "block.minecraft.crimson_hyphae",
          "block.minecraft.crimson_stem",
          "block.minecraft.dark_oak_log",
          "block.minecraft.dark_oak_wood",
          "block.minecraft.jungle_log",
          "block.minecraft.jungle_wood",
          "block.minecraft.mangrove_log",
          "block.minecraft.mangrove_wood",
          "block.minecraft.oak_log",
          "block.minecraft.oak_wood",
          "block.minecraft.pale_oak_log",
          "block.minecraft.pale_oak_wood",
          "block.minecraft.spruce_log",
          "block.minecraft.spruce_wood",
          "block.minecraft.stripped_acacia_log",
          "block.minecraft.stripped_acacia_wood",
          "block.minecraft.stripped_birch_log",
          "block.minecraft.stripped_birch_wood",
          "block.minecraft.stripped_cherry_log",
          "block.minecraft.stripped_cherry_wood",
          "block.minecraft.stripped_crimson_hyphae",
          "block.minecraft.stripped_crimson_stem",
          "block.minecraft.stripped_dark_oak_log",
          "block.minecraft.stripped_dark_oak_wood",
          "block.minecraft.stripped_jungle_log",
          "block.minecraft.stripped_jungle_wood",
          "block.minecraft.stripped_mangrove_log",
          "block.minecraft.stripped_mangrove_wood",
          "block.minecraft.stripped_oak_log",
          "block.minecraft.stripped_oak_wood",
          "block.minecraft.stripped_pale_oak_log",
          "block.minecraft.stripped_pale_oak_wood",
          "block.minecraft.stripped_spruce_log",
          "block.minecraft.stripped_spruce_wood",
          "block.minecraft.stripped_warped_hyphae",
          "block.minecraft.stripped_warped_stem",
          "block.minecraft.warped_hyphae",
          "block.minecraft.warped_stem"
        ],
        [
          "block.minecraft.acacia_log",
          "block.minecraft.acacia_wood",
          "block.minecraft.birch_log",
          "block.minecraft.birch_wood",
          "block.minecraft.cherry_log",
          "block.minecraft.cherry_wood",
          "block.minecraft.crimson_hyphae",
          "block.minecraft.crimson_stem",
          "block.minecraft.dark_oak_log",
          "block.minecraft.dark_oak_wood",
          "block.minecraft.jungle_log",
          "block.minecraft.jungle_wood",
          "block.minecraft.mangrove_log",
          "block.minecraft.mangrove_wood",
          "block.minecraft.oak_log",
          "block.minecraft.oak_wood",
          "block.minecraft.pale_oak_log",
          "block.minecraft.pale_oak_wood",
          "block.minecraft.spruce_log",
          "block.minecraft.spruce_wood",
          "block.minecraft.stripped_acacia_log",
          "block.minecraft.stripped_acacia_wood",
          "block.minecraft.stripped_birch_log",
          "block.minecraft.stripped_birch_wood",
          "block.minecraft.stripped_cherry_log",
          "block.minecraft.stripped_cherry_wood",
          "block.minecraft.stripped_crimson_hyphae",
          "block.minecraft.stripped_crimson_stem",
          "block.minecraft.stripped_dark_oak_log",
          "block.minecraft.stripped_dark_oak_wood",
          "block.minecraft.stripped_jungle_log",
          "block.minecraft.stripped_jungle_wood",
          "block.minecraft.stripped_mangrove_log",
          "block.minecraft.stripped_mangrove_wood",
          "block.minecraft.stripped_oak_log",
          "block.minecraft.stripped_oak_wood",
          "block.minecraft.stripped_pale_oak_log",
          "block.minecraft.stripped_pale_oak_wood",
          "block.minecraft.stripped_spruce_log",
          "block.minecraft.stripped_spruce_wood",
          "block.minecraft.stripped_warped_hyphae",
          "block.minecraft.stripped_warped_stem",
          "block.minecraft.warped_hyphae",
          "block.minecraft.warped_stem"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.soul_lantern",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.iron_nugget"
        ],
        [
          "item.minecraft.iron_nugget"
        ],
        [
          "item.minecraft.iron_nugget"
        ],
        [
          "item.minecraft.iron_nugget"
        ],
        [
          "block.minecraft.soul_torch"
        ],
        [
          "item.minecraft.iron_nugget"
        ],
        [
          "item.minecraft.iron_nugget"
        ],
        [
          "item.minecraft.iron_nugget"
        ],
        [
          "item.minecraft.iron_nugget"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.soul_torch",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.charcoal",
          "item.minecraft.coal"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "block.minecraft.soul_sand",
          "block.minecraft.soul_soil"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.sticky_piston",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.slime_ball"
        ],
        [
          "block.minecraft.piston"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.stone_brick_slab",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.stone_bricks"
        ],
        [
          "block.minecraft.stone_bricks"
        ],
        [
          "block.minecraft.stone_bricks"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.stone_brick_stairs",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.stone_bricks"
        ],
        [
          "block.minecraft.stone_bricks"
        ],
        [
          "block.minecraft.stone_bricks"
        ],
        [
          "block.minecraft.stone_bricks"
        ],
        [
          "block.minecraft.stone_bricks"
        ],
        [
          "block.minecraft.stone_bricks"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.stone_brick_wall",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.stone_bricks"
        ],
        [
          "block.minecraft.stone_bricks"
        ],
        [
          "block.minecraft.stone_bricks"
        ],
        [
          "block.minecraft.stone_bricks"
        ],
        [
          "block.minecraft.stone_bricks"
        ],
        [
          "block.minecraft.stone_bricks"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.stone_bricks",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.stone"
        ],
        [
          "block.minecraft.stone"
        ],
        [
          "block.minecraft.stone"
        ],
        [
          "block.minecraft.stone"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.stone_button",
      "size": 1,
      "ingredients": [
        [
          "block.minecraft.stone"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.stone_pressure_plate",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.stone"
        ],
        [
          "block.minecraft.stone"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.stone_slab",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.stone"
        ],
        [
          "block.minecraft.stone"
        ],
        [
          "block.minecraft.stone"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.stone_stairs",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.stone"
        ],
        [
          "block.minecraft.stone"
        ],
        [
          "block.minecraft.stone"
        ],
        [
          "block.minecraft.stone"
        ],
        [
          "block.minecraft.stone"
        ],
        [
          "block.minecraft.stone"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.stonecutter",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "block.minecraft.stone"
        ],
        [
          "block.minecraft.stone"
        ],
        [
          "block.minecraft.stone"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.target",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.redstone"
        ],
        [
          "item.minecraft.redstone"
        ],
        [
          "block.minecraft.hay_block"
        ],
        [
          "item.minecraft.redstone"
        ],
        [
          "item.minecraft.redstone"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.tinted_glass",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.amethyst_shard"
        ],
        [
          "item.minecraft.amethyst_shard"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "item.minecraft.amethyst_shard"
        ],
        [
          "item.minecraft.amethyst_shard"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.tnt",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.gunpowder"
        ],
        [
          "block.minecraft.red_sand",
          "block.minecraft.sand"
        ],
        [
          "item.minecraft.gunpowder"
        ],
        [
          "block.minecraft.red_sand",
          "block.minecraft.sand"
        ],
        [
          "item.minecraft.gunpowder"
        ],
        [
          "block.minecraft.red_sand",
          "block.minecraft.sand"
        ],
        [
          "item.minecraft.gunpowder"
        ],
        [
          "block.minecraft.red_sand",
          "block.minecraft.sand"
        ],
        [
          "item.minecraft.gunpowder"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.torch",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.charcoal",
          "item.minecraft.coal"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.trapped_chest",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.chest"
        ],
        [
          "block.minecraft.tripwire_hook"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.tripwire_hook",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.tuff_brick_slab",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.tuff_bricks"
        ],
        [
          "block.minecraft.tuff_bricks"
        ],
        [
          "block.minecraft.tuff_bricks"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.tuff_brick_stairs",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.tuff_bricks"
        ],
        [
          "block.minecraft.tuff_bricks"
        ],
        [
          "block.minecraft.tuff_bricks"
        ],
        [
          "block.minecraft.tuff_bricks"
        ],
        [
          "block.minecraft.tuff_bricks"
        ],
        [
          "block.minecraft.tuff_bricks"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.tuff_brick_wall",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.tuff_bricks"
        ],
        [
          "block.minecraft.tuff_bricks"
        ],
        [
          "block.minecraft.tuff_bricks"
        ],
        [
          "block.minecraft.tuff_bricks"
        ],
        [
          "block.minecraft.tuff_bricks"
        ],
        [
          "block.minecraft.tuff_bricks"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.tuff_bricks",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.polished_tuff"
        ],
        [
          "block.minecraft.polished_tuff"
        ],
        [
          "block.minecraft.polished_tuff"
        ],
        [
          "block.minecraft.polished_tuff"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.tuff_slab",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.tuff"
        ],
        [
          "block.minecraft.tuff"
        ],
        [
          "block.minecraft.tuff"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.tuff_stairs",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.tuff"
        ],
        [
          "block.minecraft.tuff"
        ],
        [
          "block.minecraft.tuff"
        ],
        [
          "block.minecraft.tuff"
        ],
        [
          "block.minecraft.tuff"
        ],
        [
          "block.minecraft.tuff"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.tuff_wall",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.tuff"
        ],
        [
          "block.minecraft.tuff"
        ],
        [
          "block.minecraft.tuff"
        ],
        [
          "block.minecraft.tuff"
        ],
        [
          "block.minecraft.tuff"
        ],
        [
          "block.minecraft.tuff"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.waxed_chiseled_copper",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.waxed_cut_copper_slab"
        ],
        [
          "block.minecraft.waxed_cut_copper_slab"
        ]
      ]
    },
    {
      "output": "block.minecraft.waxed_chiseled_copper",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.chiseled_copper"
        ],
        [
          "item.minecraft.honeycomb"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.waxed_copper_bars",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.copper_bars"
        ],
        [
          "item.minecraft.honeycomb"
        ]
      ]
    },
    {
      "output": "block.minecraft.waxed_exposed_copper_bars",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.exposed_copper_bars"
        ],
        [
          "item.minecraft.honeycomb"
        ]
      ]
    },
    {
      "output": "block.minecraft.waxed_oxidized_copper_bars",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.oxidized_copper_bars"
        ],
        [
          "item.minecraft.honeycomb"
        ]
      ]
    },
    {
      "output": "block.minecraft.waxed_weathered_copper_bars",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.weathered_copper_bars"
        ],
        [
          "item.minecraft.honeycomb"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.waxed_copper_block",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.copper_block"
        ],
        [
          "item.minecraft.honeycomb"
        ]
      ]
    },
    {
      "output": "block.minecraft.waxed_exposed_copper",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.exposed_copper"
        ],
        [
          "item.minecraft.honeycomb"
        ]
      ]
    },
    {
      "output": "block.minecraft.waxed_oxidized_copper",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.oxidized_copper"
        ],
        [
          "item.minecraft.honeycomb"
        ]
      ]
    },
    {
      "output": "block.minecraft.waxed_weathered_copper",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.weathered_copper"
        ],
        [
          "item.minecraft.honeycomb"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.waxed_copper_bulb",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.waxed_copper_block"
        ],
        [
          "block.minecraft.waxed_copper_block"
        ],
        [
          "item.minecraft.blaze_rod"
        ],
        [
          "block.minecraft.waxed_copper_block"
        ],
        [
          "item.minecraft.redstone"
        ]
      ]
    },
    {
      "output": "block.minecraft.waxed_copper_bulb",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.copper_bulb"
        ],
        [
          "item.minecraft.honeycomb"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.waxed_copper_chain",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.copper_chain"
        ],
        [
          "item.minecraft.honeycomb"
        ]
      ]
    },
    {
      "output": "block.minecraft.waxed_exposed_copper_chain",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.exposed_copper_chain"
        ],
        [
          "item.minecraft.honeycomb"
        ]
      ]
    },
    {
      "output": "block.minecraft.waxed_oxidized_copper_chain",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.oxidized_copper_chain"
        ],
        [
          "item.minecraft.honeycomb"
        ]
      ]
    },
    {
      "output": "block.minecraft.waxed_weathered_copper_chain",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.weathered_copper_chain"
        ],
        [
          "item.minecraft.honeycomb"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.waxed_copper_chest",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.copper_chest"
        ],
        [
          "item.minecraft.honeycomb"
        ]
      ]
    },
    {
      "output": "block.minecraft.waxed_exposed_copper_chest",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.exposed_copper_chest"
        ],
        [
          "item.minecraft.honeycomb"
        ]
      ]
    },
    {
      "output": "block.minecraft.waxed_oxidized_copper_chest",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.oxidized_copper_chest"
        ],
        [
          "item.minecraft.honeycomb"
        ]
      ]
    },
    {
      "output": "block.minecraft.waxed_weathered_copper_chest",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.weathered_copper_chest"
        ],
        [
          "item.minecraft.honeycomb"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.waxed_copper_door",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.copper_door"
        ],
        [
          "item.minecraft.honeycomb"
        ]
      ]
    },
    {
      "output": "block.minecraft.waxed_exposed_copper_door",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.exposed_copper_door"
        ],
        [
          "item.minecraft.honeycomb"
        ]
      ]
    },
    {
      "output": "block.minecraft.waxed_oxidized_copper_door",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.oxidized_copper_door"
        ],
        [
          "item.minecraft.honeycomb"
        ]
      ]
    },
    {
      "output": "block.minecraft.waxed_weathered_copper_door",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.weathered_copper_door"
        ],
        [
          "item.minecraft.honeycomb"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.waxed_copper_golem_statue",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.copper_golem_statue"
        ],
        [
          "item.minecraft.honeycomb"
        ]
      ]
    },
    {
      "output": "block.minecraft.waxed_exposed_copper_golem_statue",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.exposed_copper_golem_statue"
        ],
        [
          "item.minecraft.honeycomb"
        ]
      ]
    },
    {
      "output": "block.minecraft.waxed_oxidized_copper_golem_statue",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.oxidized_copper_golem_statue"
        ],
        [
          "item.minecraft.honeycomb"
        ]
      ]
    },
    {
      "output": "block.minecraft.waxed_weathered_copper_golem_statue",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.weathered_copper_golem_statue"
        ],
        [
          "item.minecraft.honeycomb"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.waxed_copper_grate",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.waxed_copper_block"
        ],
        [
          "block.minecraft.waxed_copper_block"
        ],
        [
          "block.minecraft.waxed_copper_block"
        ],
        [
          "block.minecraft.waxed_copper_block"
        ]
      ]
    },
    {
      "output": "block.minecraft.waxed_copper_grate",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.copper_grate"
        ],
        [
          "item.minecraft.honeycomb"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.waxed_copper_lantern",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.copper_lantern"
        ],
        [
          "item.minecraft.honeycomb"
        ]
      ]
    },
    {
      "output": "block.minecraft.waxed_exposed_copper_lantern",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.exposed_copper_lantern"
        ],
        [
          "item.minecraft.honeycomb"
        ]
      ]
    },
    {
      "output": "block.minecraft.waxed_oxidized_copper_lantern",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.oxidized_copper_lantern"
        ],
        [
          "item.minecraft.honeycomb"
        ]
      ]
    },
    {
      "output": "block.minecraft.waxed_weathered_copper_lantern",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.weathered_copper_lantern"
        ],
        [
          "item.minecraft.honeycomb"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.waxed_copper_trapdoor",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.copper_trapdoor"
        ],
        [
          "item.minecraft.honeycomb"
        ]
      ]
    },
    {
      "output": "block.minecraft.waxed_exposed_copper_trapdoor",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.exposed_copper_trapdoor"
        ],
        [
          "item.minecraft.honeycomb"
        ]
      ]
    },
    {
      "output": "block.minecraft.waxed_oxidized_copper_trapdoor",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.oxidized_copper_trapdoor"
        ],
        [
          "item.minecraft.honeycomb"
        ]
      ]
    },
    {
      "output": "block.minecraft.waxed_weathered_copper_trapdoor",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.weathered_copper_trapdoor"
        ],
        [
          "item.minecraft.honeycomb"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.waxed_cut_copper",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.waxed_copper_block"
        ],
        [
          "block.minecraft.waxed_copper_block"
        ],
        [
          "block.minecraft.waxed_copper_block"
        ],
        [
          "block.minecraft.waxed_copper_block"
        ]
      ]
    },
    {
      "output": "block.minecraft.waxed_cut_copper",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.cut_copper"
        ],
        [
          "item.minecraft.honeycomb"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.waxed_cut_copper_slab",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.waxed_cut_copper"
        ],
        [
          "block.minecraft.waxed_cut_copper"
        ],
        [
          "block.minecraft.waxed_cut_copper"
        ]
      ]
    },
    {
      "output": "block.minecraft.waxed_cut_copper_slab",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.cut_copper_slab"
        ],
        [
          "item.minecraft.honeycomb"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.waxed_cut_copper_stairs",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.waxed_cut_copper"
        ],
        [
          "block.minecraft.waxed_cut_copper"
        ],
        [
          "block.minecraft.waxed_cut_copper"
        ],
        [
          "block.minecraft.waxed_cut_copper"
        ],
        [
          "block.minecraft.waxed_cut_copper"
        ],
        [
          "block.minecraft.waxed_cut_copper"
        ]
      ]
    },
    {
      "output": "block.minecraft.waxed_cut_copper_stairs",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.cut_copper_stairs"
        ],
        [
          "item.minecraft.honeycomb"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.waxed_exposed_chiseled_copper",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.waxed_exposed_cut_copper_slab"
        ],
        [
          "block.minecraft.waxed_exposed_cut_copper_slab"
        ]
      ]
    },
    {
      "output": "block.minecraft.waxed_exposed_chiseled_copper",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.exposed_chiseled_copper"
        ],
        [
          "item.minecraft.honeycomb"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.waxed_exposed_copper_bulb",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.waxed_exposed_copper"
        ],
        [
          "block.minecraft.waxed_exposed_copper"
        ],
        [
          "item.minecraft.blaze_rod"
        ],
        [
          "block.minecraft.waxed_exposed_copper"
        ],
        [
          "item.minecraft.redstone"
        ]
      ]
    },
    {
      "output": "block.minecraft.waxed_exposed_copper_bulb",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.exposed_copper_bulb"
        ],
        [
          "item.minecraft.honeycomb"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.waxed_exposed_copper_grate",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.waxed_exposed_copper"
        ],
        [
          "block.minecraft.waxed_exposed_copper"
        ],
        [
          "block.minecraft.waxed_exposed_copper"
        ],
        [
          "block.minecraft.waxed_exposed_copper"
        ]
      ]
    },
    {
      "output": "block.minecraft.waxed_exposed_copper_grate",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.exposed_copper_grate"
        ],
        [
          "item.minecraft.honeycomb"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.waxed_exposed_cut_copper",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.waxed_exposed_copper"
        ],
        [
          "block.minecraft.waxed_exposed_copper"
        ],
        [
          "block.minecraft.waxed_exposed_copper"
        ],
        [
          "block.minecraft.waxed_exposed_copper"
        ]
      ]
    },
    {
      "output": "block.minecraft.waxed_exposed_cut_copper",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.exposed_cut_copper"
        ],
        [
          "item.minecraft.honeycomb"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.waxed_exposed_cut_copper_slab",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.waxed_exposed_cut_copper"
        ],
        [
          "block.minecraft.waxed_exposed_cut_copper"
        ],
        [
          "block.minecraft.waxed_exposed_cut_copper"
        ]
      ]
    },
    {
      "output": "block.minecraft.waxed_exposed_cut_copper_slab",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.exposed_cut_copper_slab"
        ],
        [
          "item.minecraft.honeycomb"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.waxed_exposed_cut_copper_stairs",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.waxed_exposed_cut_copper"
        ],
        [
          "block.minecraft.waxed_exposed_cut_copper"
        ],
        [
          "block.minecraft.waxed_exposed_cut_copper"
        ],
        [
          "block.minecraft.waxed_exposed_cut_copper"
        ],
        [
          "block.minecraft.waxed_exposed_cut_copper"
        ],
        [
          "block.minecraft.waxed_exposed_cut_copper"
        ]
      ]
    },
    {
      "output": "block.minecraft.waxed_exposed_cut_copper_stairs",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.exposed_cut_copper_stairs"
        ],
        [
          "item.minecraft.honeycomb"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.waxed_exposed_lightning_rod",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.exposed_lightning_rod"
        ],
        [
          "item.minecraft.honeycomb"
        ]
      ]
    },
    {
      "output": "block.minecraft.waxed_lightning_rod",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.lightning_rod"
        ],
        [
          "item.minecraft.honeycomb"
        ]
      ]
    },
    {
      "output": "block.minecraft.waxed_oxidized_lightning_rod",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.oxidized_lightning_rod"
        ],
        [
          "item.minecraft.honeycomb"
        ]
      ]
    },
    {
      "output": "block.minecraft.waxed_weathered_lightning_rod",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.weathered_lightning_rod"
        ],
        [
          "item.minecraft.honeycomb"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.waxed_oxidized_chiseled_copper",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.waxed_oxidized_cut_copper_slab"
        ],
        [
          "block.minecraft.waxed_oxidized_cut_copper_slab"
        ]
      ]
    },
    {
      "output": "block.minecraft.waxed_oxidized_chiseled_copper",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.oxidized_chiseled_copper"
        ],
        [
          "item.minecraft.honeycomb"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.waxed_oxidized_copper_bulb",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.waxed_oxidized_copper"
        ],
        [
          "block.minecraft.waxed_oxidized_copper"
        ],
        [
          "item.minecraft.blaze_rod"
        ],
        [
          "block.minecraft.waxed_oxidized_copper"
        ],
        [
          "item.minecraft.redstone"
        ]
      ]
    },
    {
      "output": "block.minecraft.waxed_oxidized_copper_bulb",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.oxidized_copper_bulb"
        ],
        [
          "item.minecraft.honeycomb"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.waxed_oxidized_copper_grate",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.waxed_oxidized_copper"
        ],
        [
          "block.minecraft.waxed_oxidized_copper"
        ],
        [
          "block.minecraft.waxed_oxidized_copper"
        ],
        [
          "block.minecraft.waxed_oxidized_copper"
        ]
      ]
    },
    {
      "output": "block.minecraft.waxed_oxidized_copper_grate",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.oxidized_copper_grate"
        ],
        [
          "item.minecraft.honeycomb"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.waxed_oxidized_cut_copper",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.waxed_oxidized_copper"
        ],
        [
          "block.minecraft.waxed_oxidized_copper"
        ],
        [
          "block.minecraft.waxed_oxidized_copper"
        ],
        [
          "block.minecraft.waxed_oxidized_copper"
        ]
      ]
    },
    {
      "output": "block.minecraft.waxed_oxidized_cut_copper",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.oxidized_cut_copper"
        ],
        [
          "item.minecraft.honeycomb"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.waxed_oxidized_cut_copper_slab",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.waxed_oxidized_cut_copper"
        ],
        [
          "block.minecraft.waxed_oxidized_cut_copper"
        ],
        [
          "block.minecraft.waxed_oxidized_cut_copper"
        ]
      ]
    },
    {
      "output": "block.minecraft.waxed_oxidized_cut_copper_slab",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.oxidized_cut_copper_slab"
        ],
        [
          "item.minecraft.honeycomb"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.waxed_oxidized_cut_copper_stairs",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.waxed_oxidized_cut_copper"
        ],
        [
          "block.minecraft.waxed_oxidized_cut_copper"
        ],
        [
          "block.minecraft.waxed_oxidized_cut_copper"
        ],
        [
          "block.minecraft.waxed_oxidized_cut_copper"
        ],
        [
          "block.minecraft.waxed_oxidized_cut_copper"
        ],
        [
          "block.minecraft.waxed_oxidized_cut_copper"
        ]
      ]
    },
    {
      "output": "block.minecraft.waxed_oxidized_cut_copper_stairs",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.oxidized_cut_copper_stairs"
        ],
        [
          "item.minecraft.honeycomb"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.waxed_weathered_chiseled_copper",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.waxed_weathered_cut_copper_slab"
        ],
        [
          "block.minecraft.waxed_weathered_cut_copper_slab"
        ]
      ]
    },
    {
      "output": "block.minecraft.waxed_weathered_chiseled_copper",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.weathered_chiseled_copper"
        ],
        [
          "item.minecraft.honeycomb"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.waxed_weathered_copper_bulb",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.waxed_weathered_copper"
        ],
        [
          "block.minecraft.waxed_weathered_copper"
        ],
        [
          "item.minecraft.blaze_rod"
        ],
        [
          "block.minecraft.waxed_weathered_copper"
        ],
        [
          "item.minecraft.redstone"
        ]
      ]
    },
    {
      "output": "block.minecraft.waxed_weathered_copper_bulb",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.weathered_copper_bulb"
        ],
        [
          "item.minecraft.honeycomb"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.waxed_weathered_copper_grate",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.waxed_weathered_copper"
        ],
        [
          "block.minecraft.waxed_weathered_copper"
        ],
        [
          "block.minecraft.waxed_weathered_copper"
        ],
        [
          "block.minecraft.waxed_weathered_copper"
        ]
      ]
    },
    {
      "output": "block.minecraft.waxed_weathered_copper_grate",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.weathered_copper_grate"
        ],
        [
          "item.minecraft.honeycomb"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.waxed_weathered_cut_copper",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.waxed_weathered_copper"
        ],
        [
          "block.minecraft.waxed_weathered_copper"
        ],
        [
          "block.minecraft.waxed_weathered_copper"
        ],
        [
          "block.minecraft.waxed_weathered_copper"
        ]
      ]
    },
    {
      "output": "block.minecraft.waxed_weathered_cut_copper",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.weathered_cut_copper"
        ],
        [
          "item.minecraft.honeycomb"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.waxed_weathered_cut_copper_slab",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.waxed_weathered_cut_copper"
        ],
        [
          "block.minecraft.waxed_weathered_cut_copper"
        ],
        [
          "block.minecraft.waxed_weathered_cut_copper"
        ]
      ]
    },
    {
      "output": "block.minecraft.waxed_weathered_cut_copper_slab",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.weathered_cut_copper_slab"
        ],
        [
          "item.minecraft.honeycomb"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.waxed_weathered_cut_copper_stairs",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.waxed_weathered_cut_copper"
        ],
        [
          "block.minecraft.waxed_weathered_cut_copper"
        ],
        [
          "block.minecraft.waxed_weathered_cut_copper"
        ],
        [
          "block.minecraft.waxed_weathered_cut_copper"
        ],
        [
          "block.minecraft.waxed_weathered_cut_copper"
        ],
        [
          "block.minecraft.waxed_weathered_cut_copper"
        ]
      ]
    },
    {
      "output": "block.minecraft.waxed_weathered_cut_copper_stairs",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.weathered_cut_copper_stairs"
        ],
        [
          "item.minecraft.honeycomb"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.weathered_chiseled_copper",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.weathered_cut_copper_slab"
        ],
        [
          "block.minecraft.weathered_cut_copper_slab"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.weathered_copper_bulb",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.weathered_copper"
        ],
        [
          "block.minecraft.weathered_copper"
        ],
        [
          "item.minecraft.blaze_rod"
        ],
        [
          "block.minecraft.weathered_copper"
        ],
        [
          "item.minecraft.redstone"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.weathered_copper_grate",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.weathered_copper"
        ],
        [
          "block.minecraft.weathered_copper"
        ],
        [
          "block.minecraft.weathered_copper"
        ],
        [
          "block.minecraft.weathered_copper"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.weathered_cut_copper",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.weathered_copper"
        ],
        [
          "block.minecraft.weathered_copper"
        ],
        [
          "block.minecraft.weathered_copper"
        ],
        [
          "block.minecraft.weathered_copper"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.weathered_cut_copper_slab",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.weathered_cut_copper"
        ],
        [
          "block.minecraft.weathered_cut_copper"
        ],
        [
          "block.minecraft.weathered_cut_copper"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.weathered_cut_copper_stairs",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.weathered_cut_copper"
        ],
        [
          "block.minecraft.weathered_cut_copper"
        ],
        [
          "block.minecraft.weathered_cut_copper"
        ],
        [
          "block.minecraft.weathered_cut_copper"
        ],
        [
          "block.minecraft.weathered_cut_copper"
        ],
        [
          "block.minecraft.weathered_cut_copper"
        ]
      ]
    }
  ],
  [
    {
      "output": "block.minecraft.white_wool",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.string"
        ],
        [
          "item.minecraft.string"
        ],
        [
          "item.minecraft.string"
        ],
        [
          "item.minecraft.string"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.acacia_boat",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.acacia_planks"
        ],
        [
          "block.minecraft.acacia_planks"
        ],
        [
          "block.minecraft.acacia_planks"
        ],
        [
          "block.minecraft.acacia_planks"
        ],
        [
          "block.minecraft.acacia_planks"
        ]
      ]
    },
    {
      "output": "item.minecraft.bamboo_raft",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.bamboo_planks"
        ],
        [
          "block.minecraft.bamboo_planks"
        ],
        [
          "block.minecraft.bamboo_planks"
        ],
        [
          "block.minecraft.bamboo_planks"
        ],
        [
          "block.minecraft.bamboo_planks"
        ]
      ]
    },
    {
      "output": "item.minecraft.birch_boat",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.birch_planks"
        ],
        [
          "block.minecraft.birch_planks"
        ],
        [
          "block.minecraft.birch_planks"
        ],
        [
          "block.minecraft.birch_planks"
        ],
        [
          "block.minecraft.birch_planks"
        ]
      ]
    },
    {
      "output": "item.minecraft.cherry_boat",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.cherry_planks"
        ],
        [
          "block.minecraft.cherry_planks"
        ],
        [
          "block.minecraft.cherry_planks"
        ],
        [
          "block.minecraft.cherry_planks"
        ],
        [
          "block.minecraft.cherry_planks"
        ]
      ]
    },
    {
      "output": "item.minecraft.dark_oak_boat",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.dark_oak_planks"
        ],
        [
          "block.minecraft.dark_oak_planks"
        ],
        [
          "block.minecraft.dark_oak_planks"
        ],
        [
          "block.minecraft.dark_oak_planks"
        ],
        [
          "block.minecraft.dark_oak_planks"
        ]
      ]
    },
    {
      "output": "item.minecraft.jungle_boat",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.jungle_planks"
        ],
        [
          "block.minecraft.jungle_planks"
        ],
        [
          "block.minecraft.jungle_planks"
        ],
        [
          "block.minecraft.jungle_planks"
        ],
        [
          "block.minecraft.jungle_planks"
        ]
      ]
    },
    {
      "output": "item.minecraft.mangrove_boat",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.mangrove_planks"
        ],
        [
          "block.minecraft.mangrove_planks"
        ],
        [
          "block.minecraft.mangrove_planks"
        ],
        [
          "block.minecraft.mangrove_planks"
        ],
        [
          "block.minecraft.mangrove_planks"
        ]
      ]
    },
    {
      "output": "item.minecraft.oak_boat",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.oak_planks"
        ],
        [
          "block.minecraft.oak_planks"
        ],
        [
          "block.minecraft.oak_planks"
        ],
        [
          "block.minecraft.oak_planks"
        ],
        [
          "block.minecraft.oak_planks"
        ]
      ]
    },
    {
      "output": "item.minecraft.pale_oak_boat",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.pale_oak_planks"
        ],
        [
          "block.minecraft.pale_oak_planks"
        ],
        [
          "block.minecraft.pale_oak_planks"
        ],
        [
          "block.minecraft.pale_oak_planks"
        ],
        [
          "block.minecraft.pale_oak_planks"
        ]
      ]
    },
    {
      "output": "item.minecraft.spruce_boat",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.spruce_planks"
        ],
        [
          "block.minecraft.spruce_planks"
        ],
        [
          "block.minecraft.spruce_planks"
        ],
        [
          "block.minecraft.spruce_planks"
        ],
        [
          "block.minecraft.spruce_planks"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.acacia_chest_boat",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.chest"
        ],
        [
          "item.minecraft.acacia_boat"
        ]
      ]
    },
    {
      "output": "item.minecraft.bamboo_chest_raft",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.chest"
        ],
        [
          "item.minecraft.bamboo_raft"
        ]
      ]
    },
    {
      "output": "item.minecraft.birch_chest_boat",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.chest"
        ],
        [
          "item.minecraft.birch_boat"
        ]
      ]
    },
    {
      "output": "item.minecraft.cherry_chest_boat",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.chest"
        ],
        [
          "item.minecraft.cherry_boat"
        ]
      ]
    },
    {
      "output": "item.minecraft.dark_oak_chest_boat",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.chest"
        ],
        [
          "item.minecraft.dark_oak_boat"
        ]
      ]
    },
    {
      "output": "item.minecraft.jungle_chest_boat",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.chest"
        ],
        [
          "item.minecraft.jungle_boat"
        ]
      ]
    },
    {
      "output": "item.minecraft.mangrove_chest_boat",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.chest"
        ],
        [
          "item.minecraft.mangrove_boat"
        ]
      ]
    },
    {
      "output": "item.minecraft.oak_chest_boat",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.chest"
        ],
        [
          "item.minecraft.oak_boat"
        ]
      ]
    },
    {
      "output": "item.minecraft.pale_oak_chest_boat",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.chest"
        ],
        [
          "item.minecraft.pale_oak_boat"
        ]
      ]
    },
    {
      "output": "item.minecraft.spruce_chest_boat",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.chest"
        ],
        [
          "item.minecraft.spruce_boat"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.armor_stand",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "block.minecraft.smooth_stone_slab"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.arrow",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.flint"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.feather"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.beetroot_soup",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.bowl"
        ],
        [
          "item.minecraft.beetroot"
        ],
        [
          "item.minecraft.beetroot"
        ],
        [
          "item.minecraft.beetroot"
        ],
        [
          "item.minecraft.beetroot"
        ],
        [
          "item.minecraft.beetroot"
        ],
        [
          "item.minecraft.beetroot"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.black_dye",
      "size": 1,
      "ingredients": [
        [
          "item.minecraft.ink_sac"
        ]
      ]
    },
    {
      "output": "item.minecraft.black_dye",
      "size": 1,
      "ingredients": [
        [
          "block.minecraft.wither_rose"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.black_harness",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.leather"
        ],
        [
          "item.minecraft.leather"
        ],
        [
          "item.minecraft.leather"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.black_wool"
        ],
        [
          "block.minecraft.glass"
        ]
      ]
    },
    {
      "output": "item.minecraft.blue_harness",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.leather"
        ],
        [
          "item.minecraft.leather"
        ],
        [
          "item.minecraft.leather"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.blue_wool"
        ],
        [
          "block.minecraft.glass"
        ]
      ]
    },
    {
      "output": "item.minecraft.brown_harness",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.leather"
        ],
        [
          "item.minecraft.leather"
        ],
        [
          "item.minecraft.leather"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.brown_wool"
        ],
        [
          "block.minecraft.glass"
        ]
      ]
    },
    {
      "output": "item.minecraft.cyan_harness",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.leather"
        ],
        [
          "item.minecraft.leather"
        ],
        [
          "item.minecraft.leather"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.cyan_wool"
        ],
        [
          "block.minecraft.glass"
        ]
      ]
    },
    {
      "output": "item.minecraft.gray_harness",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.leather"
        ],
        [
          "item.minecraft.leather"
        ],
        [
          "item.minecraft.leather"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.gray_wool"
        ],
        [
          "block.minecraft.glass"
        ]
      ]
    },
    {
      "output": "item.minecraft.green_harness",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.leather"
        ],
        [
          "item.minecraft.leather"
        ],
        [
          "item.minecraft.leather"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.green_wool"
        ],
        [
          "block.minecraft.glass"
        ]
      ]
    },
    {
      "output": "item.minecraft.light_blue_harness",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.leather"
        ],
        [
          "item.minecraft.leather"
        ],
        [
          "item.minecraft.leather"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.light_blue_wool"
        ],
        [
          "block.minecraft.glass"
        ]
      ]
    },
    {
      "output": "item.minecraft.light_gray_harness",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.leather"
        ],
        [
          "item.minecraft.leather"
        ],
        [
          "item.minecraft.leather"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.light_gray_wool"
        ],
        [
          "block.minecraft.glass"
        ]
      ]
    },
    {
      "output": "item.minecraft.lime_harness",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.leather"
        ],
        [
          "item.minecraft.leather"
        ],
        [
          "item.minecraft.leather"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.lime_wool"
        ],
        [
          "block.minecraft.glass"
        ]
      ]
    },
    {
      "output": "item.minecraft.magenta_harness",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.leather"
        ],
        [
          "item.minecraft.leather"
        ],
        [
          "item.minecraft.leather"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.magenta_wool"
        ],
        [
          "block.minecraft.glass"
        ]
      ]
    },
    {
      "output": "item.minecraft.orange_harness",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.leather"
        ],
        [
          "item.minecraft.leather"
        ],
        [
          "item.minecraft.leather"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.orange_wool"
        ],
        [
          "block.minecraft.glass"
        ]
      ]
    },
    {
      "output": "item.minecraft.pink_harness",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.leather"
        ],
        [
          "item.minecraft.leather"
        ],
        [
          "item.minecraft.leather"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.pink_wool"
        ],
        [
          "block.minecraft.glass"
        ]
      ]
    },
    {
      "output": "item.minecraft.purple_harness",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.leather"
        ],
        [
          "item.minecraft.leather"
        ],
        [
          "item.minecraft.leather"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.purple_wool"
        ],
        [
          "block.minecraft.glass"
        ]
      ]
    },
    {
      "output": "item.minecraft.red_harness",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.leather"
        ],
        [
          "item.minecraft.leather"
        ],
        [
          "item.minecraft.leather"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.red_wool"
        ],
        [
          "block.minecraft.glass"
        ]
      ]
    },
    {
      "output": "item.minecraft.white_harness",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.leather"
        ],
        [
          "item.minecraft.leather"
        ],
        [
          "item.minecraft.leather"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.white_wool"
        ],
        [
          "block.minecraft.glass"
        ]
      ]
    },
    {
      "output": "item.minecraft.yellow_harness",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.leather"
        ],
        [
          "item.minecraft.leather"
        ],
        [
          "item.minecraft.leather"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.yellow_wool"
        ],
        [
          "block.minecraft.glass"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.black_harness",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.black_dye"
        ],
        [
          "item.minecraft.blue_harness",
          "item.minecraft.brown_harness",
          "item.minecraft.cyan_harness",
          "item.minecraft.gray_harness",
          "item.minecraft.green_harness",
          "item.minecraft.light_blue_harness",
          "item.minecraft.light_gray_harness",
          "item.minecraft.lime_harness",
          "item.minecraft.magenta_harness",
          "item.minecraft.orange_harness",
          "item.minecraft.pink_harness",
          "item.minecraft.purple_harness",
          "item.minecraft.red_harness",
          "item.minecraft.white_harness",
          "item.minecraft.yellow_harness"
        ]
      ]
    },
    {
      "output": "item.minecraft.blue_harness",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.blue_dye"
        ],
        [
          "item.minecraft.black_harness",
          "item.minecraft.brown_harness",
          "item.minecraft.cyan_harness",
          "item.minecraft.gray_harness",
          "item.minecraft.green_harness",
          "item.minecraft.light_blue_harness",
          "item.minecraft.light_gray_harness",
          "item.minecraft.lime_harness",
          "item.minecraft.magenta_harness",
          "item.minecraft.orange_harness",
          "item.minecraft.pink_harness",
          "item.minecraft.purple_harness",
          "item.minecraft.red_harness",
          "item.minecraft.white_harness",
          "item.minecraft.yellow_harness"
        ]
      ]
    },
    {
      "output": "item.minecraft.brown_harness",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.brown_dye"
        ],
        [
          "item.minecraft.black_harness",
          "item.minecraft.blue_harness",
          "item.minecraft.cyan_harness",
          "item.minecraft.gray_harness",
          "item.minecraft.green_harness",
          "item.minecraft.light_blue_harness",
          "item.minecraft.light_gray_harness",
          "item.minecraft.lime_harness",
          "item.minecraft.magenta_harness",
          "item.minecraft.orange_harness",
          "item.minecraft.pink_harness",
          "item.minecraft.purple_harness",
          "item.minecraft.red_harness",
          "item.minecraft.white_harness",
          "item.minecraft.yellow_harness"
        ]
      ]
    },
    {
      "output": "item.minecraft.cyan_harness",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.cyan_dye"
        ],
        [
          "item.minecraft.black_harness",
          "item.minecraft.blue_harness",
          "item.minecraft.brown_harness",
          "item.minecraft.gray_harness",
          "item.minecraft.green_harness",
          "item.minecraft.light_blue_harness",
          "item.minecraft.light_gray_harness",
          "item.minecraft.lime_harness",
          "item.minecraft.magenta_harness",
          "item.minecraft.orange_harness",
          "item.minecraft.pink_harness",
          "item.minecraft.purple_harness",
          "item.minecraft.red_harness",
          "item.minecraft.white_harness",
          "item.minecraft.yellow_harness"
        ]
      ]
    },
    {
      "output": "item.minecraft.gray_harness",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.gray_dye"
        ],
        [
          "item.minecraft.black_harness",
          "item.minecraft.blue_harness",
          "item.minecraft.brown_harness",
          "item.minecraft.cyan_harness",
          "item.minecraft.green_harness",
          "item.minecraft.light_blue_harness",
          "item.minecraft.light_gray_harness",
          "item.minecraft.lime_harness",
          "item.minecraft.magenta_harness",
          "item.minecraft.orange_harness",
          "item.minecraft.pink_harness",
          "item.minecraft.purple_harness",
          "item.minecraft.red_harness",
          "item.minecraft.white_harness",
          "item.minecraft.yellow_harness"
        ]
      ]
    },
    {
      "output": "item.minecraft.green_harness",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.green_dye"
        ],
        [
          "item.minecraft.black_harness",
          "item.minecraft.blue_harness",
          "item.minecraft.brown_harness",
          "item.minecraft.cyan_harness",
          "item.minecraft.gray_harness",
          "item.minecraft.light_blue_harness",
          "item.minecraft.light_gray_harness",
          "item.minecraft.lime_harness",
          "item.minecraft.magenta_harness",
          "item.minecraft.orange_harness",
          "item.minecraft.pink_harness",
          "item.minecraft.purple_harness",
          "item.minecraft.red_harness",
          "item.minecraft.white_harness",
          "item.minecraft.yellow_harness"
        ]
      ]
    },
    {
      "output": "item.minecraft.light_blue_harness",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.light_blue_dye"
        ],
        [
          "item.minecraft.black_harness",
          "item.minecraft.blue_harness",
          "item.minecraft.brown_harness",
          "item.minecraft.cyan_harness",
          "item.minecraft.gray_harness",
          "item.minecraft.green_harness",
          "item.minecraft.light_gray_harness",
          "item.minecraft.lime_harness",
          "item.minecraft.magenta_harness",
          "item.minecraft.orange_harness",
          "item.minecraft.pink_harness",
          "item.minecraft.purple_harness",
          "item.minecraft.red_harness",
          "item.minecraft.white_harness",
          "item.minecraft.yellow_harness"
        ]
      ]
    },
    {
      "output": "item.minecraft.light_gray_harness",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.light_gray_dye"
        ],
        [
          "item.minecraft.black_harness",
          "item.minecraft.blue_harness",
          "item.minecraft.brown_harness",
          "item.minecraft.cyan_harness",
          "item.minecraft.gray_harness",
          "item.minecraft.green_harness",
          "item.minecraft.light_blue_harness",
          "item.minecraft.lime_harness",
          "item.minecraft.magenta_harness",
          "item.minecraft.orange_harness",
          "item.minecraft.pink_harness",
          "item.minecraft.purple_harness",
          "item.minecraft.red_harness",
          "item.minecraft.white_harness",
          "item.minecraft.yellow_harness"
        ]
      ]
    },
    {
      "output": "item.minecraft.lime_harness",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.lime_dye"
        ],
        [
          "item.minecraft.black_harness",
          "item.minecraft.blue_harness",
          "item.minecraft.brown_harness",
          "item.minecraft.cyan_harness",
          "item.minecraft.gray_harness",
          "item.minecraft.green_harness",
          "item.minecraft.light_blue_harness",
          "item.minecraft.light_gray_harness",
          "item.minecraft.magenta_harness",
          "item.minecraft.orange_harness",
          "item.minecraft.pink_harness",
          "item.minecraft.purple_harness",
          "item.minecraft.red_harness",
          "item.minecraft.white_harness",
          "item.minecraft.yellow_harness"
        ]
      ]
    },
    {
      "output": "item.minecraft.magenta_harness",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.magenta_dye"
        ],
        [
          "item.minecraft.black_harness",
          "item.minecraft.blue_harness",
          "item.minecraft.brown_harness",
          "item.minecraft.cyan_harness",
          "item.minecraft.gray_harness",
          "item.minecraft.green_harness",
          "item.minecraft.light_blue_harness",
          "item.minecraft.light_gray_harness",
          "item.minecraft.lime_harness",
          "item.minecraft.orange_harness",
          "item.minecraft.pink_harness",
          "item.minecraft.purple_harness",
          "item.minecraft.red_harness",
          "item.minecraft.white_harness",
          "item.minecraft.yellow_harness"
        ]
      ]
    },
    {
      "output": "item.minecraft.orange_harness",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.orange_dye"
        ],
        [
          "item.minecraft.black_harness",
          "item.minecraft.blue_harness",
          "item.minecraft.brown_harness",
          "item.minecraft.cyan_harness",
          "item.minecraft.gray_harness",
          "item.minecraft.green_harness",
          "item.minecraft.light_blue_harness",
          "item.minecraft.light_gray_harness",
          "item.minecraft.lime_harness",
          "item.minecraft.magenta_harness",
          "item.minecraft.pink_harness",
          "item.minecraft.purple_harness",
          "item.minecraft.red_harness",
          "item.minecraft.white_harness",
          "item.minecraft.yellow_harness"
        ]
      ]
    },
    {
      "output": "item.minecraft.pink_harness",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.pink_dye"
        ],
        [
          "item.minecraft.black_harness",
          "item.minecraft.blue_harness",
          "item.minecraft.brown_harness",
          "item.minecraft.cyan_harness",
          "item.minecraft.gray_harness",
          "item.minecraft.green_harness",
          "item.minecraft.light_blue_harness",
          "item.minecraft.light_gray_harness",
          "item.minecraft.lime_harness",
          "item.minecraft.magenta_harness",
          "item.minecraft.orange_harness",
          "item.minecraft.purple_harness",
          "item.minecraft.red_harness",
          "item.minecraft.white_harness",
          "item.minecraft.yellow_harness"
        ]
      ]
    },
    {
      "output": "item.minecraft.purple_harness",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.purple_dye"
        ],
        [
          "item.minecraft.black_harness",
          "item.minecraft.blue_harness",
          "item.minecraft.brown_harness",
          "item.minecraft.cyan_harness",
          "item.minecraft.gray_harness",
          "item.minecraft.green_harness",
          "item.minecraft.light_blue_harness",
          "item.minecraft.light_gray_harness",
          "item.minecraft.lime_harness",
          "item.minecraft.magenta_harness",
          "item.minecraft.orange_harness",
          "item.minecraft.pink_harness",
          "item.minecraft.red_harness",
          "item.minecraft.white_harness",
          "item.minecraft.yellow_harness"
        ]
      ]
    },
    {
      "output": "item.minecraft.red_harness",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.red_dye"
        ],
        [
          "item.minecraft.black_harness",
          "item.minecraft.blue_harness",
          "item.minecraft.brown_harness",
          "item.minecraft.cyan_harness",
          "item.minecraft.gray_harness",
          "item.minecraft.green_harness",
          "item.minecraft.light_blue_harness",
          "item.minecraft.light_gray_harness",
          "item.minecraft.lime_harness",
          "item.minecraft.magenta_harness",
          "item.minecraft.orange_harness",
          "item.minecraft.pink_harness",
          "item.minecraft.purple_harness",
          "item.minecraft.white_harness",
          "item.minecraft.yellow_harness"
        ]
      ]
    },
    {
      "output": "item.minecraft.white_harness",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.white_dye"
        ],
        [
          "item.minecraft.black_harness",
          "item.minecraft.blue_harness",
          "item.minecraft.brown_harness",
          "item.minecraft.cyan_harness",
          "item.minecraft.gray_harness",
          "item.minecraft.green_harness",
          "item.minecraft.light_blue_harness",
          "item.minecraft.light_gray_harness",
          "item.minecraft.lime_harness",
          "item.minecraft.magenta_harness",
          "item.minecraft.orange_harness",
          "item.minecraft.pink_harness",
          "item.minecraft.purple_harness",
          "item.minecraft.red_harness",
          "item.minecraft.yellow_harness"
        ]
      ]
    },
    {
      "output": "item.minecraft.yellow_harness",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.yellow_dye"
        ],
        [
          "item.minecraft.black_harness",
          "item.minecraft.blue_harness",
          "item.minecraft.brown_harness",
          "item.minecraft.cyan_harness",
          "item.minecraft.gray_harness",
          "item.minecraft.green_harness",
          "item.minecraft.light_blue_harness",
          "item.minecraft.light_gray_harness",
          "item.minecraft.lime_harness",
          "item.minecraft.magenta_harness",
          "item.minecraft.orange_harness",
          "item.minecraft.pink_harness",
          "item.minecraft.purple_harness",
          "item.minecraft.red_harness",
          "item.minecraft.white_harness"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.blaze_powder",
      "size": 1,
      "ingredients": [
        [
          "item.minecraft.blaze_rod"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.blue_dye",
      "size": 1,
      "ingredients": [
        [
          "item.minecraft.lapis_lazuli"
        ]
      ]
    },
    {
      "output": "item.minecraft.blue_dye",
      "size": 1,
      "ingredients": [
        [
          "block.minecraft.cornflower"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.bolt_armor_trim_smithing_template",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.bolt_armor_trim_smithing_template"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "block.minecraft.copper_block",
          "block.minecraft.waxed_copper_block"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.bone_meal",
      "size": 1,
      "ingredients": [
        [
          "item.minecraft.bone"
        ]
      ]
    },
    {
      "output": "item.minecraft.bone_meal",
      "size": 1,
      "ingredients": [
        [
          "block.minecraft.bone_block"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.book",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.paper"
        ],
        [
          "item.minecraft.paper"
        ],
        [
          "item.minecraft.paper"
        ],
        [
          "item.minecraft.leather"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.bordure_indented_banner_pattern",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.paper"
        ],
        [
          "block.minecraft.vine"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.bow",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.string"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.string"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.string"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.bowl",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.bread",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.wheat"
        ],
        [
          "item.minecraft.wheat"
        ],
        [
          "item.minecraft.wheat"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.brown_dye",
      "size": 1,
      "ingredients": [
        [
          "item.minecraft.cocoa_beans"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.brush",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.feather"
        ],
        [
          "item.minecraft.copper_ingot"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.bucket",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.bundle",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.string"
        ],
        [
          "item.minecraft.leather"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.carrot_on_a_stick",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.fishing_rod"
        ],
        [
          "item.minecraft.carrot"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.chest_minecart",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.chest"
        ],
        [
          "item.minecraft.minecart"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.clock",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.gold_ingot"
        ],
        [
          "item.minecraft.gold_ingot"
        ],
        [
          "item.minecraft.redstone"
        ],
        [
          "item.minecraft.gold_ingot"
        ],
        [
          "item.minecraft.gold_ingot"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.coal",
      "size": 1,
      "ingredients": [
        [
          "block.minecraft.coal_block"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.coast_armor_trim_smithing_template",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.coast_armor_trim_smithing_template"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "block.minecraft.cobblestone"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.compass",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.redstone"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.cookie",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.wheat"
        ],
        [
          "item.minecraft.cocoa_beans"
        ],
        [
          "item.minecraft.wheat"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.copper_axe",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.copper_ingot"
        ],
        [
          "item.minecraft.copper_ingot"
        ],
        [
          "item.minecraft.copper_ingot"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.copper_boots",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.copper_ingot"
        ],
        [
          "item.minecraft.copper_ingot"
        ],
        [
          "item.minecraft.copper_ingot"
        ],
        [
          "item.minecraft.copper_ingot"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.copper_chestplate",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.copper_ingot"
        ],
        [
          "item.minecraft.copper_ingot"
        ],
        [
          "item.minecraft.copper_ingot"
        ],
        [
          "item.minecraft.copper_ingot"
        ],
        [
          "item.minecraft.copper_ingot"
        ],
        [
          "item.minecraft.copper_ingot"
        ],
        [
          "item.minecraft.copper_ingot"
        ],
        [
          "item.minecraft.copper_ingot"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.copper_helmet",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.copper_ingot"
        ],
        [
          "item.minecraft.copper_ingot"
        ],
        [
          "item.minecraft.copper_ingot"
        ],
        [
          "item.minecraft.copper_ingot"
        ],
        [
          "item.minecraft.copper_ingot"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.copper_hoe",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.copper_ingot"
        ],
        [
          "item.minecraft.copper_ingot"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.copper_ingot",
      "size": 1,
      "ingredients": [
        [
          "block.minecraft.copper_block"
        ]
      ]
    },
    {
      "output": "item.minecraft.copper_ingot",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.copper_nugget"
        ],
        [
          "item.minecraft.copper_nugget"
        ],
        [
          "item.minecraft.copper_nugget"
        ],
        [
          "item.minecraft.copper_nugget"
        ],
        [
          "item.minecraft.copper_nugget"
        ],
        [
          "item.minecraft.copper_nugget"
        ],
        [
          "item.minecraft.copper_nugget"
        ],
        [
          "item.minecraft.copper_nugget"
        ],
        [
          "item.minecraft.copper_nugget"
        ]
      ]
    },
    {
      "output": "item.minecraft.copper_ingot",
      "size": 1,
      "ingredients": [
        [
          "block.minecraft.waxed_copper_block"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.copper_leggings",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.copper_ingot"
        ],
        [
          "item.minecraft.copper_ingot"
        ],
        [
          "item.minecraft.copper_ingot"
        ],
        [
          "item.minecraft.copper_ingot"
        ],
        [
          "item.minecraft.copper_ingot"
        ],
        [
          "item.minecraft.copper_ingot"
        ],
        [
          "item.minecraft.copper_ingot"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.copper_nugget",
      "size": 1,
      "ingredients": [
        [
          "item.minecraft.copper_ingot"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.copper_pickaxe",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.copper_ingot"
        ],
        [
          "item.minecraft.copper_ingot"
        ],
        [
          "item.minecraft.copper_ingot"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.copper_shovel",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.copper_ingot"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.copper_spear",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.copper_ingot"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.copper_sword",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.copper_ingot"
        ],
        [
          "item.minecraft.copper_ingot"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.creeper_banner_pattern",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.paper"
        ],
        [
          "block.minecraft.creeper_head"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.crossbow",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.string"
        ],
        [
          "block.minecraft.tripwire_hook"
        ],
        [
          "item.minecraft.string"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.cyan_dye",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.blue_dye"
        ],
        [
          "item.minecraft.green_dye"
        ]
      ]
    },
    {
      "output": "item.minecraft.cyan_dye",
      "size": 1,
      "ingredients": [
        [
          "item.minecraft.pitcher_plant"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.diamond",
      "size": 1,
      "ingredients": [
        [
          "block.minecraft.diamond_block"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.diamond_axe",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.diamond_boots",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.diamond_chestplate",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.diamond_helmet",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.diamond_hoe",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.diamond_leggings",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.diamond_pickaxe",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.diamond_shovel",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.diamond_spear",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.diamond_sword",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.dried_kelp",
      "size": 1,
      "ingredients": [
        [
          "block.minecraft.dried_kelp_block"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.dune_armor_trim_smithing_template",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.dune_armor_trim_smithing_template"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "block.minecraft.sandstone"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.emerald",
      "size": 1,
      "ingredients": [
        [
          "block.minecraft.emerald_block"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.end_crystal",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "item.minecraft.ender_eye"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "item.minecraft.ghast_tear"
        ],
        [
          "block.minecraft.glass"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.ender_eye",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.ender_pearl"
        ],
        [
          "item.minecraft.blaze_powder"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.eye_armor_trim_smithing_template",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.eye_armor_trim_smithing_template"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "block.minecraft.end_stone"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.fermented_spider_eye",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.spider_eye"
        ],
        [
          "block.minecraft.brown_mushroom"
        ],
        [
          "item.minecraft.sugar"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.field_masoned_banner_pattern",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.paper"
        ],
        [
          "block.minecraft.bricks"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.fire_charge",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.gunpowder"
        ],
        [
          "item.minecraft.blaze_powder"
        ],
        [
          "item.minecraft.charcoal",
          "item.minecraft.coal"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.firework_rocket",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.gunpowder"
        ],
        [
          "item.minecraft.paper"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.fishing_rod",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.string"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.string"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.flint_and_steel",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.flint"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.flow_armor_trim_smithing_template",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.flow_armor_trim_smithing_template"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.breeze_rod"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.flower_banner_pattern",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.paper"
        ],
        [
          "block.minecraft.oxeye_daisy"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.furnace_minecart",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.furnace"
        ],
        [
          "item.minecraft.minecart"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.glass_bottle",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ],
        [
          "block.minecraft.glass"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.glistering_melon_slice",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.gold_nugget"
        ],
        [
          "item.minecraft.gold_nugget"
        ],
        [
          "item.minecraft.gold_nugget"
        ],
        [
          "item.minecraft.gold_nugget"
        ],
        [
          "item.minecraft.melon_slice"
        ],
        [
          "item.minecraft.gold_nugget"
        ],
        [
          "item.minecraft.gold_nugget"
        ],
        [
          "item.minecraft.gold_nugget"
        ],
        [
          "item.minecraft.gold_nugget"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.glow_item_frame",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.item_frame"
        ],
        [
          "item.minecraft.glow_ink_sac"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.gold_ingot",
      "size": 1,
      "ingredients": [
        [
          "block.minecraft.gold_block"
        ]
      ]
    },
    {
      "output": "item.minecraft.gold_ingot",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.gold_nugget"
        ],
        [
          "item.minecraft.gold_nugget"
        ],
        [
          "item.minecraft.gold_nugget"
        ],
        [
          "item.minecraft.gold_nugget"
        ],
        [
          "item.minecraft.gold_nugget"
        ],
        [
          "item.minecraft.gold_nugget"
        ],
        [
          "item.minecraft.gold_nugget"
        ],
        [
          "item.minecraft.gold_nugget"
        ],
        [
          "item.minecraft.gold_nugget"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.gold_nugget",
      "size": 1,
      "ingredients": [
        [
          "item.minecraft.gold_ingot"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.golden_apple",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.gold_ingot"
        ],
        [
          "item.minecraft.gold_ingot"
        ],
        [
          "item.minecraft.gold_ingot"
        ],
        [
          "item.minecraft.gold_ingot"
        ],
        [
          "item.minecraft.apple"
        ],
        [
          "item.minecraft.gold_ingot"
        ],
        [
          "item.minecraft.gold_ingot"
        ],
        [
          "item.minecraft.gold_ingot"
        ],
        [
          "item.minecraft.gold_ingot"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.golden_axe",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.gold_ingot"
        ],
        [
          "item.minecraft.gold_ingot"
        ],
        [
          "item.minecraft.gold_ingot"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.golden_boots",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.gold_ingot"
        ],
        [
          "item.minecraft.gold_ingot"
        ],
        [
          "item.minecraft.gold_ingot"
        ],
        [
          "item.minecraft.gold_ingot"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.golden_carrot",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.gold_nugget"
        ],
        [
          "item.minecraft.gold_nugget"
        ],
        [
          "item.minecraft.gold_nugget"
        ],
        [
          "item.minecraft.gold_nugget"
        ],
        [
          "item.minecraft.carrot"
        ],
        [
          "item.minecraft.gold_nugget"
        ],
        [
          "item.minecraft.gold_nugget"
        ],
        [
          "item.minecraft.gold_nugget"
        ],
        [
          "item.minecraft.gold_nugget"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.golden_chestplate",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.gold_ingot"
        ],
        [
          "item.minecraft.gold_ingot"
        ],
        [
          "item.minecraft.gold_ingot"
        ],
        [
          "item.minecraft.gold_ingot"
        ],
        [
          "item.minecraft.gold_ingot"
        ],
        [
          "item.minecraft.gold_ingot"
        ],
        [
          "item.minecraft.gold_ingot"
        ],
        [
          "item.minecraft.gold_ingot"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.golden_helmet",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.gold_ingot"
        ],
        [
          "item.minecraft.gold_ingot"
        ],
        [
          "item.minecraft.gold_ingot"
        ],
        [
          "item.minecraft.gold_ingot"
        ],
        [
          "item.minecraft.gold_ingot"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.golden_hoe",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.gold_ingot"
        ],
        [
          "item.minecraft.gold_ingot"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.golden_leggings",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.gold_ingot"
        ],
        [
          "item.minecraft.gold_ingot"
        ],
        [
          "item.minecraft.gold_ingot"
        ],
        [
          "item.minecraft.gold_ingot"
        ],
        [
          "item.minecraft.gold_ingot"
        ],
        [
          "item.minecraft.gold_ingot"
        ],
        [
          "item.minecraft.gold_ingot"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.golden_pickaxe",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.gold_ingot"
        ],
        [
          "item.minecraft.gold_ingot"
        ],
        [
          "item.minecraft.gold_ingot"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.golden_shovel",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.gold_ingot"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.golden_spear",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.gold_ingot"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.golden_sword",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.gold_ingot"
        ],
        [
          "item.minecraft.gold_ingot"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.gray_dye",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.black_dye"
        ],
        [
          "item.minecraft.white_dye"
        ]
      ]
    },
    {
      "output": "item.minecraft.gray_dye",
      "size": 1,
      "ingredients": [
        [
          "block.minecraft.closed_eyeblossom"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.honey_bottle",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.honey_block"
        ],
        [
          "item.minecraft.glass_bottle"
        ],
        [
          "item.minecraft.glass_bottle"
        ],
        [
          "item.minecraft.glass_bottle"
        ],
        [
          "item.minecraft.glass_bottle"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.hopper_minecart",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.hopper"
        ],
        [
          "item.minecraft.minecart"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.host_armor_trim_smithing_template",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.host_armor_trim_smithing_template"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.iron_axe",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.iron_boots",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.iron_chestplate",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.iron_helmet",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.iron_hoe",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.iron_ingot",
      "size": 1,
      "ingredients": [
        [
          "block.minecraft.iron_block"
        ]
      ]
    },
    {
      "output": "item.minecraft.iron_ingot",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.iron_nugget"
        ],
        [
          "item.minecraft.iron_nugget"
        ],
        [
          "item.minecraft.iron_nugget"
        ],
        [
          "item.minecraft.iron_nugget"
        ],
        [
          "item.minecraft.iron_nugget"
        ],
        [
          "item.minecraft.iron_nugget"
        ],
        [
          "item.minecraft.iron_nugget"
        ],
        [
          "item.minecraft.iron_nugget"
        ],
        [
          "item.minecraft.iron_nugget"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.iron_leggings",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.iron_nugget",
      "size": 1,
      "ingredients": [
        [
          "item.minecraft.iron_ingot"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.iron_pickaxe",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.iron_shovel",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.iron_spear",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.iron_sword",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.item_frame",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.leather"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.lapis_lazuli",
      "size": 1,
      "ingredients": [
        [
          "block.minecraft.lapis_block"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.lead",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.string"
        ],
        [
          "item.minecraft.string"
        ],
        [
          "item.minecraft.string"
        ],
        [
          "item.minecraft.string"
        ],
        [
          "item.minecraft.string"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.leather",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.rabbit_hide"
        ],
        [
          "item.minecraft.rabbit_hide"
        ],
        [
          "item.minecraft.rabbit_hide"
        ],
        [
          "item.minecraft.rabbit_hide"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.leather_boots",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.leather"
        ],
        [
          "item.minecraft.leather"
        ],
        [
          "item.minecraft.leather"
        ],
        [
          "item.minecraft.leather"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.leather_chestplate",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.leather"
        ],
        [
          "item.minecraft.leather"
        ],
        [
          "item.minecraft.leather"
        ],
        [
          "item.minecraft.leather"
        ],
        [
          "item.minecraft.leather"
        ],
        [
          "item.minecraft.leather"
        ],
        [
          "item.minecraft.leather"
        ],
        [
          "item.minecraft.leather"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.leather_helmet",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.leather"
        ],
        [
          "item.minecraft.leather"
        ],
        [
          "item.minecraft.leather"
        ],
        [
          "item.minecraft.leather"
        ],
        [
          "item.minecraft.leather"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.leather_horse_armor",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.leather"
        ],
        [
          "item.minecraft.leather"
        ],
        [
          "item.minecraft.leather"
        ],
        [
          "item.minecraft.leather"
        ],
        [
          "item.minecraft.leather"
        ],
        [
          "item.minecraft.leather"
        ],
        [
          "item.minecraft.leather"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.leather_leggings",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.leather"
        ],
        [
          "item.minecraft.leather"
        ],
        [
          "item.minecraft.leather"
        ],
        [
          "item.minecraft.leather"
        ],
        [
          "item.minecraft.leather"
        ],
        [
          "item.minecraft.leather"
        ],
        [
          "item.minecraft.leather"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.light_blue_dye",
      "size": 1,
      "ingredients": [
        [
          "block.minecraft.blue_orchid"
        ]
      ]
    },
    {
      "output": "item.minecraft.light_blue_dye",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.blue_dye"
        ],
        [
          "item.minecraft.white_dye"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.light_gray_dye",
      "size": 1,
      "ingredients": [
        [
          "block.minecraft.azure_bluet"
        ]
      ]
    },
    {
      "output": "item.minecraft.light_gray_dye",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.black_dye"
        ],
        [
          "item.minecraft.white_dye"
        ],
        [
          "item.minecraft.white_dye"
        ]
      ]
    },
    {
      "output": "item.minecraft.light_gray_dye",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.gray_dye"
        ],
        [
          "item.minecraft.white_dye"
        ]
      ]
    },
    {
      "output": "item.minecraft.light_gray_dye",
      "size": 1,
      "ingredients": [
        [
          "block.minecraft.oxeye_daisy"
        ]
      ]
    },
    {
      "output": "item.minecraft.light_gray_dye",
      "size": 1,
      "ingredients": [
        [
          "block.minecraft.white_tulip"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.lime_dye",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.green_dye"
        ],
        [
          "item.minecraft.white_dye"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.mace",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.heavy_core"
        ],
        [
          "item.minecraft.breeze_rod"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.magenta_dye",
      "size": 1,
      "ingredients": [
        [
          "block.minecraft.allium"
        ]
      ]
    },
    {
      "output": "item.minecraft.magenta_dye",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.blue_dye"
        ],
        [
          "item.minecraft.red_dye"
        ],
        [
          "item.minecraft.pink_dye"
        ]
      ]
    },
    {
      "output": "item.minecraft.magenta_dye",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.blue_dye"
        ],
        [
          "item.minecraft.red_dye"
        ],
        [
          "item.minecraft.red_dye"
        ],
        [
          "item.minecraft.white_dye"
        ]
      ]
    },
    {
      "output": "item.minecraft.magenta_dye",
      "size": 1,
      "ingredients": [
        [
          "block.minecraft.lilac"
        ]
      ]
    },
    {
      "output": "item.minecraft.magenta_dye",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.purple_dye"
        ],
        [
          "item.minecraft.pink_dye"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.magma_cream",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.blaze_powder"
        ],
        [
          "item.minecraft.slime_ball"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.map",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.paper"
        ],
        [
          "item.minecraft.paper"
        ],
        [
          "item.minecraft.paper"
        ],
        [
          "item.minecraft.paper"
        ],
        [
          "item.minecraft.compass"
        ],
        [
          "item.minecraft.paper"
        ],
        [
          "item.minecraft.paper"
        ],
        [
          "item.minecraft.paper"
        ],
        [
          "item.minecraft.paper"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.melon_seeds",
      "size": 1,
      "ingredients": [
        [
          "item.minecraft.melon_slice"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.minecart",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.mojang_banner_pattern",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.paper"
        ],
        [
          "item.minecraft.enchanted_golden_apple"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.mushroom_stew",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.brown_mushroom"
        ],
        [
          "block.minecraft.red_mushroom"
        ],
        [
          "item.minecraft.bowl"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.music_disc_5",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.disc_fragment_5"
        ],
        [
          "item.minecraft.disc_fragment_5"
        ],
        [
          "item.minecraft.disc_fragment_5"
        ],
        [
          "item.minecraft.disc_fragment_5"
        ],
        [
          "item.minecraft.disc_fragment_5"
        ],
        [
          "item.minecraft.disc_fragment_5"
        ],
        [
          "item.minecraft.disc_fragment_5"
        ],
        [
          "item.minecraft.disc_fragment_5"
        ],
        [
          "item.minecraft.disc_fragment_5"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.name_tag",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.copper_nugget",
          "item.minecraft.gold_nugget",
          "item.minecraft.iron_nugget"
        ],
        [
          "item.minecraft.paper"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.netherite_ingot",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.netherite_scrap"
        ],
        [
          "item.minecraft.netherite_scrap"
        ],
        [
          "item.minecraft.netherite_scrap"
        ],
        [
          "item.minecraft.netherite_scrap"
        ],
        [
          "item.minecraft.gold_ingot"
        ],
        [
          "item.minecraft.gold_ingot"
        ],
        [
          "item.minecraft.gold_ingot"
        ],
        [
          "item.minecraft.gold_ingot"
        ]
      ]
    },
    {
      "output": "item.minecraft.netherite_ingot",
      "size": 1,
      "ingredients": [
        [
          "block.minecraft.netherite_block"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.netherite_upgrade_smithing_template",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.netherite_upgrade_smithing_template"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "block.minecraft.netherrack"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.orange_dye",
      "size": 1,
      "ingredients": [
        [
          "block.minecraft.open_eyeblossom"
        ]
      ]
    },
    {
      "output": "item.minecraft.orange_dye",
      "size": 1,
      "ingredients": [
        [
          "block.minecraft.orange_tulip"
        ]
      ]
    },
    {
      "output": "item.minecraft.orange_dye",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.red_dye"
        ],
        [
          "item.minecraft.yellow_dye"
        ]
      ]
    },
    {
      "output": "item.minecraft.orange_dye",
      "size": 1,
      "ingredients": [
        [
          "block.minecraft.torchflower"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.painting",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "block.minecraft.black_wool",
          "block.minecraft.blue_wool",
          "block.minecraft.brown_wool",
          "block.minecraft.cyan_wool",
          "block.minecraft.gray_wool",
          "block.minecraft.green_wool",
          "block.minecraft.light_blue_wool",
          "block.minecraft.light_gray_wool",
          "block.minecraft.lime_wool",
          "block.minecraft.magenta_wool",
          "block.minecraft.orange_wool",
          "block.minecraft.pink_wool",
          "block.minecraft.purple_wool",
          "block.minecraft.red_wool",
          "block.minecraft.white_wool",
          "block.minecraft.yellow_wool"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.paper",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.sugar_cane"
        ],
        [
          "block.minecraft.sugar_cane"
        ],
        [
          "block.minecraft.sugar_cane"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.pink_dye",
      "size": 1,
      "ingredients": [
        [
          "block.minecraft.cactus_flower"
        ]
      ]
    },
    {
      "output": "item.minecraft.pink_dye",
      "size": 1,
      "ingredients": [
        [
          "block.minecraft.peony"
        ]
      ]
    },
    {
      "output": "item.minecraft.pink_dye",
      "size": 1,
      "ingredients": [
        [
          "block.minecraft.pink_petals"
        ]
      ]
    },
    {
      "output": "item.minecraft.pink_dye",
      "size": 1,
      "ingredients": [
        [
          "block.minecraft.pink_tulip"
        ]
      ]
    },
    {
      "output": "item.minecraft.pink_dye",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.red_dye"
        ],
        [
          "item.minecraft.white_dye"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.pumpkin_pie",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.pumpkin"
        ],
        [
          "item.minecraft.sugar"
        ],
        [
          "item.minecraft.blue_egg",
          "item.minecraft.brown_egg",
          "item.minecraft.egg"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.pumpkin_seeds",
      "size": 1,
      "ingredients": [
        [
          "block.minecraft.pumpkin"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.purple_dye",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.blue_dye"
        ],
        [
          "item.minecraft.red_dye"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.rabbit_stew",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.baked_potato"
        ],
        [
          "item.minecraft.cooked_rabbit"
        ],
        [
          "item.minecraft.bowl"
        ],
        [
          "item.minecraft.carrot"
        ],
        [
          "block.minecraft.brown_mushroom"
        ]
      ]
    },
    {
      "output": "item.minecraft.rabbit_stew",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.baked_potato"
        ],
        [
          "item.minecraft.cooked_rabbit"
        ],
        [
          "item.minecraft.bowl"
        ],
        [
          "item.minecraft.carrot"
        ],
        [
          "block.minecraft.red_mushroom"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.raiser_armor_trim_smithing_template",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.raiser_armor_trim_smithing_template"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.raw_copper",
      "size": 1,
      "ingredients": [
        [
          "block.minecraft.raw_copper_block"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.raw_gold",
      "size": 1,
      "ingredients": [
        [
          "block.minecraft.raw_gold_block"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.raw_iron",
      "size": 1,
      "ingredients": [
        [
          "block.minecraft.raw_iron_block"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.recovery_compass",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.echo_shard"
        ],
        [
          "item.minecraft.echo_shard"
        ],
        [
          "item.minecraft.echo_shard"
        ],
        [
          "item.minecraft.echo_shard"
        ],
        [
          "item.minecraft.compass"
        ],
        [
          "item.minecraft.echo_shard"
        ],
        [
          "item.minecraft.echo_shard"
        ],
        [
          "item.minecraft.echo_shard"
        ],
        [
          "item.minecraft.echo_shard"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.red_dye",
      "size": 1,
      "ingredients": [
        [
          "item.minecraft.beetroot"
        ]
      ]
    },
    {
      "output": "item.minecraft.red_dye",
      "size": 1,
      "ingredients": [
        [
          "block.minecraft.poppy"
        ]
      ]
    },
    {
      "output": "item.minecraft.red_dye",
      "size": 1,
      "ingredients": [
        [
          "block.minecraft.rose_bush"
        ]
      ]
    },
    {
      "output": "item.minecraft.red_dye",
      "size": 1,
      "ingredients": [
        [
          "block.minecraft.red_tulip"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.redstone",
      "size": 1,
      "ingredients": [
        [
          "block.minecraft.redstone_block"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.rib_armor_trim_smithing_template",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.rib_armor_trim_smithing_template"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "block.minecraft.netherrack"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.saddle",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.leather"
        ],
        [
          "item.minecraft.leather"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.leather"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.sentry_armor_trim_smithing_template",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.sentry_armor_trim_smithing_template"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "block.minecraft.cobblestone"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.shaper_armor_trim_smithing_template",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.shaper_armor_trim_smithing_template"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.shears",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "item.minecraft.iron_ingot"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.shield",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "item.minecraft.iron_ingot"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.silence_armor_trim_smithing_template",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.silence_armor_trim_smithing_template"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "block.minecraft.cobbled_deepslate"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.skull_banner_pattern",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.paper"
        ],
        [
          "block.minecraft.wither_skeleton_skull"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.slime_ball",
      "size": 1,
      "ingredients": [
        [
          "block.minecraft.slime_block"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.snout_armor_trim_smithing_template",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.snout_armor_trim_smithing_template"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "block.minecraft.blackstone"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.spectral_arrow",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.glowstone_dust"
        ],
        [
          "item.minecraft.glowstone_dust"
        ],
        [
          "item.minecraft.arrow"
        ],
        [
          "item.minecraft.glowstone_dust"
        ],
        [
          "item.minecraft.glowstone_dust"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.spire_armor_trim_smithing_template",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.spire_armor_trim_smithing_template"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "block.minecraft.purpur_block"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.spyglass",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.amethyst_shard"
        ],
        [
          "item.minecraft.copper_ingot"
        ],
        [
          "item.minecraft.copper_ingot"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.stick",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ]
      ]
    },
    {
      "output": "item.minecraft.stick",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.bamboo"
        ],
        [
          "block.minecraft.bamboo"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.stone_axe",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.blackstone",
          "block.minecraft.cobbled_deepslate",
          "block.minecraft.cobblestone"
        ],
        [
          "block.minecraft.blackstone",
          "block.minecraft.cobbled_deepslate",
          "block.minecraft.cobblestone"
        ],
        [
          "block.minecraft.blackstone",
          "block.minecraft.cobbled_deepslate",
          "block.minecraft.cobblestone"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.stone_hoe",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.blackstone",
          "block.minecraft.cobbled_deepslate",
          "block.minecraft.cobblestone"
        ],
        [
          "block.minecraft.blackstone",
          "block.minecraft.cobbled_deepslate",
          "block.minecraft.cobblestone"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.stone_pickaxe",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.blackstone",
          "block.minecraft.cobbled_deepslate",
          "block.minecraft.cobblestone"
        ],
        [
          "block.minecraft.blackstone",
          "block.minecraft.cobbled_deepslate",
          "block.minecraft.cobblestone"
        ],
        [
          "block.minecraft.blackstone",
          "block.minecraft.cobbled_deepslate",
          "block.minecraft.cobblestone"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.stone_shovel",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.blackstone",
          "block.minecraft.cobbled_deepslate",
          "block.minecraft.cobblestone"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.stone_spear",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.blackstone",
          "block.minecraft.cobbled_deepslate",
          "block.minecraft.cobblestone"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.stone_sword",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.blackstone",
          "block.minecraft.cobbled_deepslate",
          "block.minecraft.cobblestone"
        ],
        [
          "block.minecraft.blackstone",
          "block.minecraft.cobbled_deepslate",
          "block.minecraft.cobblestone"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.sugar",
      "size": 1,
      "ingredients": [
        [
          "item.minecraft.honey_bottle"
        ]
      ]
    },
    {
      "output": "item.minecraft.sugar",
      "size": 1,
      "ingredients": [
        [
          "block.minecraft.sugar_cane"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.suspicious_stew",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.bowl"
        ],
        [
          "block.minecraft.brown_mushroom"
        ],
        [
          "block.minecraft.red_mushroom"
        ],
        [
          "block.minecraft.allium"
        ]
      ]
    },
    {
      "output": "item.minecraft.suspicious_stew",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.bowl"
        ],
        [
          "block.minecraft.brown_mushroom"
        ],
        [
          "block.minecraft.red_mushroom"
        ],
        [
          "block.minecraft.azure_bluet"
        ]
      ]
    },
    {
      "output": "item.minecraft.suspicious_stew",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.bowl"
        ],
        [
          "block.minecraft.brown_mushroom"
        ],
        [
          "block.minecraft.red_mushroom"
        ],
        [
          "block.minecraft.blue_orchid"
        ]
      ]
    },
    {
      "output": "item.minecraft.suspicious_stew",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.bowl"
        ],
        [
          "block.minecraft.brown_mushroom"
        ],
        [
          "block.minecraft.red_mushroom"
        ],
        [
          "block.minecraft.closed_eyeblossom"
        ]
      ]
    },
    {
      "output": "item.minecraft.suspicious_stew",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.bowl"
        ],
        [
          "block.minecraft.brown_mushroom"
        ],
        [
          "block.minecraft.red_mushroom"
        ],
        [
          "block.minecraft.cornflower"
        ]
      ]
    },
    {
      "output": "item.minecraft.suspicious_stew",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.bowl"
        ],
        [
          "block.minecraft.brown_mushroom"
        ],
        [
          "block.minecraft.red_mushroom"
        ],
        [
          "block.minecraft.dandelion"
        ]
      ]
    },
    {
      "output": "item.minecraft.suspicious_stew",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.bowl"
        ],
        [
          "block.minecraft.brown_mushroom"
        ],
        [
          "block.minecraft.red_mushroom"
        ],
        [
          "block.minecraft.golden_dandelion"
        ]
      ]
    },
    {
      "output": "item.minecraft.suspicious_stew",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.bowl"
        ],
        [
          "block.minecraft.brown_mushroom"
        ],
        [
          "block.minecraft.red_mushroom"
        ],
        [
          "block.minecraft.lily_of_the_valley"
        ]
      ]
    },
    {
      "output": "item.minecraft.suspicious_stew",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.bowl"
        ],
        [
          "block.minecraft.brown_mushroom"
        ],
        [
          "block.minecraft.red_mushroom"
        ],
        [
          "block.minecraft.open_eyeblossom"
        ]
      ]
    },
    {
      "output": "item.minecraft.suspicious_stew",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.bowl"
        ],
        [
          "block.minecraft.brown_mushroom"
        ],
        [
          "block.minecraft.red_mushroom"
        ],
        [
          "block.minecraft.orange_tulip"
        ]
      ]
    },
    {
      "output": "item.minecraft.suspicious_stew",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.bowl"
        ],
        [
          "block.minecraft.brown_mushroom"
        ],
        [
          "block.minecraft.red_mushroom"
        ],
        [
          "block.minecraft.oxeye_daisy"
        ]
      ]
    },
    {
      "output": "item.minecraft.suspicious_stew",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.bowl"
        ],
        [
          "block.minecraft.brown_mushroom"
        ],
        [
          "block.minecraft.red_mushroom"
        ],
        [
          "block.minecraft.pink_tulip"
        ]
      ]
    },
    {
      "output": "item.minecraft.suspicious_stew",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.bowl"
        ],
        [
          "block.minecraft.brown_mushroom"
        ],
        [
          "block.minecraft.red_mushroom"
        ],
        [
          "block.minecraft.poppy"
        ]
      ]
    },
    {
      "output": "item.minecraft.suspicious_stew",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.bowl"
        ],
        [
          "block.minecraft.brown_mushroom"
        ],
        [
          "block.minecraft.red_mushroom"
        ],
        [
          "block.minecraft.red_tulip"
        ]
      ]
    },
    {
      "output": "item.minecraft.suspicious_stew",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.bowl"
        ],
        [
          "block.minecraft.brown_mushroom"
        ],
        [
          "block.minecraft.red_mushroom"
        ],
        [
          "block.minecraft.torchflower"
        ]
      ]
    },
    {
      "output": "item.minecraft.suspicious_stew",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.bowl"
        ],
        [
          "block.minecraft.brown_mushroom"
        ],
        [
          "block.minecraft.red_mushroom"
        ],
        [
          "block.minecraft.white_tulip"
        ]
      ]
    },
    {
      "output": "item.minecraft.suspicious_stew",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.bowl"
        ],
        [
          "block.minecraft.brown_mushroom"
        ],
        [
          "block.minecraft.red_mushroom"
        ],
        [
          "block.minecraft.wither_rose"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.tide_armor_trim_smithing_template",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.tide_armor_trim_smithing_template"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "block.minecraft.prismarine"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.tnt_minecart",
      "size": 2,
      "ingredients": [
        [
          "block.minecraft.tnt"
        ],
        [
          "item.minecraft.minecart"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.turtle_helmet",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.turtle_scute"
        ],
        [
          "item.minecraft.turtle_scute"
        ],
        [
          "item.minecraft.turtle_scute"
        ],
        [
          "item.minecraft.turtle_scute"
        ],
        [
          "item.minecraft.turtle_scute"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.vex_armor_trim_smithing_template",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.vex_armor_trim_smithing_template"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "block.minecraft.cobblestone"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.ward_armor_trim_smithing_template",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.ward_armor_trim_smithing_template"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "block.minecraft.cobbled_deepslate"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.warped_fungus_on_a_stick",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.fishing_rod"
        ],
        [
          "block.minecraft.warped_fungus"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.wayfinder_armor_trim_smithing_template",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.wayfinder_armor_trim_smithing_template"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "block.minecraft.terracotta"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.wheat",
      "size": 1,
      "ingredients": [
        [
          "block.minecraft.hay_block"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.white_dye",
      "size": 1,
      "ingredients": [
        [
          "item.minecraft.bone_meal"
        ]
      ]
    },
    {
      "output": "item.minecraft.white_dye",
      "size": 1,
      "ingredients": [
        [
          "block.minecraft.lily_of_the_valley"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.wild_armor_trim_smithing_template",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.wild_armor_trim_smithing_template"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "block.minecraft.mossy_cobblestone"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ],
        [
          "item.minecraft.diamond"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.wind_charge",
      "size": 1,
      "ingredients": [
        [
          "item.minecraft.breeze_rod"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.wolf_armor",
      "size": 3,
      "ingredients": [
        [
          "item.minecraft.armadillo_scute"
        ],
        [
          "item.minecraft.armadillo_scute"
        ],
        [
          "item.minecraft.armadillo_scute"
        ],
        [
          "item.minecraft.armadillo_scute"
        ],
        [
          "item.minecraft.armadillo_scute"
        ],
        [
          "item.minecraft.armadillo_scute"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.wooden_axe",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.wooden_hoe",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.wooden_pickaxe",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.wooden_shovel",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.wooden_spear",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "item.minecraft.stick"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.wooden_sword",
      "size": 3,
      "ingredients": [
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "block.minecraft.acacia_planks",
          "block.minecraft.bamboo_planks",
          "block.minecraft.birch_planks",
          "block.minecraft.cherry_planks",
          "block.minecraft.crimson_planks",
          "block.minecraft.dark_oak_planks",
          "block.minecraft.jungle_planks",
          "block.minecraft.mangrove_planks",
          "block.minecraft.oak_planks",
          "block.minecraft.pale_oak_planks",
          "block.minecraft.spruce_planks",
          "block.minecraft.warped_planks"
        ],
        [
          "item.minecraft.stick"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.writable_book",
      "size": 2,
      "ingredients": [
        [
          "item.minecraft.book"
        ],
        [
          "item.minecraft.ink_sac"
        ],
        [
          "item.minecraft.feather"
        ]
      ]
    }
  ],
  [
    {
      "output": "item.minecraft.yellow_dye",
      "size": 1,
      "ingredients": [
        [
          "block.minecraft.dandelion"
        ]
      ]
    },
    {
      "output": "item.minecraft.yellow_dye",
      "size": 1,
      "ingredients": [
        [
          "block.minecraft.golden_dandelion"
        ]
      ]
    },
    {
      "output": "item.minecraft.yellow_dye",
      "size": 1,
      "ingredients": [
        [
          "block.minecraft.sunflower"
        ]
      ]
    },
    {
      "output": "item.minecraft.yellow_dye",
      "size": 1,
      "ingredients": [
        [
          "block.minecraft.wildflowers"
        ]
      ]
    }
  ]
]
export const RecipeGroups = recipe_groups;
